export const tmData = {
  locale: {
    home_instavc_build:
      "நிறுவனங்கள் மற்றும் ஊழியர்களிடையே அர்த்தமுள்ள உறவுகளை உருவாக்குங்கள்.",
    home_instavc_conference_platform:
      "இணையற்ற பயனர் அனுபவத்துடன் மாநாட்டு தளங்கள்",
    home_instavc_start_conference:
      "மாநாட்டைத் தொடங்குங்கள் |மாநாட்டில் சேர|உடனடி மாநாடு",
    home_instavc_Hippa:
      "ஹிப்பா தகுதி மற்றும் பிசிஐ டி.எஸ்.எஸ், எஸ்ஓசி, ஐ.எஸ்.ஓ/இஐசி 27018,மற்றும் ஐஎஸ்ஓ 9001 இணக்கம்.",
    home_instavc_copyrights:
      "© 2018 · instaVC · பீப்பிள்லிங்க் யுனிஃபைட் கம்யூனிகேஷன்ஸ் பிரைவேட் லிமிடெட்.",
    home_instavc_terms_agree: "நான் இதனை ஏற்று கொள்கிறேன்",
    home_instavc_terms: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",

    visibility: "தெரிவுநிலை",
    members: "உறுப்பினர்கள்",
    create_class: "வகுப்பை உருவாக்கவும்",
    public_class: "பொது - வகுப்பு உறுப்பினர்கள் மட்டுமே சேர முடியும்",
    private_class: "தனியார் - உங்கள் நிறுவனத்தில் உள்ள எவரும் சேரலாம்",
    private: "தனியார்",
    filter_by: "இதன்படி வடிகட்டவும்:",
    blocked: "தடுக்கப்பட்டது",
    deleted: "நீக்கப்பட்டது",
    unblock: "தடைநீக்கு",
    make_active: "செயலில் ஆக்கு",
    addNewSubject: "புதிய பாடத்தைச் சேர்க்கவும்",
    editSubject: "தலைப்பைத் திருத்து",
    editQuestionnarie: "கேள்வித்தாளைத் திருத்தவும்",
    editAssignment: "பணியைத் திருத்தவும்",
    addNewClass: "புதிய வகுப்பைச் சேர்க்கவும்",
    assign_teacher: "ஆசிரியரை நியமிக்கவும்",
    exculde_students: "மாணவர்களை விலக்கு",
    dateOfJoining: "சேரும் தேதி",
    classes: "வகுப்புகள்",
    users: "பயனர்கள்",
    classList: "வகுப்புகள் பட்டியல்",
    add_teacher: "ஆசிரியரைச் சேர்க்கவும்",
    add_student: "மாணவர் சேர்க்கவும்",
    mySessions: "எனது அமர்வுகள்",
    reports: "அறிக்கைகள்",

    inclass_admin_teacher: "ஆசிரியர்கள்",
    inclass_admin_student: "மாணவர்கள்",
    inclass_admin_studentName: "மாணவன் பெயர்",
    inclass_admin_studentID: "மாணவர் அடையாளம்",
    inclass_teacher_designation: "பதவி",
    inclass_teacher_department: "துறை",
    inclass_student_rollnumber: "பட்டியல் எண்",
    inclass_teacher_status: "நிலை",
    inclass_admin_user_info: "பயனர் தகவல்",
    inclass_admin_professional_info: "தொழில்முறை தகவல்",
    inclass_student_classname: "வகுப்பின் பெயர்",

    instavc_login: "உள்நுழை",
    instavc_login_email: "மின்னஞ்சல்",
    instavc_login_password: "கடவுச்சொல்",
    instavc_login_button: "உள்நுழை",
    instavc_login_forgotpassword: "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
    instavc_login_have_account: "கணக்கு இல்லையா?",
    instavc_login_signup: "பதிவுபெறுக",
    instavc_signup: "பதிவுபெறுக",
    instavc_signup_firstname: "முதல் பெயர்",
    instavc_signup_lastname: "கடைசி பெயர்",
    instavc_signup_email: "மின்னஞ்சல்",
    instavc_signup_password: "கடவுச்சொல்",
    instavc_signup_cpassword: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
    instavc_signup_button: "பதிவுபெறுக",
    instavc_signup_already_have_account: "ஏற்கனவே ஒரு கணக்கு உள்ளதா?",
    instavc_signup_login: "உள்நுழை",
    instavc_signup_fname_error:
      "முதல் பெயர் எழுத்துக்கள் மட்டுமே இருக்க வேண்டும்",
    instavc_signup_lname_error:
      "கடைசி பெயர் எழுத்துக்கள் மட்டுமே இருக்க வேண்டும்",
    instavc_signup_email_error: "மின்னஞ்சல் சரியான வடிவத்தில் இருக்க வேண்டும்",
    instavc_signup_password_error:
      "கடவுச்சொல் எட்டு எழுத்துக்கள் நீளமாக இருக்க வேண்டும் மற்றும் ஒரு பெரிய எழுத்து, ஒரு சிறிய எழுத்து, ஒரு இலக்க மற்றும் ஒரு சிறப்பு எழுத்து இருக்க வேண்டும்",
    instavc_signup_cpassword_error:
      "கடவுச்சொல் மேலே உள்ள கடவுச்சொல்லுடன் பொருந்த வேண்டும் என்பதை உறுதிப்படுத்தவும்",
    instavc_forgotpassword_link:
      "உங்கள் கணக்குடன் தொடர்புடைய மின்னஞ்சல் ஐடியை உள்ளிடவும். உங்கள் கடவுச்சொல்லை மீட்டமைக்க OTP ஐ உங்களுக்கு அனுப்புவோம்.",
    instavc_forgotpassword_email: "மின்னஞ்சல் முகவரியை உள்ளிடவும்",
    instavc_forgotpassword: "கடவுச்சொல்லை மறந்துவிட்டீர்களா?",
    instavc_forgotpassword_button: "கடவுச்சொல்லை மறந்துவிட்டீர்களா",
    instavc_confirmpass_heading: "மாணவரை உருவாக்குங்கள்",
    instavc_confirmpass_verificationcode: "சரிபார்ப்புக் குறியீட்டை உள்ளிடவும்",
    instavc_confirmpass_newpassword: "புதிய கடவுச்சொல்லை உள்ளிடவும்",
    instavc_confirmpass_retypepassword: "புதிய கடவுச்சொல் மீண்டும் தட்டச்சு",
    instavc_confirmpass_button: "ஆசிரியரை உருவாக்குங்கள்",
    instavc_forgotpassword_signin: "உள்நுழைக",
    instavc_forgotpassword_passwordcreated:
      "வாழ்த்துகள்! உங்கள் புதிய கடவுச்சொல் புதுப்பிக்கப்பட்டது, நீங்கள் இப்போது inClass இல் உள்நுழையலாம்.",
    instavc_dashboard: "முகப்புப்பக்கம்",
    instavc_dashboard_schedule: "அட்டவணை அமர்வு",
    instavc_dashboard_meetinglist: "கடந்த அமர்வுகள்",
    instavc_dashboard_conferenceplatform:
      "இணையற்ற பயனர் அனுபவத்துடன் மாநாட்டு தளங்கள்",
    instavc_dashboard_SC_room: "மாநாட்டைத் தொடங்குங்கள்",
    instavc_dashboard_SC_roomlist:
      "உங்கள் திட்டமிடப்பட்ட அமர்வைத் தேர்ந்தெடுப்பதன் மூலம்",
    instavc_dashboard_startconference: "மாநாட்டைத் தொடங்குங்கள்",
    instavc_dashboard_JC: "மாநாட்டில் சேரவும்",
    instavc_dashboard_JC_ID: "மாநாட்டு அடையாளம் அல்லது திட்டமிடப்பட்ட வழியாக",
    instavc_dashboard_JC_button: "மாநாட்டில் சேரவும்",
    instavc_dashboard_SC: "மாநாட்டைத் தொடங்குங்கள்",
    instavc_dashboard_SC_p2p:
      "உங்கள் பட்டியலிலிருந்து ஒரு அறையைத் தேர்ந்தெடுப்பதன் மூலம்",
    instavc_dashboard_instaconference: "உடனடி மாநாடு",
    instavc_dashboard_buynow: "இப்போது வாங்கவும்",
    instavc_dashboard_myprofile: "என் சுயவிவரம்",
    instavc_dashboard_settings: "அமைப்புகள்",
    instavc_dashboard_myadmin: "எனது நிர்வாகம்",
    instavc_dashboard_affiliate: "எனது இணைப்பு",
    instavc_dashboard_logout: "வெளியேறு",
    conference_myrooms: "எனது அறைகள்",
    conference_myrooms_host: "ஆசிரியர் ஐடி",
    conference_myrooms_roomhost: "இந்த அறைக்கு நீங்கள் ஒரு தொகுப்பாளர்.",
    conference_myrooms_search: "தேடல் ...",
    conference_myrooms_hostuser: "தொகுப்பாளர் பயனர்",
    conference_myrooms_gotopremium: "பிரீமியத்திற்குச் செல்லவும்",
    conference_myrooms_buynow: "இப்போது வாங்க",
    conference_myrooms_renewal: "புதுப்பித்தல்",
    conference_setup: "அமைவு",
    conference_myrooms_renewnow: "இப்போது புதுப்பிக்கவும்",
    // "conference_myrooms_hosts": "தொகுப்பாளர்",
    conference_myrooms_join: "சேர",
    conference_myrooms_setup: "அறை அமைப்பு",
    conference_myrooms_sethost_email:
      "உங்களை ஒரு தொகுப்பாளராக அமைக்கவும் அல்லது ஒரு பயனரின் மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
    conference_myrooms_selfhost: "உங்களை ஒரு தொகுப்பாளராக அமைக்கவும்",
    conference_myrooms_otherhost:
      "நீங்கள் எந்தவொரு பயனரையும் தொகுப்பாளராக மாற்ற விரும்பினால், அவரது / அவள் மின்னஞ்சல் முகவரியை உள்ளிடவும்",
    conference_myrooms_email: "மின்னஞ்சல் முகவரி",
    Cancel: "ரத்துசெய்",
    conference_myrooms_apply: "விண்ணப்பிக்கவும்",
    view_schedule_myrooms: "எனது அறைகள்",
    view_schedule_search: "தேடல்...",
    view_schedule_schedule: "அட்டவணை",
    view_schedule_calender:
      "இந்த அறையின் அட்டவணைகளை சரிபார்க்க நாட்காட்டி கீழே உள்ளது",
    video_recordings: "காணொலி பதிவுகள்",
    view_recordings_search: "தேடல்",
    view_recordings_month: "இந்த மாதம்",
    view_recordings_week: "கடைசி 7 நாட்கள்",
    view_recordings_today: "இன்று",
    no_recordings: "இன்னும் பதிவுகள் இல்லை!",
    no_recordings_message: "இப்போது இங்கே காணொளிகள் எதுவும் இல்லை.",
    no_recordings_startmessage:
      "நீங்கள் பதிவு செய்யத் தொடங்கியதும் உங்கள் எல்லா காணொலிகளையும் இங்கே பார்க்கலாம்.",
    stop_recording: "இந்த பதிவை நிறுத்த விரும்புகிறீர்களா?",
    stop_recording_agree: "ஒப்புக்கொள்கிறேன்",
    stop_recording_disagree: "கருத்து வேறுபாடு",
    conference_in_use: "மாநாடு பயன்பாட்டில் உள்ளது",
    conference_mode: "மாநாட்டு முறை",
    large_conference_mode: "பெரிய மாநாட்டு பயன்முறை",
    conference_setup_configuration: "கட்டமைப்பு",
    conference_setup_generateid:
      "அமர்வு ஐடி எதுவும் கிடைக்கவில்லை, ஒன்றை உருவாக்கு!",
    conference_setup_regenerate: "மீண்டும் உருவாக்கவும்",
    conference_setup_meetingid: "அமர்வு ஐடி",
    conference_setup_camera: "முகநேரம் எச்டி கேமரா",
    conference_setup_defaultmicrophone:
      "இயல்புநிலை - உள் ஒலிவாங்கி (உள்ளமைக்கப்பட்ட)",
    conference_setup_microphone: "உள் ஒலிவாங்கி (உள்ளமைக்கப்பட்ட)",
    conference_setup_volume: "தொகுதி",
    conference_setup_videomode: "காணொலி பயன்முறை",
    conference_setup_forward: "முன்னோக்கி",
    conference_setup_mix: "கலவை",
    conference_setup_invite: "அழைக்கவும்",
    conference_setup_invitepeople: "மக்களை அழைக்கவும்",
    conference_setup_invitefriends:
      "ஒத்துழைக்க உங்கள் நண்பர்களையும் சக ஊழியர்களையும் அழைக்கவும்.",
    conference_setup_invite_directlink: "உங்கள் அறைக்கு நேரடி இணைப்பு",
    conference_setup_invite_sharelink:
      "உங்கள் பங்கேற்பாளர்கள் உங்கள் அமர்வில் சேர இந்த இணைப்பை பகிர்ந்து கொள்ளுங்கள்",
    conference_setup_invite_link:
      "https://connect.instavc.com/conference-guest/eddca0fc7adcdc61a24dabe02597412a36bb96dac7302f3cedb6aac50169d58614eb46b940b556a9/f",
    conference_setup_invitebyemail: "அஞ்சல் மூலம் அழைக்கவும்",
    conference_setup_invite_enteremail:
      "உங்கள் பங்கேற்பாளர்களை அழைக்க விருப்பமான மின்னஞ்சல் முகவரியை உள்ளிடவும்",
    conference_setup_invite_emailid: "மின்னஞ்சல் முகவரி",
    conference_setup_invite_close: "மூடு",
    conference_setup_invite_button: "அழைக்கவும்",
    conference_setup_advancesettings: "முன்கூட்டியே அமைப்புகள்",
    conference_setup_changeresolution: "பிரித்திரனைத் தேர்வுசெய்க",
    conference_setup_lowbandwidth: "குறைந்த அலைவரிசை",
    conference_setup_poornetwork: "மோசமான பிணையம்",
    conference_setup_vga: "விஜிஏ - (640x480)",
    conference_setup_vga_graphics:
      "காணொலி வரைகலை வரிசை (விஜிஏ) காணொலி பிரித்திரனுக்கு",
    conference_setup_hd1080: "எச்டி1080p - (1920x1080)",
    conference_setup_fhd:
      "முழு உயர் வரையறை (எஃப்எச்டி) காணொலி பிரித்திரனுக்கு",
    conference_setup_4k: "4 கே - (3840 x 2160)",
    conference_setup_4k_fhd:
      "முழு உயர் வரையறை (எஃப்எச்டி) காணொலி பிரித்திரனுக்கு",
    conference_setup_sif: " SIF - (320x240)",
    conference_setup_sif_vr: "SIF காணொலி பிரித்திரனுக்கு",
    conference_setup_hd720: "எச்டி720p - (1280x720)",
    conference_setup_hd720_vr: "உயர் வரையறை (எச்டி) காணொலி பிரித்திரனுக்கு",
    conference_setup_2k: "2 கே - (2048×1080)",
    conference_setup_2k_fhd:
      "முழு உயர் வரையறை (எஃப்எச்டி) காணொலி பிரித்திரனுக்கு",
    conference_setup_broadcastoptions: "ஒளிபரப்பு விருப்பங்கள்",
    conference_setup_enable: "இயக்கு",
    conference_setup_disable: "முடக்கு",
    conference_setup_reportquality:
      "குரல் மற்றும் காணொலி அழைப்புகளை மேம்படுத்த உதவும் தரமான புள்ளிவிவரங்களைப் புகாரளிக்கவும்",
    conference_setup_havetroubleshoot:
      "நீங்கள் ஒரு மாநாடு சரிசெய்தல் செய்ய விரும்புகிறீர்களா, பின்னர் இங்கே இணைப்பைச் சொடுக்கவும்",
    conference_setup_conferencetroubleshoot: "மாநாட்டு சரிசெய்தல்",
    conference_troubleshoot: "சரிசெய்தல்",
    conference_troubleshoot_faq: "அடிக்கடி கேட்கப்படும் கேள்விகள்",
    conference_troubleshoot_emailreport: "மின்னஞ்சல் அறிக்கை",
    conference_troubleshoot_gotoconference: "மாநாட்டிற்குச் செல்லுங்கள்",
    conference_troubleshoot_os: "இயங்குதளம்",
    conference_troubleshoot_version: "பதிப்பு",
    conference_troubleshoot_browser: "உலாவி",
    conference_troubleshoot_chromeversion: "குரோம் பதிப்பு",
    conference_troubleshoot_privatebrowsing: "தனியார் உலாவல்",
    conference_troubleshoot_displayresolution: "பிரித்திரன்களைக் காண்பி",
    conference_troubleshoot_aspectratio: "விகிதம் காண்பி",
    conference_troubleshoot_hasspeakers: "கணினியில் ஒலிபெருக்கி உள்ளதா?",
    conference_troubleshoot_foundspeaker: "ஒலிபெருக்கி சாதனங்கள் கிடைத்தன",
    conference_troubleshoot_hasmicrophone: "கணினியில் ஒலிவாங்கி உள்ளதா?",
    conference_troubleshoot_foundmicrophone: "ஒலிவாங்கி சாதனங்கள் கிடைத்தன",
    conference_troubleshoot_haswebcam: "கணினியில் வலைநிழம்பி உள்ளதா?",
    conference_troubleshoot_foundcameras: "புகைப்படக்கருவி சாதனங்கள் கிடைத்தன",
    conference_troubleshoot_webcampermission:
      "வலைத்தளத்திற்கு வலைநிழம்பி அனுமதிகள் உள்ளதா?",
    conference_troubleshoot_microphonepermission:
      "வலைத்தளத்திற்கு ஒலிவாங்கி அனுமதிகள் உள்ளதா?",
    conference_troubleshoot_getUsermedia:
      "இந்த பக்கத்தில் getUserMedia ஐ உலாவி அனுமதிக்கிறதா?",
    conference_troubleshoot_changeoutput_audiodevice:
      "வெளியீட்டு கேட்பொலி சாதனங்களை மாற்ற முடியுமா? ",
    conference_troubleshoot_changecamera_resolution:
      "புதிய மாநாட்டு கோரிக்கையை செய்யாமல் புகைப்பட கருவி தீர்மானங்களை மாற்ற முடியுமா?",
    conference_troubleshoot_supportwebrtc:
      "உலாவி WebRTC ஐ ஆதரிக்கிறது(ஒன்று 1.0 அல்லது 1.1)?",
    conference_troubleshoot_supportortc:
      "உலாவி ORTC யை ஆதரிக்கிறது(WebRTC 1.1)?",
    conference_troubleshoot_turnserver: "TURN சேவையகத்தை அணுக முடியுமா?",
    conference_troubleshoot_turn: "turn:139.59.64.172:443",
    conference_troubleshoo_coturn: "turn: coturn.instavc.com: 443",
    conference_troubleshoot_replacetracks:
      "சகாக்களுடன் மீண்டும் பேச்சுவார்த்தை நடத்தாமல் தடங்களை மாற்ற முடியுமா?",
    conference_troubleshoot_record_remoteaudio:
      "உங்கள் உலாவி தொலைநிலை கேட்பொலியை பதிவுசெய்ய முடியுமா அல்லது வலை கேட்பொலி API இல் தொலை கேட்பொலி தாரையை செயல்முறையாக்க முடியுமா?",
    conference_troubleshoot_browsersupports_websocketapi:
      "உலாவிகள் வெப்சாக்கெட்ஸ் APIயை ஆதரிக்கின்றன",
    conference_troubleshoot_blockwebsocket:
      "உங்கள் கணினி வெப்சாக்கெட் நெறிமுறையைத் தடுத்தது, அல்லது வெப்சாக்கெட் சேவையகத்தை அணுக முடியாதா? இல்லை",
    conference_troubleshoot_supportwebaudioapi:
      "உலாவி வலை கேட்பொலி APIயை ஆதரிக்கிறதா?",
    conference_troubleshoot_supportsctp:
      "உலாவி SCTP தரவு அலைவரிசைகளை ஆதரிக்கிறதா?",
    conference_troubleshoot_supportsrtp:
      "உலாவி RTP தரவு அலைவரிசைகளை ஆதரிக்கிறதா?",
    conference_troubleshoot_support_screencapturing:
      "இந்த பக்கம் திரை பிடிப்பு APIயை ஆதரிக்கிறதா?",
    conference_troubleshoot_support_multimonitor:
      "உலாவி பல திரையகம் தேர்வை ஆதரிக்கிறதா மற்றும் எந்த திரையகத்தின் திரையையும் கைப்பற்றுமா?",
    conference_troubleshoot_mobiledevice: "இது கைபேசி சாதனமா?",
    conference_troubleshoot_supportscreencap_canvas:
      "கித்தானிலிருந்து திரை பிடிப்பதை உலாவி ஆதரிக்கிறதா?",
    conference_troubleshoot_supportscreencap_video:
      "காணொலியிருந்து திரை பிடிப்பதை உலாவி ஆதரிக்கிறதா?",
    conference_troubleshoot_supportpromisses:
      "உலாவி வாக்குறுதிகளை ஆதரிக்கிறதா?",
    conference_troubleshoot_ipaddress: "ஐபி முகவரிகளைக் காட்ட சொடுக்கவும்",
    conference_troubleshoot_stunserver: "STUN சேவையகத்தை அடைய முடியுமா?",
    cancel: "ரத்துசெய்",
    instavc_conference_revoke_fromhost: "தொகுப்பாளலிருந்து திரும்பப்பெறுங்கள்",
    instavc_conference_startvideoconf_button: "காணொலி மாநாட்டைத் தொடங்குங்கள்",
    instavc_conference_loading:
      "உங்கள் திரையை ஏற்றுகிறது தயவுசெய்து காத்திருங்கள்",
    instavc_conference_authenticating:
      "Instavc சேவையகத்தில் அங்கீகரிக்கிறது ....",
    instavc_conference_joinconference: "மாநாட்டில் இணைகிறது",
    instavc_conference_publishyourvideo: "உங்கள் காணொலியை வெளியிடுகிறது",
    instavc_conference_publishyouraudio: "உங்கள் கேட்பொலியை வெளியிடுகிறது",
    instavc_conference_settings: "அமைப்புகள்",
    instavc_conference_setting: "மாநாட்டு அமைப்புகள்",
    instavc_conference_setting_source: "மூலாதாரம்",
    instavc_conference_setting_camera: "புகைப்படக்கருவி",
    instavc_conference_audioinputs: "கேட்பொலி உள்ளீடுகள்",
    instavc_conference_setting_apply: "விண்ணப்பிக்கவும்",
    instavc_conference_setting_resolution: "பிரித்திறண்",
    instavc_conference_setting_qr: "QR (பீட்டா)",
    instavc_conference_whiteboard: "வெண்பலகை",
    instavc_conference_screenshare: "திரை பகிர்",
    instavc_conference_presenter: "வழங்குபவர்",
    instavc_conference_stopshare: "பகிர்வை நிறுத்து",
    instavc_conf_install_Screenshare: "திரை பகிர்வை நிறுவவும்",
    instavc_conference_videosync: "ஒன்றாகப் பாருங்கள்",
    instavc_conference_videourl: "காணொலி உரலி",
    instavc_conference_enter_videourl: "காணொலி உரலியை உள்ளிடவும்",
    instavc_conference_videourl_note:
      "குறிப்பு: செயலில் பங்கேற்பாளர்கள் மட்டுமே இந்த காணொளியைப் பார்க்க முடியும், தாமதமாக இணைந்தவர்கள் காணொலியைப் பார்க்க முடியாது",
    instavc_conf_recordings: "பதிவு",
    instavc_conference_sharecontent: "உங்கள் திரையைப் பகிரவும்",
    instavc_conference_sharecontent_screen:
      "connect.instavc.com உங்கள் திரையின் உள்ளடக்கங்களைப் பகிர விரும்புகிறது. நீங்கள் பகிர விரும்புவதைத் தேர்வுசெய்க",
    instavc_conference_shareentire_screen: "உங்கள் முழு திரை",
    instavc_conference_sharescreen_applicationwindow: "பயன்பாட்டு சாளரம்",
    instavc_conference_sharescreen_chrometab: "குரோம் தாவல்",
    instavc_conference_sharescreen_share: "பகிர்",
    instavc_conf_sharescreen: "உங்கள் திரையைப் பகிர்கிறீர்கள்!",
    instavc_conf_share_otherparticipants:
      "பிற பங்கேற்பாளர்கள் உங்கள் திரையில் பயன்பாடுகள் மற்றும் ஆவணங்களைக் காணலாம்",
    instavc_stopsharing: "பகிர்வதை நிறுத்துங்கள்",
    instavc_conference_chat: "அரட்டை",
    instavc_conference_additional_camera: "கூடுதல் புகைப்படக்கருவி",
    instavc_conference_sharescreen_groupchat: "குழு அரட்டை",
    instavc_conference_sharescreen_GC: "ஜி.சி.",
    instavc_conference_entermessage: "ஏதாவது கூறுங்கள்!",
    instavc_conference_adddevice: "சாதனங்களைச் சேர்க்கவும்",
    instavc_conference_adddevice_addcamera: "புகைப்படக்கருவியைச் சேர்க்கவும்",
    instavc_conference_adddevice_source: "மூலாதாரம்",
    instavc_conference_adddevice_camera: "புகைப்படக்கருவி",
    instavc_conference_adddevice_cameraname:
      "முகநேரம் எச்டி கண்காணிப்புக்கருவி",
    instavc_conference_adddevice_close: "மூடு",
    instavc_conference_adddevice_publish: "வெளியிடு",
    instavc_conference_info: "தகவல்",
    questions: "கேள்விகள்",
    instavc_conference_askquestions: "கேள்விகள் கேட்க",
    instavc_conference_info_meetingid: "தனிப்பட்ட அமர்வு ஐடி",
    instavc_conference_fullscreen: "முழு திரை",
    conference_setup_invitepeoplel: "மக்களை அழைக்கவும்",
    conference_setup_invite_linktojoin:
      "https://connect.instavc.com/conference-guest/93ac2135d88727ca29061b4b6bf9477bc8f285a8121ff580649512abad353fbc6751a134d56438f7/f",
    conference_setup_invite_byemail: "அஞ்சல் மூலம் அழைக்கவும்",
    instavc_conference_participants: "பங்கேற்பாளர்கள்",
    instavc_conference_participants_search: "தேடு ...",
    instavc_conference_participant: "பங்கேற்பாளர்",
    instavc_conference_participants_muteall: "அனைத்தையும் முடக்கு",
    instavc_conference_participants_unmuteall: "அனைத்தையும் முடக்கு",
    instavc_conference: "மாநாடு",
    instavc_conf_more: "மேலும்",
    instavc_conference_picturemode:
      "இந்த காணொலி படம்-இன்-படம் பயன்முறையில் இயங்குகிறது",
    instavc_conference_mediastreams_stats: "ஊடகத் தாரை புள்ளிவிவரங்கள்",
    instavc_conference_mediastreams_audio: "கேட்பொலி",
    instavc_conference_mediastreams_audio_send: "அனுப்புக",
    instavc_conference_mediastreams_audio_codec: "புரிப்பு",
    instavc_conference_mediastreams_audio_rates: "விகிதங்கள் (Kbps)",
    instavc_conference_mediastreams_audio_lost: "இழந்தது",
    instavc_conference_mediastreams_audio_fraction: "பின்னம்",
    instavc_conference_mediastreams_video: "காணொலி",
    instavc_conference_mediastreams_video_send: "அனுப்புக",
    instavc_conference_mediastreams_video_codec: "புரிப்பு",
    instavc_conference_mediastreams_video_rates: "விகிதங்கள் (Kbps)",
    instavc_conference_mediastreams_video_lost: "இழந்தது",
    instavc_conference_mediastreams_video_fraction: "பின்னம்",
    instavc_conference_resolution: "பிரித்திறண்",
    instavc_conference_framerate: "சட்டகம் வீதம்",
    instavc_conference_nack: "Nack",
    instavc_conference_pli: "பி.எல்.ஐ.",
    instavc_conference_bw: "கிடைக்கும் அலைக்கற்றை",
    instavc_conference_audiomuted: "கேட்பொலி முடக்கப்பட்டது",
    instavc_conference_microphonemuted: "உங்கள் ஒலிவாங்கி முடக்கப்பட்டது",
    join_conference_join_meetinginvitation: "அமர்வு அழைப்பிதழ்களில் சேரவும்",
    join_conference_search: "தேடு …",
    "join_conference_meeting details":
      "சந்திப்பு பெயர்  n அழைக்கப்பட்டது:\n அழைப்பாளர் பெயர்",
    join_conference_join: "சேர",
    join_conference_nomeetings: "அமர்வுகள் இல்லை",
    join_conference_noupcomingmeetings:
      "அச்சச்சோ! உங்களிடம் இன்னும் வரவிருக்கும் அமர்வுகள் எதுவும் இல்லை!",
    insta_conference_mycontacts: "எனது தொடர்புகள்",
    insta_conference_search: "தேடு …",
    insta_conference_typemessage: "செய்தியைத் தட்டச்சு செய்க",
    insta_conference_addcontact: "தொடர்பைச் சேர்க்கவும்",
    insta_conference_enteremail: "மின்னஞ்சல் அடையாளம் உள்ளிடவும்",
    insta_conference_add: "சேர்",
    insta_conference_nouserfound:
      "இந்த மின்னஞ்சல் முகவரியுடன் அத்தகைய பயனர் இல்லை",
    instavc_conf_callnot_allowed:
      "நீங்கள் ஏற்கனவே அழைப்பில் இருக்கும்போது மற்ற பயனர்களை அழைக்க முடியாது",
    insta_conference_pendingapproval: "நிலுவையிலுள்ள ஒப்புதல்",
    insta_conference_outgoingvideocall: "வெளிச்செல்லும் காணொலி அழைப்பு",
    insta_conference_calling: "அழைக்கிறது ....",
    insta_conference_incomingvideocall: "உள்வரும் காணொலி அழைப்பு",
    insta_conference_calldecline: "சரிவு",
    insta_conference_callaccept: "ஏற்றுக்கொள்",
    insta_conference_instavcalert:
      "connect.instavc.com அனுமதிக்க விரும்புகிறது",
    insta_conference_usemicrophone: "உங்கள்  ஒலிவாங்கிப் பயன்படுத்தவும்",
    insta_conference_usecamera: "உங்கள் புகைப்படக்கருவியைப் பயன்படுத்தவும்",
    insta_conference_blockdevices: "தடு",
    insta_conference_allowdevices: "அனுமதி",
    instavc_schedulemeeting_createmeeting:
      "புதிய அமர்வை உருவாக்கவும் / திருத்தவும்",
    instavc_schedulewebinar_createmeeting:
      "புதிய வலைக்கருத்தரங்கு உருவாக்கு / திருத்து",
    instavc_schedulemeeting_meetingname:
      "உங்கள் அமர்வுக்கு ஒரு பெயரைக் கொடுங்கள்",
    instavc_schedulemeeting_selectnames_tomeeting:
      "உங்கள் அமர்வுக்கு ஒரு அறையைத் தேர்ந்தெடுக்கவும்",
    instavc_schedulemeeting_setduration: "கால அளவை அமைக்கவும்",
    instavc_schedulemeeting_15min: "15 நிமிடங்கள்",
    instavc_schedulemeeting_30min: "30 நிமிடங்கள்",
    instavc_schedulemeeting_60min: "60 நிமிடங்கள்",
    instavc_schedulemeeting_setcustom: "தனிப்பயன் அமைக்கவும்",
    instavc_schedulemeeting_customduration: "தனிப்பயன் காலம்",
    instavc_schedulemeeting_minutes: "நிமிடங்கள்",
    instavc_schedulemeeting_setconfpassword:
      "உங்கள் மாநாட்டு கடவுச்சொல்லை அமைக்கவும்",
    instavc_schedulemeeting_typepassword:
      "உங்கள் அமர்வுக்கான கடவுச்சொல்லை உள்ளிடவும்",
    instavc_schedulemeeting_conferencecolor:
      "உங்கள் மாநாட்டு ஐகானுக்கு வண்ணம் கொடுங்கள்",
    instavc_schedulemeeting_invitepeople: "இந்த அமர்வுக்கு மக்களை அழைக்கவும்",
    instavc_schedulemeeting_search: "தேடு ...",
    instavc_schedulemeeting_SM: "எஸ்.எம்",
    instvc_SM_message:
      "அங்கீகரிக்கப்பட்ட பயனர் உரிமம் உள்ள பயனர்களின் எண்ணிக்கை உரிம வரம்பை மீறிவிட்டது. நீங்கள் அதிகமானவர்களை அழைக்க விரும்பினால் உங்களால் முடியும்",
    instavc_SM_message_href: "பிரீமியத்திற்குச் செல்லவும்",
    instavc_schedulemeeting_notify:
      "இந்த அமர்வைப் பற்றி தேர்ந்தெடுக்கப்பட்டவர்களுக்கு தெரிவிக்கவும்",
    instavc_schedulemeeting_addreminder: "நினைவூட்டல்களைச் சேர்",
    instavc_schedulemeeting_add: "சேர்",
    instavc_schedulemeeting_addmeetingreminder:
      "அமர்வு நினைவூட்டலைச் சேர்க்கவும்",
    instavc_schedulemeeting_adddatetime: "தேதி எடுப்பவர், நேரம் எடுப்பவர்",
    instavc_schedulemeeting_apply: "விண்ணப்பிக்கவும்",
    instavc_schedulemeeting_name: "அமர்வு பெயரை உள்ளிடவும்",
    instavc_schedulemeeting_selectroom: "தயவுசெய்து அறையைத் தேர்ந்தெடுக்கவும்",
    instavc_schedulemeeting_selectduration:
      "தயவுசெய்து காலத்தைத் தேர்ந்தெடுக்கவும்",
    instavc_recuring_schedule: "தொடர்ச்சியான அட்டவணை",
    instavc_schedulemeeting_nothinginreminders:
      "நினைவூட்டல்களில் எதுவும் இல்லை",
    instavc_schedulemeeting_createbutton: "உருவாக்கு",
    instavc_schedulemeeting_createdsuccessfully:
      "உருவாக்கப்பட்டது அட்டவணை வெற்றிகரமாக",
    instavc_meetinglist_calender: "நாட்காட்டி",
    instavc_meetinglist_selecteddates: "நீங்கள் தேர்ந்தெடுத்த தேதிகள் ",
    instavc_meetinglist_schedulecreted: "அட்டவணைகள் உருவாக்கப்பட்டன",
    instavc_meetinglist_pastschedule: "கடந்த அட்டவணை",
    instavc_meetinglist: "அமர்வுகள் பட்டியல்",
    instavc_meetinglist_meetingdetils: "அமர்வு பெயர், அமர்வு நேரம், ஏற்பாடு",
    instavc_meetinglist_search: "தேடு ...",
    instavc_meetinglist_deleterecuring: "தொடர்ச்சியான அட்டவணையை நீக்கு",
    instavc_meetinglist_alow_deleterecuring:
      "தற்போதைய அட்டவணையை அல்லது மீண்டும் நிகழும் அனைத்து அட்டவணைகளையும் நீக்க விரும்புகிறீர்களா?",
    instavc_meetinglist_schedule_series:
      "தொடரின் மற்ற எல்லா அட்டவணைகளும் இருக்கும்:",
    instavc_meetinglist_schedule_seriesdelete:
      "தொடரின் அனைத்து அட்டவணைகளும் நீக்கப்படும்:",
    instavc_meetinglist_allrecuringsch: "அனைத்து தொடர்ச்சியான அட்டவணைகளும்",
    instavc_meetinglist_cancelchanges: "மாற்றங்களை ரத்துசெய்",
    instavc_meetinglist_noschedules: "அட்டவணைகள் இல்லை",
    instavc_ml_schedulemessage:
      "அமர்வு அட்டவணை இன்னும் உருவாக்கப்படவில்லை! கீழே உள்ள பொத்தானைக் கிளிக் செய்வதன் மூலம் உங்கள் அட்டவணையை உருவாக்கவும்.",
    instavc_create_schedule: "அட்டவணையை உருவாக்கு",
    instavc_meetinglist_currentschedule: "தற்போதைய அட்டவணை",
    instavc_meetinglist_join: "சேர்",
    instavc_meetinglist_buynow: "இப்போது வாங்க",
    instavc_dashboard_chooseplan: "ஒரு திட்டத்தைத் தேர்வுசெய்க",
    instavc_package_smbplan: "SMB திட்டங்கள்",
    instavc_package_smbplan_host: "(தொகுப்பாளர் அடிப்படையிலான உரிமம்)",
    instavc_package_smbplandescription:
      "ஒரு அறையில் ஒரே நேரத்தில் 1 தொகுப்பாளர் மட்டுமே இருக்க முடியும். வாங்குபவர் தொகுப்பாளர் கணக்கை அமைக்கலாம் அல்லது மாற்றலாம், யார் அறையை கட்டுப்படுத்த முடியும். அழைப்பின் போது தொகுப்பாளர் அணுகல்களைப் பகிர முடியாது.தொகுப்பாளர் மாநாட்டில் சேரும் வரை மற்ற எல்லா பயனர்களும் தொடர்பு கொள்ள முடியாது . ",
    instavc_package_basic: "அடிப்படை",
    instavc_package_hostuser_smb: "1 தொகுப்பாளர் மற்றும்",
    instavc_package_hostuser_smb_users: "பயனர்கள்",
    instavc_package_currency: "$",
    instavc_package_permonth: "/ மாதம்",
    instavc_package_bill_smb: "ஆண்டுதோறும் வசூலிக்கப்படும்",
    instavc_package_include_smb: "இந்த தொகுப்பு இதில் அடங்கும்",
    instavc_package_specifictions_Whiteboard: "வெண்பலகை",
    instavc_package_specifictions_Screen: "திரை பகிர்",
    instavc_package_specifictions_nChat: "அரட்டை",
    instavc_package_specifictions_Recording: "பதிவு",
    instavc_package_specifictions_PresenterMode: "வழங்குபவர் பயன்முறை",
    instavc_package_buynowbutton: "இப்போது வாங்க",
    instavc_package_fullfeatures_smb: "முழு அம்சங்கள்",
    instavc_package_billinginfo: "ரசிது தகவல்கள்",
    instavc_package_billinginfo_name: "பெயர்",
    instavc_package_billinginfo_orginazation: "நிறுவனம்",
    instavc_package_biilinginfo_gstin: "GSTIN",
    Save: "சேமி",
    instavc_package_billinginfo_edit: "தொகு",
    instavc_package_billingdetails: "ரசிது  விவரங்கள்",
    instavc_package_billingdetails_firstname: "முதல் பெயர்",
    instavc_package_billingdetails_lastname: "கடைசி பெயர்",
    instavc_package_billingdetails_address: "முகவரி",
    instavc_package_billingdetails_zip: "தபால் இலக்கம்",
    instavc_package_shippinginfo: "போக்குவரவு-தகவல்",
    instavc_package_shippinginfo_edit: "தொகு",
    instavc_package_shippingdetails: "போக்குவரவு-விவரங்கள்",
    instavc_package_shippingdetails_firstname: "முதல் பெயர்",
    instavc_package_shippingdetails_lastname: "கடைசி பெயர்",
    instavc_package_shippingdetails_address: "முகவரி",
    instavc_package_shippingdetails_zip: "தபால் இலக்கம்",
    instavc_package_cartsummary: "வண்டி சுருக்கம்",
    instavc_package_hostbase:
      "தொகுப்பாளர் அடிப்படையிலான உரிமம் (உரிமத்தின் பெயர்)",
    instavc_package_smbplan_basic: "SMB திட்டம் - அடிப்படை",
    instavc_package_plandetails:
      "$ 144.02  n  n 1 வருடத்திற்கு \n $ 13 மாதத்திற்கு கட்டணம்",
    instavc_package_term: "கால",
    instavc_package_1year: "1 வருடம்",
    instavc_package_2years: "2 வருடம்",
    instavc_package_3years: "3 வருடம்",
    instavc_package_4years: "4 வருடம்",
    instavc_package_5years: "5 வருடம்",
    instavc_package_subtotal: "கூட்டுத்தொகை",
    instavc_package_taxes: "வரி மற்றும் கட்டணம் (ஜிஎஸ்டி 18%)",
    instavc_package_launchoffer: "துவக்க சலுகை",
    instavc_package_promo: "விளம்பர வெற்றிகரமாக பயன்படுத்தப்பட்டது",
    instavc_package_remove: "அகற்று",
    instavc_package_havepromocode:
      "விளம்பர குறியீடு உள்ளதா ? இங்கே விண்ணப்பிக்கவும்",
    instavc_package_entercouponcode:
      "தயவுசெய்து செல்லுபடியாகும் படிவ குறியீட்டை உள்ளிடவும்",
    instavc_package_total: "மொத்தம்",
    instavc_package_offerdisclaimer: "சலுகை மறுப்பு காண்க",
    instavc_package_paynow: "இப்போது செலுத்த",
    instavc_package_payment_instavclicense:
      "பீப்பிள்லிங்க் யுனிஃபைட் கம்யூனிகேஷன்\nInstaVC உரிமத்திற்கான கட்டணம்",
    instavc_package_phone: "தொலைபேசி",
    instavc_package_entervalid_contactnumber:
      "தயவுசெய்து சரியான தொடர்பு எண்ணை உள்ளிடவும்",
    instavc_package_email: "மின்னஞ்சல்",
    instavc_package_enteremail:
      "செல்லுபடியாகும் மின்னஞ்சல் முகவரியை உள்ளிடவும். எடுத்துக்காட்டு: you@example.com",
    instavc_package_paybycard: "அட்டை மூலம் செலுத்துங்கள்",
    instavc_package_securedbyrazorpay: "ரேஸர்பேயால் பாதுகாக்கப்பட்டது",
    instavc_package_card: "அட்டை",
    instavc_package_enterotp:
      "சேமித்த அட்டைகளை அணுக xxxxxxxxx இல் அனுப்பப்பட்ட ஒரு முறை கடவுச்சொல்லை உள்ளிடவும்",
    instavc_package_resendotp: "ஒரு முறை கடவுச்சொல்லை மீண்டும் அனுப்பவும்",
    instavc_package_skipsavedcards: "சேமித்த அட்டைகளைத் தவிர்",
    instavc_package_enter_otp: "தயவுசெய்து ஒரு முறை கடவுச்சொல்லை உள்ளிடவும்",
    instavc_package_skipthesavedcards: "சேமித்த அட்டைகளைத் தவிர்க்கவும்",
    instavc_package_cardnumber: "அட்டை எண்",
    instavc_package_entervalid_cardnumber:
      "தயவுசெய்து செல்லுபடியாகும் அட்டை எண்ணை உள்ளிடவும்",
    instavc_package_expiry: "காலாவதி",
    instavc_package_cardholdername: "அட்டை வைத்திருப்பவர்களின் பெயர்",
    instavc_package_cvv: "சி.வி.வி.",
    instavc_package_3digitcode:
      "இது உங்கள் அட்டையின் பின்புறத்தில் அச்சிடப்பட்ட 3 இலக்க குறியீடு",
    instavc_package_pay: "செலுத்தவும்",
    instavc_package_remembercard: "அட்டையை நினைவில் கொள்க",
    instavc_package_medium: "நடுத்தரம்",
    instavc_package_hostuser_medium: "1 தொகுப்பாளர் மற்றும் 50 பயனர்கள்",
    instavc_package_month_medium: "$ 15 / மாதம்",
    instavc_package_bill_medium:
      "ஆண்டுக்கு சரக்கு மற்றும் சேவை வரி 18% கட்டணம்",
    instavc_package_include_medium: "இந்த தொகுப்பு இதில் அடங்கும்",
    instavc_package_specifictions_medium:
      "வெண்பலகை\n திரை பகிர்  n அரட்டை  n பதிவுசெய்தல்  n வழங்குநர் பயன்முறை",
    instavc_package_buynow_medium: "இப்போது வாங்கவும்",
    instavc_package_fullfeatures_medium: "முழு அம்சங்கள்",
    instavc_package_advanced: "மேம்படுத்தபட்ட",
    instavc_package_hostuser_advanced: "1 தொகுப்பாளர் மற்றும் 100 பயனர்கள்",
    instavc_package_month_advanced: "$ 16 / மாதம்",
    instavc_package_bill_advanced:
      "ஆண்டுக்கு சரக்கு மற்றும் சேவை வரி 18% கட்டணம்",
    instavc_package_include_advanced: "இந்த தொகுப்பு இதில் அடங்கும்",
    instavc_package_specifictions_advanced:
      "வெண்பலகை\n திரை பகிர்  n அரட்டை  n பதிவுசெய்தல்  n வழங்குநர் பயன்முறை",
    instavc_package_buynow_advanced: "இப்போது வாங்கவும்",
    instavc_package_fullfeatures_advanced: "முழு அம்சங்கள்",
    instavc_package_virtualmcu: "மெய்நிகர் MCU உரிமம்",
    instavc_package_virtualmcu_room: "(அறை அடிப்படையிலான உரிமம்)",
    instavc_package_vmcudetails:
      "ஒரு அறையில் ஒரே நேரத்தில் 1 தொகுப்பாளர் மட்டுமே இருக்க முடியும். வாங்குபவர் தொகுப்பாளர் கணக்கை அமைக்கலாம் அல்லது மாற்றலாம், யார் அறையை கட்டுப்படுத்த முடியும். அழைப்பின் போது தொகுப்பாளர் அணுகல்களைப் பகிர முடியாது.தொகுப்பாளர் மாநாட்டில் சேரும் வரை மற்ற எல்லா பயனர்களும் தொடர்பு கொள்ள முடியாது . ",
    instavc_package_instavc: "InstaVC",
    instavc_package_silver: "வெள்ளி",
    instavc_package_userrooms_silver_users: "பயனர்கள்",
    instavc_package_userrooms_silver_rooms: "அறைகள்",
    instavc_package_month_silver: "$281 / மாதம்",
    instavc_package_bill_silver:
      "ஆண்டுக்கு சரக்கு மற்றும் சேவை வரி 18% கட்டணம்",
    instavc_package_include_silver: "இந்த தொகுப்பு இதில் அடங்கும்",
    instavc_package_specifictions_silver:
      "வெண்பலகை\n திரை பகிர்  n அரட்டை  n பதிவுசெய்தல்  n வழங்குநர் பயன்முறை",
    instavc_package_buynow_silver: "இப்போது வாங்கவும்",
    instavc_package_fullfeatures_silver: "முழு அம்சங்கள்",
    instavc_package_gold: "தங்கம்",
    instavc_package_userrooms_gold: "200 பயனர்கள் - 30 அறைகள்",
    instavc_package_month_gold: "$467 / மாதம்",
    instavc_package_bill_gold: "ஆண்டுக்கு சரக்கு மற்றும் சேவை வரி 18% கட்டணம்",
    instavc_package_include_gold: "இந்த தொகுப்பு இதில் அடங்கும்",
    instavc_package_specifictions_gold:
      "வெண்பலகை\n திரை பகிர்  n அரட்டை  n பதிவுசெய்தல்  n வழங்குநர் பயன்முறை",
    instavc_package_buynow_gold: "இப்போது வாங்கவும்",
    instavc_package_fullfeatures_gold: "முழு அம்சங்கள்",
    instavc_package_platinum: "வெண்தங்கம்",
    instavc_package_userrooms_platinum: "500 பயனர்கள் - 50 அறைகள்",
    instavc_package_month_platinum: "$933 / மாதம்",
    instavc_package_bill_platinum:
      "ஆண்டுக்கு சரக்கு மற்றும் சேவை வரி 18% கட்டணம்",
    instavc_package_include_platinum: "இந்த தொகுப்பு இதில் அடங்கும்",
    instavc_package_specifictions_platinum:
      "வெண்பலகை\n திரை பகிர்  n அரட்டை  n பதிவுசெய்தல்  n வழங்குநர் பயன்முறை",
    instavc_package_buynow_platinum: "இப்போது வாங்கவும்",
    instavc_package_fullfeatures_platinum: "முழு அம்சங்கள்",
    instavc_package_legacybaselicense: "மரபு அடிப்படையிலான உரிமம்",
    instavc_package_licensebased_ports:
      "துறைமுகங்களின் எண்ணிக்கையின் அடிப்படையில் உரிமம்",
    instavc_package_hardwareendpoint: "வன்பொருள் முடிவுப்புள்ளியுடன் InstaVC",
    instavc_package_webrtcconf_legacysupport: "மரபு ஆதரவுடன் WebRTC மாநாடு",
    instavc_package_sip: "SIP / BFCP ஆதரவு",
    instavc_package_chh323: "ChH323 / H.239 ஆதரவு",
    instavc_package_contactus: "எங்களை தொடர்பு கொள்ள",
    instavc_myprofile_dashboard: "முகப்புப்பக்கம்",
    instavc_myprofile_settings: "அமைப்புகள்",
    instavc_myprofile: "என் சுயவிவரம்",
    instavc_myprofile_personaldetail: "சொந்த விவரங்கள்",
    instavc_myprofile_personaldetails_name: "பெயர்",
    instavc_myprofile_personaldetails_email: "மின்னஞ்சல்",
    instavc_myprofile_personaldetails_phoneno: "தொலைபேசி எண்",
    instavc_myprofile_personaldetails_address: "முகவரி",
    instavc_myprofile_personaldetails_city: "நகரம்",
    instavc_myprofile_edit: "தொகு",
    instavc_myprofile_personaldetails: "சொந்த விவரங்கள்",
    instavc_myprofile_firstname: "முதல் பெயர்",
    instavc_myprofile_lastname: "கடைசி பெயர்",
    instavc_myprofile_email: "மின்னஞ்சல்",
    instavc_myprofile_phoneno: "தொலைபேசி எண்",
    instavc_myprofile_professionaldetails: "தொழில்முறை விவரங்கள்",
    instavc_myprofile_position: "நிலை",
    instavc_myprofile_professionaldetails_email: "மின்னஞ்சல்",
    instavc_myprofile_professionaldetails_phoneno: "தொலைபேசி எண்",
    instavc_myprofile_professionaldetails_address: "முகவரி",
    instavc_myprofile_professionaldetails_branch: "கிளை",
    instavc_myprofile_professionaldetails_edit: "தொகு",
    instavc_myprofile_officialdetails: "அதிகாரப்பூர்வ விவரங்கள்",
    instavc_myprofile_officialdetails_position: "நிலை",
    instavc_myprofile_officialdetails_email: "மின்னஞ்சல்",
    instavc_myprofile_officialdetails_phoneno: "தொலைபேசி எண்",
    instavc_myprofile_officialdetails_branch: "கிளை",
    instavc_myprofile_officialdetails_address: "முகவரி",
    instavc_myprofile_contactinfo: "தொடர்பு தகவல்",
    instavc_myprofile_contactinformation: "தொடர்பு தகவல்",
    instavc_myprofile_add: "சேர்",
    instavc_myprofile_contactinformation_address: "முகவரி",
    instavc_myprofile_contactinformation_city: "நகரம் / சிறுநகரம்",
    instavc_myprofile_contactinformation_zip: "தபால் இலக்கம்",
    instavc_myprofile_contactinformation_landmark: "குறிப்பிடத்தக்க அடையாளம்",
    instavc_myprofile_address: "முகவரி",
    instavc_myprofile_landmark: "குறிப்பிடத்தக்க அடையாளம்",
    instavc_myprofile_delete: "எச்சரிக்கை",
    instavc_myprofile_deletealert: "இதை நீக்க விரும்புகிறீர்களா?",
    instavc_myprofile_disagree: "வித்தியாசம் கொள்",
    instavc_myprofile_agree: "ஒப்புக்கொள்",
    instavc_myprofile_websitelinks: "வலைத்தள இணைப்பு",
    instavc_myprofile_website_add: "சேர்",
    instavc_myprofile_website: "இணையதளம்",
    instavc_myprofile_websiteexample: "https://www.google.com",
    instavc_myprofile_sociallinks: "சமூக இணைப்புகள்",
    instavc_myprofile_sociallinks_add: "சேர்",
    instavc_myprofile_sociallink: "சமூக இணைப்புகள்",
    instavc_myprofile_sociallinks_example: "https://www.facebook.com/xxx",
    instavc_myprofile_basicinfo: "அடிப்படை தகவல்",
    instavc_myprofile_basicinfo_add: "சேர்",
    instavc_myprofile_basicinfo_dob: "பிறந்த தேதி",
    instavc_myprofile_basicinfo_gender: "பாலினம்",
    instavc_myprofile_basicinformation: "அடிப்படை தகவல்",
    instavc_myprofile_basicinformation_dob: "பிறந்த தேதி",
    instavc_myprofile_basicinformation_gender: "பாலினம்",
    instavc_myprofile_basicinformation_deletealert:
      "எச்சரிக்கை\nஇதை நீக்க விரும்புகிறீர்களா? ",
    instavc_myprofile_basicinformation_disagree: "வித்தியாசம் கொள்",
    instavc_myprofile_basicinformation_agree: "ஒப்புக்கொள்",
    instavc_myprofile_uploadnewavatar: "புதிய அவதாரத்தைப் பதிவேற்று",
    instavc_myprofile_cropimage: "படத்தை வெட்டு",
    instavc_myprofile_locale: "காட்சிக்குரிய இடம்",
    instavc_myprofile_localesettings: "இடம் அமைப்புகள்",
    instavc_myprofile_preferredlanguage: "விருப்பமான மொழி:",
    instavc_myprofile_language: "ஆங்கிலம்",
    instavc_settings: "அமைப்புகள்",
    instavc_settings_changepassword: "கடவுச்சொல்லை மாற்று",
    instavc_settings_changepass: "கடவுச்சொல்லை மாற்று",
    instavc_settings_currentpassword: "தற்போதைய கடவுச்சொல்",
    instavc_settings_newpassword: "புதிய கடவுச்சொல்",
    conf_password: "கடவுச்சொல்லை உறுதிப்படுத்தவும்",
    instavc_settings_enter_currentpassword:
      "தயவுசெய்து தற்போதைய கடவுச்சொல்லை உள்ளிடுக",
    instavc_settings_enter_newpassword:
      "தயவுசெய்து புதிய கடவுச்சொல்லை உள்ளிடுக",
    enter_confpassword: "உறுதிப்படுத்தும் கடவுச்சொல்லை உள்ளிடவும்",
    newpassword_confpassword_should_same:
      "புதிய கடவுச்சொல் மற்றும் உறுதி கடவுச்சொல் ஒரே மாதிரியாக இருக்க வேண்டும்",
    curnt_psw_and_new_psw_should_not_same:
      "தற்போதைய கடவுச்சொல் மற்றும் புதிய கடவுச்சொல் ஒரே மாதிரியாக இருக்கக்கூடாது",
    instavc_settings_help: "உதவி",
    instavc_settings_affiliate: "இணை சந்தைப்படுத்தல்",
    instavc_settings_support: "ஆதரவு மையம்",
    instavc_settings_newticket: "புதிய சீட்டைத் திற",
    instavc_settings_ticketstatus: "சீட்டு நிலையை சரிபார்க்கவும்",
    instavc_settings_troubleshoot: "சரிசெய்தல்",
    instavc_legacy_dailout: "டயல் அவுட்",
    instavc_legacy_stats: "புள்ளிவிவரங்கள்",
    instavc_legacy_dail_in_detail: "டயல்-இன் விவரங்கள்",
    instavc_legacy_h323_endpoint: "H.323 முடிவு புள்ளி",
    instavc_legacy_sip_endpoint: "SIP முடிவு புள்ளி",
    instavc_admin_users: "பயனர்கள்",
    instavc_courses: "படிப்புகள்",
    instavc_admin_username: "ஆசிரியர் பெயர்",
    instavc_admin_user_accountstatus: "கணக்கு நிலை",
    instavc_admin_user_confirmed: "உறுதி",
    instavc_admin_user_unconfirmed: "உறுதிப்படுத்தப்படாதது",
    instavc_admin_user_resetall: "அனைத்தையும் மீட்டமை",
    instavc_admin_user_sync: "ஒத்திசைவு ",
    instavc_admin_user_status: "நிலை",
    instavc_admin_user_phonenumber: "தொலைபேசி எண்",
    instavc_admin_user_created: "உருவாக்கப்பட்டது",
    instavc_admin_user_all: "எல்லாம்",
    instavc_admin_groups: "குழுக்கள்",
    instavc_admin_addmore: "மேலும் சேர்க்கவும்",
    instavc_admin_group_peoplelink: "குயின்ஸ், கோலைவ், பீப்பிள்லிங்க்",
    instavc_admin_select_plan: "திட்டத்தைத் தேர்ந்தெடு",
    instavc_admin_lastmodified: "கடைசியாக மாற்றியமைக்கப்பட்டது",
    instavc_admin_email_verified: "மின்னஞ்சல் சரிபார்க்கப்பட்டது",
    instavc_admin_verified: "சரிபார்க்கப்பட்டது",
    instavc_admin_Unverified: "சரிபார்க்கப்படாதது",
    instavc_admin_licenses: "உரிமங்கள்",
    instavc_admin_addlicense: "உரிமங்களைச் சேர்",
    instavc_admin_defaultroom: "இயல்புநிலை அறை",
    instavc_admin_hostlicense: "தொகுப்பாளர் அடிப்படையிலான உரிமம்",
    instavc_admin_roomlicense: "அறை அடிப்படையிலான உரிமம்",
    instavc_admin_virtualmcu: "மெய்நிகர் MCU அடிப்படையிலான உரிமம்",
    instavc_admin_enterprise: "நிறுவன உரிமம்",
    instavc_mcuserver: "MCU சேவையகம்",
    instavc_mculink: "https://awsmcu.instavc.com",
    instavc_admin_expirydate: "காலாவதி தேதி",
    instavc_admin_settings: "நிர்வாக அமைப்புகள்",
    instavc_default_offer: "பரிந்துரைக்கான இயல்புநிலை சலுகை ",
    instavc_enter_coupon_code: "படிவ குறியீட்டை உள்ளிடுக",
    instavc_current_partshare: "தற்போதைய கூட்டாளர் பகிர்வு",
    instavc_share_value: "பங்கு மதிப்பு",
    instavc_affliate_share: "தற்போதைய இணைப்பு பங்கு",
    instavc_enter_share: "பங்கு மதிப்பு உள்ளிடவும் (%)",
    instavc_roomname: "அறை பெயர்",
    instavc_room_ten: "பத்து",
    instavc_room_twenty: "இருபது",
    instavc_room_thirty: "முப்பது",
    instavc_room_hostbased: "தொகுப்பாளர் அடிப்படையிலான",
    instavc_virtualmcu: "மெய்நிகர் MCU",
    instavc_rooms_enterprises: "நிறுவன",
    instavc_roomid: "அறை அடையாளம்",
    instavc_roomtype: "வயது",
    instavc_room_options: "அறை விருப்பங்கள்",
    instavc_commercialtype: "பாடங்கள்",
    instavc_free: "இலவசம்",
    instavc_poc: "பிஓசி",
    instavc_commercial: "வணிகம்",
    instavc_createdAt: "உருவாக்கப்பட்டது",
    instavc_useraccess: "பயனர் அணுகல்",
    instavc_peoplelinkroom: "மக்கள் இணைப்பு அறை",
    instavc_inputlimit: "உள்ளீட்டு வரம்பு",
    instavc_participant_limit: "பங்கேற்பாளர்கள் வரம்பு",
    instavc_adduser: "பயனரைச் சேர்",
    instavc_searchbyname: "பெயரால் தேடு",
    instavc_manage_plans: "திட்டங்கள் / தயாரிப்புகளை நிர்வகி",
    instavc_new_plans: "புதிய திட்டம் / தயாரிப்பு",
    instavc_allplan_list: "அனைத்து திட்டங்களின் பட்டியல்",
    instavc_sortby: "வரிசைப்படுத்து",
    instavc_active: "செயலில்",
    instavc_inactive: "செயலற்றது",
    instavc_create_plan: "புதிய திட்டத்தை உருவாக்கு",
    instavc_plan_name: "திட்ட பெயர்",
    instavc_enteramount: "தொகையை உள்ளிடவும் (குறைந்தபட்சம்: INR 100)",
    instavc_select_product: "தயாரிப்பு தேர்ந்தெடு",
    instavc_host_room: "1 தொகுப்பாளர்/ அறை",
    instavc_multiroom: "பல தொகுப்பாளர் / அறை",
    instavc_legacyrooms: "மரபு அறை",
    instavc_number_hosts: "தொகுப்பாளர்களின் எண்ணிக்கை",
    instavc_number_participants: "பங்கேற்பாளர்களின் எண்ணிக்கை",
    instavc_number_room: "அறைகளின் எண்ணிக்கை",
    instavc_subscriptiom_period: "சந்தா காலம்",
    instavc_sub_yearly: "ஆண்டு",
    instavc_sub_monthly: "மாதாந்திர",
    instavc_sub_weekly: "வாராந்திர",
    instavc_setinterval: "இடைவெளியை அமை",
    instavc_type: "வகை",
    instavc_subscription: "சந்தா",
    instavc_onetime: "ஒரு முறை",
    instavc_description: "விளக்கம்",
    instavc_planid: "திட்ட அடையாளம்",
    instavc_orders: "ஆணைகள்",
    instavc_orderid: "ஆணை அடையாளம்",
    instavc_none: "எதுவுமில்லை",
    instavc_customer: "வாடிக்கையாளர்",
    instavc_build_anually: "ஆண்டுதோறும் கட்டணம்",
    instavc_recurring_billing: "தொடர்ச்சியான பில்லிங்",
    instavc_next_due: "அடுத்து செலுத்தக்கூடிய கட்டண நாள்",
    instavc_invoice_details: "விலைப்பட்டியல் விவரம்",
    instavc_recurring_payment: "தொடர்ச்சியான கட்டணம்",
    instavc_todays_sale: "இன்றைய விற்பனை",
    instavc_total_order: "மொத்த ஆணை",
    instavc_total_rooms: "மொத்த அறைகள்",
    instavc_current_conference: "தற்போதைய மாநாடுகள்",
    instavc_current_user: "தற்போதைய பயனர்கள்",
    instavc_live_broadcast: "நேரடி ஒளிபரப்பு",
    instavc_loading_chart: "விளக்கப்படத்தை ஏற்றுகிறது",
    instavc_view: "காண்க",
    instavc_coupon_info: "படிவ தகவல்",
    instavc_new_coupon: "புதிய படிவம்",
    instavc_create_coupon: "புதிய படிவத்தை உருவாக்கு",
    instavc_coupon_code: "படிவ குறியீடு",
    instavc_company_code: "நிறுவனத்தின் குறியீடு",
    instavc_select_plan: "திட்டங்களைத் தேர்ந்தெடு",
    instavc_discount: "தள்ளுபடி",
    instavc_activestatus: "செயலில் உள்ள நிலை",
    instavc_usage: "பயன்பாடு",
    instavc_activeusage: "செயலில் பயன்பாடு",
    instavc_singleuse: "ஒற்றை பயன்பாடு",
    instavc_multiuse: "பல பயன்பாடு",
    instavc_first_page: "முதல் பக்கம்",
    instavc_previosu_page: "முந்தைய பக்கம்",
    instavc_next_page: "அடுத்த பக்கம்",
    instavc_last_page: "கடைசி பக்கம்",
    instavc_plan: "திட்டம்",
    instavc_request_withdrawal: "திரும்பப் பெறுதல் கோரிக்கை",
    instavc_withdraw: "திரும்பப் பெறு",
    instavc_account: "கணக்கு",
    instavc_verification: "சரிபார்ப்பு",
    instavc_withdraw_history: "வரலாற்றைத் திரும்பப் பெறு",
    instavc_add_bank: "திரும்பப் பெறுவதற்கு வங்கி கணக்கைச் சேர்க்கவும்",
    instavc_bank_description:
      "உங்கள் நிதித் தகவலை ரகசியமாக வைத்திருப்பதன் மூலம் உங்கள் வங்கிக் கணக்கை நாங்கள் பாதுகாக்கிறோம். இந்தக் கணக்கிலிருந்து திரும்பப் பெறுவதற்கான கோரிக்கையை நாங்கள் பெறும்போதெல்லாம் உள்ள நிலைமையை உங்களுக்கு மின்னஞ்சல் செய்வோம்.திரும்பப் பெறுதல் தோல்விகள் மற்றும் வருமானத் தொகையைத் தவிர்க்க, இந்தக் கணக்கின் பெயர் உங்கள் வங்கிக் கணக்கில் உள்ள பெயருடன் பொருந்த வேண்டும். உங்கள் வங்கியின் கொள்கைகள் மற்றும் விடுமுறை அட்டவணைகளைப் பொறுத்து பரிமாற்றத்தை முடிக்க சிறிது நேரம் ஆகலாம்.",
    instavc_bank_accountnumber: "வங்கி கணக்கு எண்",
    instavc_enter_accountnumber: "உங்கள் கணக்கு எண்ணை உள்ளிடுக",
    instavc_account_name: "கணக்கு வைத்திருப்பவரின் பெயர்",
    instavc_per_bank_account: "வங்கி கணக்கின் படி",
    instavc_ifsc: "IFSC குறியீடு",
    instavc_bankname: "வங்கி பெயர்",
    instavc_branchname: "வங்கி கிளை பெயர்",
    instavc_confirmdetails: "விவரங்களை உறுதிப்படுத்தவும்",
    instavc_pandetails:
      "தயவுசெய்து உங்கள் நிரந்தர கணக்கு எண்(பான்) படி கீழே விவரங்களை வழங்கவும்",
    instavc_enter_pan: "நிரந்தர கணக்கு எண்(பான்) படி உங்கள் பெயரை உள்ளிடவும்",
    instavc_fathername: "தந்தையின் பெயர்",
    instavc_enter_fathername: "தந்தையின் பெயரை உள்ளிடுக",
    instavc_pannumber: "நிரந்தர கணக்கு எண்(பான்) எண்",
    instavc_panexampe: "எ.கா: BNZPM2501G",
    instavc_upload_pan_copy: "நிரந்தர கணக்கு எண்(பான்) நகலைப் பதிவேற்று",
    instavc_save_details: "விவரங்களைச் சேமி",
    instavc_sales: "விற்பனை",
    instavc_transactionid: "பரிவர்த்தனை அடையாளம்",
    instavc_date: "தேதி",
    instavc_amount: "தொகை",
    instavc_setaccount_withdraw:
      "திரும்பப் பெறுவதற்கு முன் கணக்கு விவரங்களை அமைக்கவும்",
    instavc_first_withdraw:
      "நீங்கள் திரும்பப் பெற முதல் முறையாக பயனராக இருந்தால், நீங்கள் கணக்கு விவரங்களை பூர்த்தி செய்து அடுத்த தாவல்களில் நிரந்தர கணக்கு எண்(பான்) அட்டை விவரங்களைப் பயன்படுத்தி உங்கள் கணக்கை சரிபார்க்க வேண்டும். சரிபார்ப்பு முடிந்ததும், உங்களுடைய கிடைக்கக்கூடிய நிலுவைத் தொகையை திரும்பப் பெறுமாறு கோரலாம்.",
    instavc_accountdetails: "கணக்கு விவரங்களை நிரப்புக",
    instavc_available_balance: "கிடைக்கக்கூடிய இருப்பு",
    instavc_amount_withdraw: "திரும்பப் பெற வேண்டிய தொகை",
    instavc_enteramount_withdraw:
      "நீங்கள் திரும்பப் பெற விரும்பும் தொகையை உள்ளிடவும்",
    instavc_select_payment_mode: "கட்டண பயன்முறையைத் தேர்ந்தெடுக்கவும்",
    instavc_paypal_payment: "பேபால் கட்டணம்",
    instavc_bank_transaction: "வங்கி பரிவர்த்தனை",
    instavc_paypalfee: "பேபால் கட்டணம்",
    instavc_totalamount_withdraw: "திரும்பப் பெற மொத்த தொகை",
    instavc_sendrequest: "கோரிக்கையை அனுப்பு",
    instavc_no_request_withdraw:
      "திரும்பப் பெறுவதற்கான கோரிக்கைகள் எதுவும் இதுவரை எழுப்பப்படவில்லை!",
    instavc_start_process_withdraw:
      "கீழே இருந்து திரும்பப் பெறுவதற்கான செயலாக்கத்தை நீங்கள் தொடங்கலாம்.",
    instavc_request_withdraw_now: "இப்போது திரும்பப் பெறுமாறு கோருங்கள்",
    instavc_current_commission: "தற்போதைய விற்பனை பங்கு",
    instavc_from: "இருந்து",
    instavc_to: "இடத்திற்கு",
    instavc_today: "இன்று",
    instavc_last7days: "கடைசி 7 நாட்கள்",
    instavc_lastmonth: "இந்த மாதம்",
    instavc_paid_customers: "கட்டண வாடிக்கையாளர்கள்",
    instavc_share_referral_link:
      "உங்கள் பரிந்துரை இணைப்பை நண்பர்களுடன் பகிர்ந்து கொள்ளுங்கள்",
    instavc_copylink: "இணைப்பை நகலெடு",
    instavc_minimum_payout: "குறைந்தபட்ச செலுத்துதல்",
    instavc_referral_signup: "பரிந்துரை பதிவுபெறுதல்கள்",
    instavc_referral_clicks: "பரிந்துரை சொடுக்குகள்",
    instavc_paid: "செலுத்தப்பட்டது",
    instavc_unpaid: "செலுத்தப்படாதது",
    instavc_totalearned: "மொத்தம் சம்பாதித்தது",
    instavc_myreferr: "My Referrals",
    instavc_viewall: "அனைத்தையும் காட்டு",
    instavc_mysales: "எனது விற்பனை",
    instavc_sms_mfa: "எஸ்எம்எஸ் எம்எஃப்ஏ நிலை",
    instavc_facebook: "முகநூல்",
    instavc_twitter: "கீச்சகம்",
    instavc_linkedin: "சென்டர்",
    instavc_referred_users: "பரிந்துரைக்கப்பட்ட பயனர்கள்",
    instavc_created_date: "உருவாக்கிய தேதி",
    instavc_myearnings: "எனது வருவாய்",
    instavc_earnings: "வருவாய்",
    instavc_commission_share: "விற்பனை பங்கினை பகிர்",
    instavc_commission_percentage: "விற்பனை பங்கு சதவீதம்",
    instavc_coupon_offers: "படிவங்கள் / சலுகைகள்",
    instavc_my_referral_account: "எனது பரிந்துரை கணக்கு",
    instavc_req_withdraw: "கோரிக்கை திரும்பப் பெறுதல்",
    instavc_authenticating: "InstaVC சேவையகத்திற்கு அங்கீகரிக்கிறது ...",
    instavc_join_access_media: "சேர்ந்தார் .. ஊடக சாதனங்களை அணுகுகிறது ...",
    instavc_publish_success: "வெற்றிகரமாக வெளியிடுங்கள்",
    instavc_recieves: "பெறுகிறது",
    instavc_host_screenshare:
      "நீங்கள் திரை / ஆவண பகிர்வுக்கான தொகுப்பாளராக மாற வேண்டும் அல்லது",
    instavc_request_sharescreen: "திரை / ஆவண பகிர்வுக்கான அணுகலைக் கோருங்கள்",
    instavc_note: "குறிப்பு",
    instavc_filesize: "கோப்பு அளவு 10MB க்கு மேல் இருக்கக்கூடாது",
    instavc_become_host:
      "தொகுப்பாளராக மாற, காணொலியில் புள்ளியிடப்பட்ட வழிதல் பட்டி சின்னங்கள்களைக் சொடுக்கவும்",
    instavc_clicklink:
      "மேல்விரிப்பில் தொகுப்பாளராக மாற இணைப்பை சொடுக்கவும் மற்றும் தொகுப்பாளர் கடவுச்சொல்லை உள்ளிட்டு மற்றும் தொகுப்பாளராக என்ற பொத்தானை சொடுக்கவும்.",
    instavc_doc_share: "ஆவண பகிர்வு",
    instavc_search_host: "தொகுப்பாளக்காக காத்திருக்கிறது",
    instavc_wait_for_host: "இந்த அமர்வை ஹோஸ்ட் தொடங்கும் வரை காத்திருக்கவும்",
    instavc_open_black_dialog: "கருப்பு உரையாடலைத் திற",
    instavc_open_white_dialog: "வெள்ளை உரையாடலைத் திறக்கவும்",
    instavc_dail_detail: "டயல்-இன் விவரங்கள்",
    instavc_request_access: "அணுகலைக் கோருங்கள்",
    instavc_inordder_enable: "செயல்படுத்தும் பொருட்டு",
    instavc_host_permission: "தொகுப்பாளலிருந்து அணுகல் அனுமதி தேவை ",
    instavc_please_wait: "தயவுசெய்து காத்திருங்கள்",
    instavc_host_to_permit: "(தொகுப்பாளர்) அனுமதி",
    instavc_alternate_content: "மாற்று உள்ளடக்கம்",
    instavc_meeting_room: "வின் அமர்வு அறை",
    instavc_host_left_conference: "தொகுப்பாளர் மாநாட்டை விட்டு வெளியேறினார்!",
    instavc_conf_end: "மாநாடு தானாகவே முடிவடையும்",
    instavc_seconds: "விநாடிகள்",
    instavc_waiting_msg:
      "காத்திருந்ததற்கு நன்றி. ஹோஸ்ட் சேர்ந்ததும் அமர்வைத் தொடங்குவோம்",
    instavc_let_hostname:
      "நீங்கள் காத்திருக்கிறீர்கள் என்பதை தொகுப்பாளருக்கு தெரியப்படுத்த விரும்புகிறீர்களா?",
    instavc_exitconf: "மாநாட்டிலிருந்து வெளியேறு",
    instavc_host_left: "தொகுப்பாளர் அந்த இடத்தை விட்டு வெளியேறினார்",
    instavc_end_host_msg:
      "தொகுப்பாளர் இந்த அமர்வை முடித்துவிட்டார். கலந்து கொண்டதற்கு நன்றி.",
    instavc_close_conf:
      "நீங்கள் முகப்புப்பக்கத்திற்குச் செல்லலாம் (அல்லது) பயன்பாட்டை மூடலாம்.",
    instavc_gohome: "முகப்பு பக்கத்திற்கு செல்லவும்",
    instavc_hand_raised: "கை உயர்த்தப்பட்டது",
    instavc_ask: "கேளுங்கள்",
    instavc_protocal: "நெறிமுறை",
    instavc_bitrate: "துகள்வீதம்",
    instavc_confirm_details: "உங்கள் விவரங்களை உறுதிப்படுத்தவும்",
    instavc_enter_info_conf:
      "தயவுசெய்து மாநாட்டைத் தொடங்குவதற்கு முன் உங்கள் தகவலை உள்ளிடவும்.",
    instavc_have_acc: "உங்களிடம் ஏற்கனவே கணக்கு இருந்தால்?",
    instavc_host_access: "தொகுப்பாளர் அணுகல்",
    instavc_host_pass: "தொகுப்பாளர் கடவுச்சொல்லை உள்ளிடவும்",
    instavc_becomehost: "தொகுப்பாளர் ஆக",
    instavc_permit_screenshare: "திரை-பகிர்வை அனுமதிக்கவும்",
    instavc_allow_access: "வெண்பலகை அணுகலை அனுமதிக்கவும்",
    instavc_request_permission: "கூடுதல் அனுமதிகளைக் கோரியுள்ளது",
    instavc_deny: "மறுக்க",
    // "instavc_planid" : "திட்ட அடையாளம்",
    instavc_customeremail: "வாடிக்கையாளர் மின்னஞ்சல்",
    instavc_orderlink: "ஆணை இணைப்பு",
    instavc_customerid: "வாடிக்கையாளர் அடையாளம்",
    instavc_selectpackage: "தொகுப்பைத் தேர்ந்தெடுக்கவும்",
    instavc_host_package: "தொகுப்பாளர் அடிப்படையிலான தொகுப்பு",
    instavc_virtualbase_mcu: "மெய்நிகர் MCU அடிப்படையிலானது",
    instavc_plans_product: "திட்டங்கள் / தயாரிப்புகள்",
    instavc_nodata: "தரவு எதுவும் கிடைக்கவில்லை",
    instavc_nodata_msg:
      "அச்சச்சோ! இப்போது உங்களுக்குக் காண்பிக்க தரவு எதுவும் கிடைக்கவில்லை.",
    instavc_basicplan: "அடிப்படை திட்டம்",
    instavc_host_participants: "30 பங்கேற்பாளர்களுடன் 1 தொகுப்பாளர்",
    instavc_link: "இணைப்பு",
    instavc_cancel_order: "ஆணை ரத்துசெய்",
    instavc_per: "ஒன்றுக்கு",
    instavc_user_email: "பயனர் மின்னஞ்சல்",
    instavc_owner: "உரிமையாளர்",
    instavc_user: "பயனர்",
    instavc_default_users: "இயல்புநிலை சலுகைகள்",
    instavc_system_settings: "கணினி அமைப்புகள்",
    instavc_expires: "காலாவதியாகிறது",
    instavc_start_VC: "காணொலி மாநாட்டைத் தொடங்குங்கள்",
    instavc_start_AC: "கேட்பொலி மாநாட்டைத் தொடங்கவும்",
    instavc_date_error:
      "தொடக்க தேதி மற்றும் நேரம் தற்போதைய நேரத்தை விட அதிகமாக இருக்க வேண்டும்",
    instavc_browser_update: "உலாவி புதுப்பிப்பு தேவை",
    instavc_browser_note:
      "இப்போது ஆதரிக்கப்படாத உலாவி பெயர் இன் பழைய பதிப்பை நீங்கள் பயன்படுத்துவதை நாங்கள் கவனித்தோம்.",
    instavc_browser_msg:
      "Instavc.com க்கு உலாவி பெயர் அல்லது வேறு எந்த நவீன உலாவிகளின் புதுப்பிக்கப்பட்ட பதிப்பு தேவைப்படுகிறது.",
    instavc_browser_upgrade:
      "தயவுசெய்து, சிறந்த அனுபவத்திற்காக இந்த உலாவிகளின் சமீபத்திய பதிப்புகளில் ஏதேனும் ஒன்றை மேம்படுத்தவும்.",
    instavc_googlechrome: "கூகிள் குரோம்",
    instavc_gc_version74: "பதிப்பு 74",
    instavc_mfirefox: "மொஸில்லா பயர்பாக்ஸ்",
    instavc_mff_version: "பதிப்பு 66",
    instavc_opera: "ஓபரா",
    instavc_opera_version: "பதிப்பு 60.0+",
    instavc_microsoftedge: "மைக்ரோசாஃப்ட் எட்ஜ்",
    instavc_ms_version: "பதிப்பு 44+",
    instavc_safari: "ஆப்பிள் சஃபாரி",
    instavc_safari_version: "பதிப்பு 12.1",
    instavc_contact_msg:
      "ஏற்கனவே மேம்படுத்தப்பட்டது, ஆனால் இன்னும் சிக்கல் உள்ளதா? எங்களை தொடர்பு கொள்ளவும்",
    instavc_camera_busy: "புகைப்படக்கருவி பரபரப்பக இருப்பதாக தெரிகிறது!",
    instavc_close_camera:
      "எல்லா பயன்பாடுகளையும் மூடிவிட்டு மீண்டும் முயற்சிக்கவும்.",
    instavc_resolution: "பிரித்திரன் ஆதரிக்கப்படவில்லை!",
    instavc_camera_notsupport:
      "இந்தத் பிரித்திரனை உங்கள் புகைப்படக்கருவி ஆதரிக்கவில்லை.",
    instavc_camera_reconfig:
      "குறைந்த தெளிவுத்திறனுடன் உங்கள் அமைப்புகளை மீண்டும் கட்டமைத்து மீண்டும் முயற்சிக்கவும்.",
    instavc_change_resolution: "பிரித்திரனை மாற்றவும்",
    instavc_confirmation: "உறுதிப்படுத்தல்",
    instavc_yes: "ஆம்",
    instavc_delete_room: "நீங்கள் நிச்சயமாக அறையை நீக்க விரும்புகிறீர்களா?",
    instavc_delete_license:
      "நீங்கள் நிச்சயமாக உரிமத்தை நீக்க விரும்புகிறீர்களா?",
    instavc_help: "உங்களுக்கு உதவ நாங்கள் இங்கு வந்துள்ளோம்",
    instavc_browse_questions: "அடிக்கடி கேட்கப்படும் கேள்விகள் மூலம் உலாவுக.",
    instavc_os: "இயக்க முறைமை",
    instavc_macos: "மேக் ஓஎஸ் எக்ஸ் பதிப்பு:",
    instavc_chrome_version: "குரோம் பதிப்பு:",
    instavc_private_browsing: "தனியார் உலாவலா?",
    instavc_faq_no: "இல்லை",
    instavc_display_resolution: "instavc காட்சி பிரித்திரன்",
    instavc_aspect_ratio: "காட்சி விகிதம்",
    instavc_sys_hasspeakers: "கணினியில் ஒலிப்பெட்டி உள்ளதா?",
    instavc_found_speakers: "ஒலிப்பெட்டி சாதனங்கள் கிடைத்தன: 2",
    instavc_speakers1: "ஒலிப்பெட்டி 1",
    instavc_speakers2: "ஒலிப்பெட்டி 2",
    instavc_sys_have_microphone: "கணினியில் ஒலிபெருக்கி உள்ளதா?",
    instavc_found_microphone: "ஒலிபெருக்கி சாதனங்கள் கிடைத்தன: 2",
    instavc_microphone1: "ஒலிபெருக்கி 1",
    instavc_microphone2: "ஒலிபெருக்கி 2",
    instavc_has_webcam: "கணினியில் வலைநிழம்பி உள்ளதா?",
    instavc_found_speakers1: "ஒலிப்பெட்டி சாதனங்கள் கிடைத்தன: 1",
    instavc_camera1: "புகைப்படக்கருவி 1",
    instavc_webcam_permission: "வலைத்தளத்திற்கு வலைநிழம்பி அனுமதிகள் உள்ளதா?",
    instavc_microphone_permission:
      "வலைத்தளத்திற்கு ஒலிபெருக்கி அனுமதிகள் உள்ளதா?",
    instavc_browser_allows:
      "இந்த பக்கத்தில் getUserMedia வை உலாவி அனுமதிக்கிறதா?",
    instavc_change_output_device:
      "வெளியீட்டு கேட்பொலி சாதனங்களை மாற்ற முடியுமா?",
    instavc_change_camera_resolutions:
      "புதிய getUserMedia கோரிக்கையை செய்யாமல் புகைப்படக்கருவி பிரித்திரனை மாற்ற முடியுமா?",
    instavc_browser_support_webrtc:
      "உலாவி WebRTC (ஒன்று 1.0 அல்லது 1.1)?யை ஆதரிக்கிறது",
    instavc_browser_support_ortc: "உலாவி ORTC (WebRTC 1.1)?யை ஆதரிக்கிறது",
    instavc_initial_setup:
      "உங்கள் ஆரம்ப அமைப்பு செயலாக்கப்படும் போது காத்திருக்கவும்!",
    instavc_close_browser:
      "இந்த நேரத்தில் உங்கள் உலாவியை மூட வேண்டாம் அல்லது பின் பொத்தானைப் பயன்படுத்த வேண்டாம்.",
    instavc_whoops: "அச்சச்சோ!",
    instavc_nonet_msg:
      "இணைய இணைப்பு எதுவும் கிடைக்கவில்லை. உங்கள் இணைப்பைச் சரிபார்க்கவும் அல்லது மீண்டும் முயற்சிக்கவும்.",
    instavc_nosearch: "தேடல் முடிவுகள் எதுவும் கிடைக்கவில்லை",
    instavc_noserchmsg:
      "உங்கள் தேடலுடன் பொருந்தக்கூடிய எந்த உருப்படியையும் எங்களால் கண்டுபிடிக்க முடியவில்லை.",
    instavc_nosearch_filter:
      "நீங்கள் தேடுவதைக் கண்டுபிடிக்க உங்கள் தேடல் அல்லது வடிப்பானை சரிசெய்ய முயற்சிக்கவும்.",
    instavc_gotohoem_page: "முகப்பு பக்கத்திற்கு செல்லவும்",
    instavc_pageloading: "பக்கம் ஏற்றுகிறது ... தயவுசெய்து காத்திருங்கள்!",
    instavc_process: "செயலாக்க ...",
    instavc_session_timeout: "அமர்வு நேரம் முடிந்தது",
    instavc_session_inactivity:
      "செயலற்ற தன்மை காரணமாக உங்கள் அமர்வு நேரம் முடிந்தது.",
    instavc_session_msg: "தயவுசெய்து உள்நுழைந்திருப்பதைத் தேர்வுசெய்க",
    instavc_session_reconnect: "மீண்டும் இணைக்கவும்",
    instavc_site_notreached: "இந்த தளத்தை அடைய முடியாது!",
    instavc_site_webaddress:
      "உங்களுக்கு சரியான வலை முகவரி கிடைத்துள்ளது என்பதை உறுதிப்படுத்திக் கொள்ளுங்கள்",
    instavc_check_internet: "உங்கள் பிணையத்தை சரிபார்க்கவும்",
    instavc_search_url: "பிற உலாவியில் உரலியைத் தேடுங்கள்",
    instavc_goto: "செல்லுங்கள்",
    instavc_request_for_access: "அணுகலுக்கான கோரிக்கை",
    instavc_start_collabrate: "வெண்பலகையில் ஒத்துழைக்கத் தொடங்க",
    instavc_large_conference_mode:
      'அதன் "பெரிய மாநாடு" பயன்முறையில், தொகுப்பாளர் உங்களுக்கு அனுமதி வழங்கும் வரை மற்றவர்களுடன் பேசவோ பார்க்கவோ முடியாது',
    instavc_allow_participants:
      'அதன் "பெரிய மாநாடு" பயன்முறையில், பங்கேற்பாளர்களை பேச நீங்கள் கைமுறையாக அனுமதிக்க வேண்டும்',
    instavc_buy_premium: "இந்த அம்சங்களைத் திறக்க பிரீமியம் வாங்கவும்",
    instavc_alert_tryagain:
      "ஏதோ தவறு ஏற்பட்டது, தயவுசெய்து மீண்டும் முயற்சிக்கவும்",
    instavc_enter_name: "உங்கள் பெயரை உள்ளிடவும்",
    instavc_confirm: "உறுதிப்படுத்தவும்",
    instavc_ok: "சரி",
    instavc_askquestion: "ஒரு கேள்வி கேள்...",
    instavc_recieve: "பெறு",
    instavc_delay: "தாமதம்(Ms)",
    instavc_audio_opus: "கேட்பொலி / ஓபஸ்",
    instavc_video_vp8: "காணொலி / விபி 8",
    instavc_browser_not_support_incall:
      "அழைப்பின் போது தெளிவு மாற்றத்தை உங்கள் உலாவி ஆதரிக்காது!",
    instavc_failed_toPublish: "காணொலியை வெளியிடுவதில் தோல்வி",
    instavc_publish_fail: "வெளியீடு தோல்வியுற்றது",
    instavc_video_cant_publish:
      "பயனர் வரம்பை எட்டியதால் காணொலியை வெளியிட முடியாது",
    instavc_failed_joinConference: "மாநாட்டில் சேர முடியவில்லை",
    instavc_mute_audio:
      "தொலை கேட்பொலி முடக்கப்பட்டிருந்தால் நீங்கள் முடக்க / முடக்க முடியாது",
    instavc_remote_audio_muted: "தொலை கேட்பொலி முடக்கப்பட்டது!",
    instavc_enter_conferenceid: "உங்கள் மாநாடு அடையாளம் உள்ளிடவும்",
    instavc_share_screen: "திரையைப் பகிரவும்",
    instavc_sharing_your_screen: "உங்கள் திரையைப் பகிர்கிறது ...",
    instavc_stop: "நிறுத்து",
    instavc_back: "பின்",
    instavc_choose_plan:
      "கீழேயுள்ள பட்டியலிலிருந்து உங்கள் திட்டத்தைத் தேர்வுசெய்க",
    instavc_have_promotionalcode:
      "விளம்பரக்குறியீடு / கூட்டாளர் குறியீடு உள்ளதா?",
    instavc_contact_pricing: "விலை நிர்ணயம் செய்ய எங்களைத் தொடர்பு கொள்ளுங்கள்",
    instavc_payment_failed: "கட்டணம் தோல்வியுற்றது",
    instavc_payment_error:
      "உங்கள் கட்டணத்தை கையாளும் போது துரதிர்ஷ்டவசமாக பிழை ஏற்பட்டது.",
    instavc_contact_support:
      "ஏதேனும் உதவி தேவைப்பட்டால் எங்கள் ஆதரவு குழுவை தொடர்பு கொள்ளவும்.",
    instavc_tryagain: "மீண்டும் முயற்சி செய்",
    instavc_payment_success: "கட்டணம் வெற்றிகரம்",
    instavc_thanks_for_payment: "உங்கள் கட்டணத்திற்கு நன்றி!",
    instavc_payment_processed:
      "உங்கள் கட்டணம் வெற்றிகரமாக செயல்படுத்தப்பட்டது. தானியங்கு கட்டண ரசீது",
    instavc_mail_sent:
      "விரைவில் உங்கள் பதிவு செய்யப்பட்ட மின்னஞ்சல் முகவரிக்கு அனுப்பப்படும்",
    instavc_goto_homepage: "முகப்பு பக்கத்திற்குச் செல்லவும்",
    instavc_want_toend_call: "அழைப்பை முடிக்க வேண்டுமா?",
    instavc_exit_window:
      "இந்த சாளரத்தை மூடுவது உங்கள் அழைப்பிலிருந்து வெளியேறும். இந்த அழைப்பை முடிக்க விரும்புகிறீர்களா?",
    instavc_create_room: "அறை உருவாக்கு",
    instavc_userlimit: "பயனர் வரம்பு",
    instavc_edit_room: "அறையைத் திருத்து",
    instavc_update: "புதுப்பிப்பு",
    instavc_manage_license: "உரிமங்களை நிர்வகிக்கவும்",
    instavc_package: "தொகுப்பு",
    instavc_no_of_rooms: "அறைகளின் எண்ணிக்கை",
    instavc_no_of_users: "பயனர்களின் எண்ணிக்கை",
    instavc_purchasedOn: "வாங்கப்பட்டது",
    instavc_expiredon: "காலாவதியானது",
    instavc_or: "அல்லது",
    instavc_otherhost_email:
      "நீங்கள் எந்தவொரு பயனரையும் தொகுப்பாளராக மாற்ற விரும்பினால், அவரது / அவள் மின்னஞ்சல் முகவரியை உள்ளிடவும்.",
    instavc_set_host_password: "தொகுப்பாளர் கடவுச்சொல்லை அமைக்கவும்",
    instavc_host_password: "தொகுப்பாளர் கடவுச்சொல்",
    instavc_access_room: "இந்த அறையை வேறு யார் அணுக முடியும்?",
    instavc_select_user_host:
      "அவரை / அவளை தொகுப்பாளராக மாற்ற பட்டியலில் இருந்து எந்த பயனரையும் தேர்ந்தெடுக்கவும்.",
    instavc_prologin: "InstaVC Pro உள்நுழைவு",
    instavc_start: "தொடங்கு",
    instavc_enter_website: "தயவுசெய்து வலைத்தளத்தின் பெயரை உள்ளிடவும்",
    instavc_enter_valid_email: "தயவுசெய்து,சரியான மின்னஞ்சலை உள்ளிடவும்",
    instavc_enter_valid_phone:
      "தயவுசெய்து செல்லுபடியாகும் தொலைபேசி எண்ணை உள்ளிடவும்",
    instavc_field_required: "இந்த புலம் தேவை",
    instavc_invitedby: "அழைத்தவர்",
    instavc_storage: "சேமிப்பு",
    affiliate_approve: "அங்கீகரிக்கப்பட்டது",
    affiliate_pending: "நிலுவையில் உள்ளது",
    affiliate_rejected: "நிராகரிக்கப்பட்டது",
    affiliate_user_status: "பயனர் நிலை",
    commission_other: "பிற விற்பனை பங்குகள்",
    add_commission: "விற்பனை பங்குகளைச் சேர்க்கவும்",
    delete_commission: "நீங்கள் விற்பனை பங்குகளை நீக்க விரும்புகிறீர்களா?",
    update_commission: "விற்பனை பங்கு புதுப்பிப்பு",
    name: "பெயர்",
    offer_value: "சலுகை மதிப்பு",
    add: "சேர்",
    update: "புதுப்பிப்பு",
    affiliates: "சந்தைப்படுத்தல்",
    status: "நிலை",
    status_change_message: "நிலையை மாற்ற விரும்புகிறீர்களா?",
    approve: "ஒப்புதல்",
    reject: "நிராகரி",
    commissions: "விற்பனை பங்குகள்",
    withdraw_data: "தரவைத் திரும்பப் பெறுங்கள்",
    withdraw_amount: "தொகையை திரும்பப் பெறுங்கள்",
    payment_method: "கட்டணம் செலுத்தும் முறை",
    payment_fee: "கட்டண கட்டணம்",
    total_amount_withdraw: "திரும்பப் பெறுவதற்கான மொத்த தொகை",
    total_earnings: "மொத்த வருவாய்",
    pending_amount: "நிலுவையில் உள்ள தொகை",
    paid_amount: "செலுத்திய தொகை",
    unpaid_amount: "செலுத்தப்படாத தொகை",
    requested_withdraw: "திரும்பப் பெறும் தொகை கோரப்பட்டது",
    english: "ஆங்கிலம்",
    french: "பிரஞ்சு",
    portuguese: "போர்த்துகீசியம்",
    hindi: "இந்தி",
    gujarati: "குஜராத்தி",
    kannada: "கன்னடம்",
    marathi: "மராத்தி",
    tamil: "தமிழ்",
    telugu: "தெலுங்கு",
    urdu: "உருது",
    spanish: "ஸ்பானிஷ்",
    malyalam: "மலையாளம்",
    italian: "இத்தாலிய",
    bangla: "பங்களா",
    room: "அறை",
    create: "உருவாக்கு",
    repeat: "மீண்டும் செய்யவும்",
    daily: "தினசரி",
    repeat_every: "மீண்டும் மீண்டும்",
    repeat_on: "மீண்டும் செய்யவும்",
    repeat_by: "மூலம் மீண்டும் செய்யவும்",
    ends: "முடிகிறது",
    after: "பிறகு",
    occurences: "கழ்வுகள்",
    on: "மேல்",
    summary: "சுருக்கம்",
    repeats: "மீண்டும் மீண்டும்",
    withdraws: "திரும்பப் பெறுகிறது",
    every: "ஒவ்வொரு",
    days: "நாட்கள்",
    weeks: "வாரங்கள்",
    months: "மாதம்",
    onday: "நாள்",
    years: "ஆண்டுகள்",
    times: "முறை",
    until: "வரை",
    past_meeting_list: "கடந்த அமர்வு பட்டியல்",
    organised_by: "ஏற்பாட்டு குழு",
    delete: "அழி",
    join: "சேர",
    to: "இடத்திற்கு",
    enter_password: "கடவுச்சொல்லை உள்ளிடவும்",
    submit: "சமர்ப்பிக்கவும்",
    enter_passwordmessage: "தயவுசெய்து கடவுச்சொல்லை உள்ளிடவும்",
    delete_message: "நீங்கள் நீக்க விரும்புகிறீர்களா?",
    meeting_permanent: "அமர்வு நிரந்தரமா?",
    day: "நாள்",
    password_message: "கடவுச்சொல் தவறானது",
    timezone: "நேரம் மண்டலம்",
    by: "வழங்கியவர்",
    weekdays: [
      "ஞாயிறு",
      "திங்கள்",
      "செவ்வாய்",
      "புதன்",
      "வியாழன்",
      "வெள்ளி",
      "சனி",
    ],
    allweek: [
      "ஞாயிறு",
      "திங்கள்",
      "செவ்வாய்",
      "புதன்",
      "வியாழன்",
      "வெள்ளி",
      "சனி",
    ],
    day_month: "மாதத்தின் நாள்",
    day_week: "வாரம் ஒரு நாள்",
    week: "வாரம்",
    month: "மாதம்",
    year: "ஆண்டு",
    enterpassword:
      "தயவுசெய்து உங்கள் புதிய கடவுச்சொல்லை உள்ளிட்டு கடவுச்சொல்லை உறுதிப்படுத்தவும்",
    passwordmessage:
      "கடவுச்சொல் மற்றும் கடவுச்சொல்லை உறுதிப்படுத்துதல் இரண்டும் ஒரே மாதிரியாக இருக்க வேண்டும்",
    passwordupdate:
      "கடவுச்சொல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது, தயவுசெய்து உங்கள் புதிய கடவுச்சொல்லுடன் உள்நுழையவும்",
    numeric: ["முதல்", "இரண்டாவது", "மூன்றாவது", "நான்காவது", "ஐந்தாவது"],
    verify_email: "உங்கள் மின்னஞ்சலை சரிபார்க்கவும்",
    confirm_code: "உறுதிப்படுத்தல் குறியீடு",
    verify_msg:
      "தயவுசெய்து குறியீட்டிற்காக உங்கள் செல்பேசியைச் சரிபார்க்கவும்.",
    verify: "சரிபார்க்கவும்",
    not_recieved: "பெறப்படவில்லை?",
    resend_otp: "OTP யை மீண்டும் அனுப்பு",
    start_browsing: "உலாவத் தொடங்குங்கள்",
    become_affiliate: "இணை சந்தைப்படுத்தல்",
    affiliate: "சந்தைப்படுத்தல்",
    verify_mobile: "உங்கள் செல்பேசியை சரிபார்க்கவும்",
    instavc_allow_DocumentAccess: "ஆவண-பகிர்வை அனுமதிக்கவும்",
    instavc_allow_Notes: "அனுமதி குறிப்புகள்",

    //common - CameraResolution
    camera_not_access:
      "பின்வரும் காரணங்களில் ஒன்று காரணமாக கேமராவை அணுக முடியாது:",
    camera_not_access_reason1:
      "தெளிவுத்திறன் அமைப்புகள் இந்த காட்சிக்கு பொருந்தாது. உங்கள் அமைப்புகளை குறைந்த தெளிவுத்திறனுடன் மீண்டும் கட்டமைத்து மீண்டும் முயற்சிக்கவும்.",
    camera_not_access_reason2:
      "உங்கள் புகைப்படக்கருவி வெவ்வேறு பயன்பாட்டால் பயன்படுத்தப்படுகிறது, தயவுசெய்து எல்லா பயன்பாடுகளையும் மூடிவிட்டு இணைப்பைக் சொடுக்கவும் செய்வதன் மூலம் மீண்டும் முயற்சிக்கவும்.",

    //Containers
    //content - components - assignQuestionnaire
    asgnQue_Assign_Question: "கேள்வித்தாளை ஒதுக்குங்கள்",
    asgnQue_assigned_question: "ஒதுக்கப்பட்ட கேள்வித்தாள்",
    //assignQuestList
    quslsit_assig_que_list: "ஒதுக்கப்பட்ட கேள்வித்தாள் பட்டியல்",
    quslsit_question_lists: "கேள்வித்தாள் பட்டியல்கள்",
    quslsit_add_new_question: "புதிய கேள்வித்தாளைச் சேர்க்கவும்",
    quslsit_no_question_assign: "கேள்வித்தாள் எதுவும் இதுவரை ஒதுக்கப்படவில்லை!",
    quslsit_assign_new_ques:
      "மேலே உள்ள கேள்வித்தாள் ஒதுக்கு பொத்தானைக் அழுத்தி, புதிய கேள்வித்தாளை ஒதுக்கவும்.",

    //model-assign-Questionnaire
    select_questionnaire: "கேள்வித்தாளைத் தேர்ந்தெடுக்கவும்",
    duration: "காலம்",
    time_limit: "நேர வரம்பு",
    show_results: "முடிவுகளை காட்டு",
    save: "சேமி",

    //viewAssigned
    content_group: "உள்ளடக்கக் குழு",
    list_assigned_ques: "ஒதுக்கப்பட்ட கேள்விகளின் பட்டியல்:",
    mins: "நிமிடங்கள்",
    marks: "மதிப்பெண்கள்",

    //AssignedQuestions
    asgQues_5_Marks: "(5 மதிப்பெண்கள்)",
    asgQues_answers: "பதில்கள்",
    asgQues_no_questions: "கேள்விகள் இல்லை!",

    //content - components - contentGrade
    //GradeSetting
    grdSet_GPA_calculation: "சதவீதத்திலிருந்து ஜி.பி.ஏ கணக்கீடு",
    grdSet_GPA_cal_msg:
      "சதவீதம் 100% ஆகும், இது 100 புள்ளிகளைத் தவிர வேறில்லை. எனவே சதவீதத்தில் 25 புள்ளிகள் ஜி.பி.ஏ அமைப்பில் 1 புள்ளிக்கு சமம். ஜி.பி.ஏ சூத்திரத்தின் சதவீதம் உங்கள் சதவீதத்தை 100 ஆல் வகுத்து 4 ஆல் பெருக்க வேண்டும். உங்கள் சதவீதம் 75% ஆக இருந்தால் உங்கள் தரம் (75/100) * 4 = 3 ஆக இருக்கும்.",
    grdSet_grade_point: "தர புள்ளிகள் என்றால்",

    //managegrade
    mngGrd_grades: "தரங்கள்",
    mngGrd_modify: "மாற்றவும்",
    mngGrd_save_grades: "தரங்களைச் சேமிக்கவும்",
    mngGrd_modify_grades: "தரங்களை மாற்றவும்",
    mngGrd_grade_info: "தர தகவல்",
    //content - components - ContentParticipants
    //components-admnAnsView
    admnAns_answer_list_for_question:
      "இந்த உள்ளடக்கக் குழுவின் அனைத்து கேள்வித்தாள்களுக்கான பதில்களின் பட்டியல் கீழே.",
    //components-participants
    prtcpt_certification: "சான்றிதழ்கள்:",
    prtcpt_other_content_group: "பிற உள்ளடக்கக் குழுக்களில்",
    prtcpt_sales: "விற்பனை",
    prtcpt_marketing: "சந்தைப்படுத்தல்",
    prtcpt_human_resource: "மனித வளம்",
    //manageparticipants
    mngPrtcpt_add_participants: "பங்கேற்பாளர்களைச் சேர்க்கவும்",
    mngPrtcpt_participants_list: "பங்கேற்பாளர்கள் பட்டியல்கள்",
    mngPrtcpt_import_participants: "பங்கேற்பாளர்களை இறக்குமதி செய்க",
    mngPrtcpt_download_sample: "மாதிரி பதிவிறக்க",
    mngPrtcpt_no_participants_added:
      "பங்கேற்பாளர்கள் யாரும் இதுவரை சேர்க்கப்படவில்லை!",
    mngPrtcpt_add_new_participant:
      "புதிய பங்கேற்பாளரைச் சேர்க்க, சேர்க்க மேலே உள்ள பங்கேற்பாளரைச் சேர்க்கவும் பொத்தானைக் அழுத்தவும்",
    //modal-add-participants
    addPrtcpt_select_participants: "பங்கேற்பாளர்களைத் தேர்ந்தெடுக்கவும்",
    addPrtcpt_model_add_participants: "பங்கேற்பாளர்களைச் சேர்க்கவும்",
    //partipantGradeView
    prtcptGrde_participant_grade: "பங்கேற்பாளர் தர விவரங்கள்",
    prtcptGrde_grade_participants_list: "பங்கேற்பாளர் பட்டியல்",
    //content - components - ContentQuestionnaire
    //managequestionnaire
    mngQuesnr_create_questionnaire: "கேள்வித்தாள் உருவாக்கு",

    questionnaire_list: "கேள்வித்தாள் பட்டியல்",
    //managequestions
    mngQues_question_details: "கேள்வித்தாள் விவரங்கள்",
    mngQues_no_question_created: "இதுவரை எந்த கேள்வியும் உருவாக்கப்படவில்லை!",
    mngQues_create_new_question:
      "ஒரு புதிய கேள்வியை உருவாக்கவும்,உருவாக்க மேலே உள்ள கேள்வி உருவாக்கு பொத்தானை அழுத்தவும்",
    //modal-create-quest-group
    mdlGrp_questionnaire_name: "கேள்வித்தாளின் பெயர்",
    mdlGrp_update: "புதுப்பிப்பு",
    mdlGrp_create: "உருவாக்கு",
    //modal-create-questions
    mdlCrtQues_question_type: "கேள்வி வகை",
    mdlCrtQues_sel_question_type: "கேள்வி வகையைத் தேர்ந்தெடுக்கவும்",
    mdlCrtQues_single_sel_multiple_choice: "ஒற்றை தேர்ந்தெடு பல தேர்வு",
    mdlCrtQues_multiselect_multiple_choice: "பல தேர்ந்தெடுக்கப்பட்ட பல தேர்வு",
    mdlCrtQues_ture_false: "சரி/ தவறு",
    mdlCrtQues_enter_answer_choice:
      "பதில் தேர்வுகளை உள்ளிட்டு, எந்த பதில் சரியானது என்று குறிக்கவும்",
    mdlCrtQues_add_another_choice: "+ மற்றொரு தேர்வைச் சேர்க்கவும்",
    //viewQuestionnaire
    viewQues_add_questions: "கேள்விகளைச் சேர்க்கவும்",
    viewQues_no_question_created: "இதுவரை எந்த கேள்வியும் உருவாக்கப்படவில்லை!",
    viewQues_create_new_question:
      "ஒரு புதிய கேள்வியை உருவாக்கவும்,உருவாக்க மேலே உள்ள கேள்வி உருவாக்கு பொத்தானை அழுத்தவும்",

    //content - components - createContent
    //createcontent
    crteContent_create_new_content: "புதிய உள்ளடக்கத்தை உருவாக்கவும்",
    crteContent_update_content: "உள்ளடக்கத்தைப் புதுப்பிக்கவும்",
    crteContent_save_content: "உள்ளடக்கத்தை சேமிக்கவும்",
    crteContent_content_list: "உள்ளடக்க பட்டியல்கள்",
    edit_content: "உள்ளடக்கத்தைத் திருத்து",
    crteContent_create_content: "உள்ளடக்கத்தை உருவாக்கவும்",
    crteContent_create_your_content_like:
      "படங்கள், காணொலி கோப்புகள், கேட்பொலி கோப்புகள் மற்றும் ஆவணங்கள் போன்ற ஊடகங்களைச் சேர்ப்பதன் மூலம் உங்கள் உள்ளடக்கத்தை உருவாக்கவும்.",
    crteContent_upload_document: "ஆவணங்களை பதிவேற்றவும்",
    crteContent_upload_media: "ஊடகத்தைப் பதிவேற்றுங்கள்",
    crteContent_document: "ஆவணங்கள்",
    crteContent_media_files: "ஊடக கோப்புகள்",
    //view-content
    viewCon_content_view: "உள்ளடக்கக் காட்சி",
    viewCon_content_list: "உள்ளடக்க பட்டியல்கள்",
    viewCon_View_content: "உள்ளடக்கத்தைக் காண்க",
    viewCon_enable: "இயக்கு:",
    viewCon_document: "ஆவணங்கள்",
    viewCon_media_files: "ஊடக கோப்புகள்",

    //content - components - contentRow
    conRow_by: "வழங்கியவர்:",

    //content - components - managecontent
    create_new_content: "உள்ளடக்கத்தை உருவாக்கவும்",
    mngCon_all: "அனைத்தும்",
    mngCon_content_list: "உள்ளடக்க பட்டியல்கள்",
    mngCon_no_content_created: "இதுவரை எந்த உள்ளடக்கமும் உருவாக்கப்படவில்லை!",
    mngCon_create_new_content:
      "புதிய உள்ளடக்கத்தை உருவாக்கவும்,உருவாக்க மேலே உள்ள உள்ளடக்கு உருவாக்கு பொத்தானை அழுத்தவும்.",
    //content - components - model-access-right
    mdlAccRight_share_access: "பிற பயிற்றுனர்களுடன் அணுகலைப் பகிரவும்",
    mdlAccRight_type_id_add:
      "மின்னஞ்சல் அடையாளத்தை தட்டச்சு செய்து சேர்க்கவும்",
    mdlAccRight_no_instructor_added:
      "எந்த பயிற்றுவிப்பாளரும் இதுவரை சேர்க்கப்படவில்லை!",
    mdlAccRight_add_people_from_addressbok:
      "உங்கள் முகவரி புத்தகத்திலிருந்து அல்லது மின்னஞ்சல் முகவரியைத் தட்டச்சு செய்வதன் மூலம் நபர்களைச் சேர்க்கவும்.",
    mdlAccRight_contacts: "தொடர்புகள்",
    mdlAccRight_add_contacts:
      "உங்கள் முகவரி புத்தக தொடர்புகளிலிருந்து உள்ளடக்கக் குழுவில் தொடர்புகளைச் சேர்க்கவும்",
    mdlAccRight_no_contacts_added:
      "தொடர்புகள் எதுவும் இதுவரை சேர்க்கப்படவில்லை!",
    //content - components - model-confirm-delete
    mdlConfDel_confirmation: "உறுதிப்படுத்தல்",
    mdlConfDel_are_you_sure_delete: "இதை நீக்க விரும்புகிறீர்களா",
    mdlConfDel_delete: "அழி",
    //content - components - model-create-content-group
    mdlCrtConGrp_alert_enter_group_title: "தயவுசெய்து குழு தலைப்பை உள்ளிடவும்",
    mdlCrtConGrp_alert_enter_group_description:
      "தயவுசெய்து குழு விளக்கத்தை உள்ளிடவும்",
    mdlCrtConGrp_group_name: "குழு பெயர்",
    //content - components - model-upload-doc
    mdlUpldoc_alert_enter_title_doc: "ஆவணத்தின் தலைப்பை உள்ளிடவும்",
    mdlUpldoc_upload_document: "ஆவணங்களை பதிவேற்றவும்",
    mdlUpldoc_document_title: "ஆவண தலைப்பு",
    mdlUpldoc_upload_doc_from_system:
      "உங்கள் கணினியிலிருந்து ஆவணத்தைப் பதிவேற்றவும், இது .pdf, Excel, சொல் ஆவணத்தை ஆதரிக்கிறது.",
    mdlUpldoc_upload_doc: "ஆவணத்தைப் பதிவேற்று",
    mdlUpldoc_added_doc: "ஆவணங்கள் சேர்க்கப்பட்டது",
    //content - components - model-upload-media
    mdlUplMedia_alert_enter_title_media:
      "தயவுசெய்து ஊடகத்தின் தலைப்பை உள்ளிடுக",
    mdlUplMedia_alert_enter_title_url:
      "தயவுசெய்து தலைப்பு மற்றும் உரலி உள்ளிடுக",
    mdlUplMedia_alert_enter_youtube_vimeo_url:
      "செல்லுபடியாகும் URL ஐ உள்ளிடவும் (Youtube / Vimeo)",
    mdlUplMedia_upload_media: "ஊடகத்தை  பதிவேற்றவும்",
    mdlUplMedia_upload_url: "இணையதள முகவரியை  பதிவேற்றவும்",
    mdlUplMedia_Upload_media_system:
      "உங்கள் கணினியிலிருந்து உயர் தெளிவுத்திறன் கொண்ட கோப்புகளைப் பதிவேற்றவும், இது .jpg, .png, .jpeg, .mp3, .mp4 ஐ ஆதரிக்கிறது.",
    mdlUplMedia_add_media_url:
      "ஊடகங்களை இணைக்க ஊடக உரலி முகவரியைச் சேர்க்கவும்",
    mdlUplMedia_upload_media_url: "ஊடக உரலி முகவரியை  பதிவேற்றவும்",
    mdlUplMedia_upload_youtube_url:
      "குறிப்பு: வலையொளி உரலி முகவரியை பதிவேற்றவும்",
    mdlUplMedia_Add_media_file: "ஊடக கோப்புகள் சேர்க்கப்பட்டது",

    //content - managecontent - index
    // "mngContent_content" : "உள்ளடக்கம்",
    mngContent_participants: "பங்கேற்பாளர்கள்",
    mngContent_grade_settings: "தர அமைப்புகள்",

    //content - index
    content_all_content_group: "அனைத்து உள்ளடக்கக் குழுக்களும்",
    create_new_group: "குழுவை உருவாக்கவும்",
    content_no_group_created: "இதுவரை எந்த குழுக்களும் உருவாக்கப்படவில்லை!",
    content_create_new_group:
      "ஒரு புதிய குழுவை உருவாக்கு, உருவாக்க மேலே உள்ள குழுவை உருவாக்கு பொத்தானை அழுத்தவும்.",

    //ContentShare - contentList
    conList_all_group: "அனைத்து குழுக்களும்",
    conList_content_list: "உள்ளடக்க பட்டியல்கள்",
    conList_no_content_created: "இதுவரை எந்த உள்ளடக்கமும் உருவாக்கப்படவில்லை!",
    //contentShare - grouplist
    grpList_all_content_group: "அனைத்து உள்ளடக்கக் குழுக்களும்",
    grpList_no_group_created: "இதுவரை எந்த குழுக்களும் உருவாக்கப்படவில்லை!",

    //ContentShare - questionStepper
    queStepper_cant_skip:
      "விருப்பமில்லாத ஒரு படிநிலையை நீங்கள் தவிர்க்க முடியாது.",
    queStepper_back: "பின்",
    queStepper_next: "அடுத்தது",
    queStepper_skip: "தவிர்",
    queStepper_finish: "முடி",
    queStepper_submit_next: "சமர்ப்பிக்கவும் அடுத்தது",
    //contentshare - showContent
    conList_content_list: "உள்ளடக்க பட்டியல்",
    showCont_document: "ஆவணங்கள்",
    showCont_previous: "முந்தையது",
    showCont_next: "அடுத்தது",
    showCont_have_completed_topic:
      "நான் இந்த உள்ளடக்கத்தில் தலைப்புகளை பூர்த்தி செய்துள்ளேன்",
    //contentShare - showMedia
    showMedia_page: "பக்கம்",
    showMedia_of: "இருந்த",
    showMedia_previous: "முந்தைய",

    //contentShare - showquestions
    showQues_min_left: "நிமிடங்கள் மீதமுள்ளன",
    showQues_completed_test:
      "இந்த கேள்வித்தாளில் நீங்கள் சோதனையை முடித்துவிட்டீர்கள்.",
    showQues_go_back_content_group: "உள்ளடக்கக் குழுவிற்குத் திரும்புக",
    //contentShare - viewUserScore
    viewUserScore_view_score: "மதிப்பெண் காண்க",
    viewUserScore_total_marks: "மொத்த மதிப்பெண்கள்:",
    viewUserScore_scored_marks: "மதிப்பெண்கள் பெற்றார்:",
    viewUserScore_GPA_score: "உங்கள் ஜி.பி.ஏ மதிப்பெண்",
    viewUserScore_below_list_of_answer:
      "இந்த உள்ளடக்கக் குழுவின் அனைத்து கேள்வித்தாள்களுக்கான பதில்களின் பட்டியல் கீழே.",
    viewUserScore_answered: "பதில்",
    viewUserScore_correct_answer: "சரியான பதில்",

    //schedule - components
    //ConfirmCancelInvite
    confCancle_confirmation: "உறுதிப்படுத்தல்",
    confCancle_are_you_sure: "நீ சொல்வது உறுதியா?",
    confCancle_delete_user: "பயனரை நீக்கு",
    //confirmscheduledelete
    confSche_are_you_sure_delete:
      "Are you sure you want to delete this schedule?",
    confSche_no: "இல்லை",
    //PastMeetingitem
    // "pastMtnItem_rn" : "ஆர்.என்",
    // "pastMtnItem_room_name" : "அறை பெயர்:",
    // "pastMtnItem_webinar_list" : "வலை கருத்தரங்குகள் பட்டியல்",
    // "pastMtnItem_list_webinar" : "வலை கருத்தரங்குகள் பட்டியல் கீழே",
    // "pastMtnItem_today" : "இன்று"
    // "pastMtnItem_webinar_title_falls" : "வலை கருத்தரங்கு தலைப்பு இங்கே விழுகிறது",
    // "pastMtnItem_view" : "காண்க",
    // "pastMtnItem_upcoming" : "வரவிருக்கும்",

    //SchedulesView	வலை கருத்தரங்கில்
    //"scheView_edit_content" : "உள்ளடக்கத்தைத் திருத்து",
    scheView_scheduled_by: "திட்டமிடப்பட்டது:",
    scheView_delete: "அழி",
    scheView_download_calander: "நாட்காட்டியைப் பதிவிறக்கவும்",
    scheView_invite_participants: "பங்கேற்பாளர்களை அழைக்கவும்",
    scheView_start_conference: "மாநாட்டைத் தொடங்கு",
    scheView_event_details: "நிகழ்வு விவரங்கள்",
    scheView_room_name: "அறை பெயர்",
    scheView_minutes: "நிமிடங்கள்",
    scheView_conference_password: "மாநாட்டு கடவுச்சொல்",
    scheView_settings: "அமைப்புகள்",
    scheView_webinar_event: "வலைநார் நிகழ்வு",
    scheView_list_webinar:
      "இந்த வலைநார் நிகழ்வை instavc.com/webinar இல் பட்டியலிட்டு, பதிவுகளை ஏற்கவும்.",
    scheView_guest_login_anonymous: "விருந்தினர் அநாமதேயராக உள்நுழையலாம்",
    scheView_allow_invities:
      "அழைப்பாளர்களை மட்டுமே மாநாட்டில் சேர அனுமதிக்கவும்",
    scheView_enable_webinar_chat: "வலை கருத்தரங்கு அரட்டையை இயக்கு",
    scheView_enable_hand_rise: "வலை கருத்தரங்கில் கை எழுப்பலை இயக்கு",
    scheView_list_of_people_invited: "கீழே அழைக்கப்பட்டவர்கள் பட்டியலில் உள்ளன",
    scheView_alert_err_to_join: "சேருவதற்கான பிழை",
    //WebinarDetails
    webnrDtls_upcoming_webinar_room:
      "கீழே இந்த அறைக்கு வரவிருக்கும் வலை கருத்தரங்கு உள்ளன",
    // Webinar 1
    // Webinar 2
    // Webinar 3
    webnrDtls_webinar_details: "வலை கருத்தரங்கு விவரங்கள்",
    webnrDtls_webinar_list: "வலை கருத்தரங்குகள் பட்டியல்",
    webnrDtls_webinar_title: "வலை கருத்தரங்கு தலைப்பு",
    webnrDtls_webinar_title_falls: "வலை கருத்தரங்கு தலைப்பு இங்கே விழுகிறது",
    webnrDtls_get_more_joining:
      "இந்த வலை கருத்தரங்கில் சேருவதன் மூலம் மேலும் பலவற்றைப் பெறுங்கள்",
    webnrDtls_join_webinar: "வெபினரில் சேரவும்",
    //webinarList
    webnrList_webinar_list: "வலை கருத்தரங்கு",
    webnrList_below_list_of_webinar: "கீழே வலை கருத்தரங்குகள் பட்டியல்",
    webnrList_today: "இன்று",
    webnrList_webinar_title_falls: "வலை கருத்தரங்கு தலைப்பு இங்கே விழுகிறது",
    webnrList_view: "காண்க",
    webnrList_upcoming: "வரவிருக்கும்",

    //schedule -
    //AddressBook
    addBook_address_book: "முகவரி புத்தகம்",
    addBook_contact: "தொடர்புகள்",
    addBook_add_contact_to_meeting:
      "உங்கள் முகவரி புத்தக தொடர்புகளிலிருந்து, அமர்வில் தொடர்புகளைச் சேர்க்கவும்",
    //MeetingList
    meetingList_past_meetings: "கடந்த அமர்வுகள்",
    meetingList_past_meetings_list: "கடந்த அமர்வுகள் பட்டியல்",
    meetingList_room_name: "அறை பெயர்:",
    meetingList_view_content: "உள்ளடக்கத்தைக் காண்க",
    meetingList_recording: "பதிவுகள்",
    meetingList_view: "காண்க",
    //scheduleInvite
    scheInvt_err_invalid_id: "தவறான மின்னஞ்சல் அடையாளம்",
    scheInvt_invite_participants: "பங்கேற்பாளர்களை அழைக்கவும்",
    scheInvt_address_book: "முகவரி புத்தகம்",
    scheInvt_invite_people_to_meeting:
      "இந்த அமர்வுக்கு மக்களை அழைக்கவும். உங்கள் முகவரிப் புத்தகத்திலிருந்து அல்லது மின்னஞ்சல் முகவரியைத் தட்டச்சு செய்வதன் மூலம் நபர்களைச் சேர்க்கவும்.",
    scheInvt_start: "தொடங்குகிறது @",
    scheInvt_below_list_of_answer:
      "இந்த உள்ளடக்கக் குழுவின் அனைத்து கேள்வித்தாள்களுக்கான பதில்களின் பட்டியல் கீழே.",
    scheInvt_host: "தொகுப்பாளர்:",
    scheInvt_minutes: "நிமிடங்கள்",
    //Webinar 1
    scheInvt_add: "சேர்",
    scheInvt_no_participants_added: "பங்கேற்பாளர்கள் யாரும் சேர்க்கப்படவில்லை",
    scheInvt_add_ppl_to_meetings:
      "உங்கள் முகவரிப் புத்தகத்தில் இருந்து பங்கேற்பாளர்களாக இந்த அமர்வில் நபர்களைச் சேர்க்கவும் அல்லது தேடலின் மூலம் அவர்களைச் சேர்க்கவும்.",
    scheInvt_send_invitation: "அழைப்பை அனுப்பு",
    scheInvt_send_passcodes: "கடவுக்குறியீடுகளை தனி அஞ்சலில் அனுப்பவும்.",

    //Invitation - component - invitationbody
    invitBody_invite_only_upto: "நீங்கள் 10 பேர் வரை மட்டுமே அழைக்க முடியும் ",
    invitBody_invite_ppl_meeting_email_add:
      "இந்த அமர்வுக்கு நபர்களை அழைக்கவும், உங்கள் முகவரிப் புத்தகத்திலிருந்து நபர்களைச் சேர்க்கவும் அல்லது மின்னஞ்சல் முகவரி மூலம் சேர்க்கவும்.",
    invitBody_copy: "நகலெடு",
    invitBody_enter_emailid: "மின்னஞ்சல் அடையாளத்தை உள்ளிடவும்.",
    invitBody_close: "மூடு",
    invitBody_send_invitation: "அழைப்பை அனுப்பு",

    //documentShare
    //index,js
    docShare_doc_sharing: "ஆவண பகிர்வு",
    docShare_upload_doc_system_pdf:
      "உங்கள் கணினியிலிருந்து ஆவணத்தைப் பதிவேற்றவும், இது .pdf, Excel, சொல் ஆவணத்தை ஆதரிக்கிறது.",
    docShare_upload_doc: "ஆவணத்தைப் பதிவேற்றுங்கள்",
    docShare_no_doc: "ஆவணங்கள் இல்லை",
    docShare_no_doc_in_list:
      "பட்டியலில் இதுவரை எந்த ஆவணங்களும் சேர்க்கப்படவில்லை.",
    docShare_add_doc: "ஆவணங்கள் சேர்க்கப்பட்டது",
    docShare_alert_title_doc: "தயவுசெய்து ஆவணத்தின் தலைப்பை உள்ளிடவும்",
    docShare_alert_something_went_wrong:
      "ஏதோ தவறு நடைபெற்றிருக்கிறது.தயவுசெய்து மீண்டும் முயற்சிக்கவும்",
    //components - PermitDocShare
    permitDocShr_permit_doc_share_access: "ஆவண பகிர்வு அணுகலை அனுமதிக்கவும்",
    permitDocShr_req_permission_doc_share:
      "ஆவணப் பகிர்வை அணுக அனுமதி கோரியுள்ளது.",
    permitDocShr_deny: "மறு",
    permitDocShr_allow: "அனுமதி",
    //components - RequestDocShare
    reqDocShr_req_doc_share_access: "ஆவண பகிர்வு அணுகலைக் கோருங்கள்",
    reqDocShr_access_permission_host:
      "ஆவணப் பகிர்வை இயக்க, தொகுப்பாளலிருந்து அணுகல் அனுமதி தேவை.",
    reqDocShr_plz_wait: "தயவுசெய்து காத்திருங்கள்",
    reqDocShr_permission_start_doc_share:
      "ஆவணப் பகிர்வைத் தொடங்க (தொகுப்பாளர்) அனுமதி.",
    reqDocShr_doc_share: "ஆவண பகிர்வு!",
    //components - ShowDocument View
    showDocViewback: "பின்னே",
    showDocViewdoc_title_name: "ஆவண தலைப்பு பெயர்",
    showDocViewnext: "அடுத்தது",
    showDocViewprevious: "முந்தைய",

    //Broadcast -
    //boradcastScreenShare
    borcstScreen_alert_unsupported:
      "ஆதரிக்கப்படாத நாடக ஒழுங்கு கோரப்பட்டது. ஆதரிக்கப்படும் வடிவங்கள் webrtc மற்றும் hls. PlayOrder = webrtc, hls போன்றவற்றைப் பயன்படுத்தவும்",
    borcstScreen_alert_no_stream_spec:
      "தாரை எதுவும் குறிப்பிடப்படவில்லை.தயவுசெய்து, URL இல்? Id = {STREAM_ID} யைச் சேர்க்கவும்",
    borcstScreen_Plz_enable_js:
      "இந்த காணொலியைக் காண ஜாவாஸ்கிரிப்டை இயக்கவும், மேலும் இணைய உலாவிக்கு மேம்படுத்தவும்",
    borcstScreen_support_HTML5: "HTML5 காணொலியை ஆதரிக்கிறது",
    borcstScreen_steam_play_when_live:
      "காணொலி தாரை நேரலையில் இருக்கும்போது இயங்கும்.",
    //broadcast
    broadcast_alert_unsupported:
      "ஆதரிக்கப்படாத நாடக ஒழுங்கு கோரப்பட்டது. ஆதரிக்கப்படும் வடிவங்கள் webrtc மற்றும் hls. PlayOrder = webrtc, hls போன்றவற்றைப் பயன்படுத்தவும்",
    broadcast_alert_no_stream_spec:
      "தாரை எதுவும் குறிப்பிடப்படவில்லை.தயவுசெய்து, URL இல்? Id = {STREAM_ID} யைச் சேர்க்கவும்",
    broadcast_enter_your_name: "தயவுசெய்து, உங்களுடைய பெயரை பதிவு செய்யவும்",
    broadcast_enter_your_email: "தயவுசெய்து, உங்கள் மின்னஞ்சலை உள்ளிடவும்",
    broadcast_user_details: "பயனர் விவரங்கள்",
    broadcast_submit_next: "சமர்ப்பிக்கவும்",
    broadcast_Plz_enable_js:
      "இந்த காணொலியைக் காண ஜாவாஸ்கிரிப்டை இயக்கவும், மேலும் இணைய உலாவிக்கு மேம்படுத்தவும்.",
    broadcast_support_HTML5: "HTML5 காணொலியை ஆதரிக்கிறது",
    broadcast_steam_play_when_live:
      "காணொலி தாரை நேரலையில் இருக்கும்போது இயங்கும்.",
    //broadcastConference
    brdcstConf_whiteboard: "வெண்பலகை",
    brdcstConf_screen_share: "திரை பகிர்",
    // "brdcstConf_participants" : "பங்கேற்பாளர்கள்",
    brdcstConf_broadcast: "ஒளிபரப்பு",
    brdcstConf_right: "சரி",
    //broadcast - component
    //broadcasterParicipants
    brdcstPart_broadcast_list: "ஒளிபரப்பு பட்டியல்",

    //Containers - calender
    //index
    calender_scheduled_calendar: "அட்டவணை நாட்காட்டி",
    calender_select_all: "அனைத்தையும் தேர்ந்தெடு",
    calender_calender: "நாட்காட்டி",
    calender_daily: "தினசரி",
    calender_weekly: "வாராந்திர",
    calender_month: "மாதம்",
    calender_today: "இன்று",

    //Dashboard - componenet

    //MeetingReminder
    meetReminder_scheduled_confirm: "அட்டவணை உறுதிப்படுத்தல்",
    meetReminder_meeting_has_been_scheduled:
      "இந்த நேரத்தில் அடுத்த அமர்வு திட்டமிடப்பட்டுள்ளது",
    meetReminder_start_meeting: "இந்த அமர்வைத் தொடங்குங்கள்",
    meetReminder_join_meeting: "இந்த அமர்வில் சேரவும்",
    meetReminder_quick_start_another_meeting:
      "மற்றொரு அமர்வை விரைவாகத் தொடங்குங்கள்",
    //MyMeetingItem
    myMeetItem_start: "தொடங்கு",
    myMeetItem_for: "ஆக",
    myMeetItem_minutes: "நிமிடங்கள்",
    myMeetItem_host: "தொகுப்பாளர்:",
    //MyMeeting
    myMeet_my_meetings: "எனது அமர்வுகள்",
    myMeet_search_my_meetings: "எனது அமர்வுகளைத் தேடுங்கள்",
    //NoScheduledMeeting
    noScheMeet_no_meeting_scheduled: "எந்த அமர்வுகளும் திட்டமிடப்படவில்லை",
    noScheMeet_no_upcoming_meetings:
      "உங்களிடம் இன்னும் வரவிருக்கும் அமர்வுகள் எதுவும் திட்டமிடப்படவில்லை. நீங்கள் ஒரு புதிய அட்டவணையை உருவாக்கலாம் அல்லது உங்கள் மாநாட்டை இப்போதே தொடங்கலாம்.",
    noScheMeet_create_schedule: "அட்டவணையை உருவாக்கவும்",
    noScheMeet_quick_start: "விரைவு தொடக்கம்",
    noScheMeet_or: "அல்லது",
    //RoomSettings
    roomSet_alert_select_license: "தயவுசெய்து, உரிமத்தைத் தேர்ந்தெடுக்கவும்",
    roomSet_manage_licenses: "உரிமங்களை நிர்வகிக்கவும்",
    roomSet_package: "தொகுப்பு",
    roomSet_no_of_rooms: "அறைகளின் எண்ணிக்கை",
    roomSet_no_of_user: "பயனர்களின் எண்ணிக்கை",
    roomSet_purchased_on: "வாங்கப்பட்டது",
    roomSet_expired_on: "காலாவதியானது",
    roomSet_create_room: "அறையை உருவாக்குங்கள்",

    //conference - component
    //AddSipDevice
    addSipDev_add_sip_details: "SIP விவரங்களைச் சேர்க்கவும்",
    addSipDev_sip_address: "SIP முகவரி:",
    addSipDev_connect: "இணைக்கவும்",
    addSipDev_enter_sip_address: "SIP முகவரியை உள்ளிடவும்",
    //ConfNotification
    confNotf_notification: "அறிவிப்புகள்",
    confNotf_user_name: "பயனர் பெயர்",
    confNotf_want_to_join: "இந்த அமர்வு அறையில் சேர விரும்புகிறார்.",
    confNotf_allow: "அனுமதி",
    confNotf_deny: "மறுக்க",
    confNotf_ask_question: "ஒரு கேள்வி கேட்டார்.",
    confNotf_send_msg_lobby: "கூடத்திலிருந்து ஒரு செய்தியை அனுப்பினார்.",
    //Loddy
    lobby_participants_loddy: "கூடத்தில் பங்கேற்பாளர்கள்",
    lobby_pramote_all: "அனைத்தையும் ஊக்குவிக்கவும்",
    lobby_user_name: "பயனர் பெயர்",
    //RemoveUserDialog
    removeUserDlg_manage_user_selecting:
      "இந்த விருப்பங்களில் ஏதேனும் ஒன்றைத் தேர்ந்தெடுப்பதன் மூலம் இந்த பயனரை நிர்வகிக்கவும்:",
    removeUserDlg_user_name: "பயனர் பெயர்",
    removeUserDlg_block_participant: "பங்கேற்பாளரைத் தடு",
    removeUserDlg_send_to_lobby: "கூடத்திருக்கு அனுப்பு",
    removeUserDlg_remote_participant: "பங்கேற்பாளரை அகற்று",
    removeUserDlg_close: "மூடு",
    //participantsList
    PartList_participants_in_lobby: "கூடத்தில் பங்கேற்பாளர்கள்",
    PartList_alert_something_went_wrong:
      "ஏதோ தவறு ஏற்பட்டது, தயவுசெய்து மீண்டும் முயற்சிக்கவும்",
    PartList_in_webinar: "வலை கருத்தரங்கில்",
    PartList_promote_all: "அனைத்தையும் ஊக்குவிக்கவும்",
    //participants2020	Retry
    //WaitingRoom
    waitingRoom_waiting_room: "காத்திருக்கும் அறை",
    waitingRoom_plz_wait_host_allow:
      "தொகுப்பாளர் உங்களை மாநாட்டில் சேர அனுமதிக்கும் வரை காத்திருங்கள்.",
    waitingRoom_chat: "அரட்டை",
    waitingRoom_mins: "நிமிடங்கள்",
    waitingRoom_no_msg_yet: "செய்திகள் இல்லை, இன்னும்!",
    waitingRoom_no_msg_from_host: "தொகுப்பாளலிருந்து செய்திகள் எதுவும் இல்லை.",
    //userRemoved
    userRemoved_you_removed_by_host:
      "பங்கேற்பாளர்களின் பட்டியலிலிருந்து நீங்கள் தொகுப்பாளரால் அகற்றப்பட்டீர்கள்",
    //invitationSlide
    invitSlide_invite: "அழைக்கவும்",
    invitSlide_add_email: "மின்னஞ்சல்களைச் சேர்க்கவும்",
    invitSlide_add: "கூட்டு",
    invitSlide_broadcast_list: "ஒளிபரப்பு இணைப்பு",
    invitSlide_invite_people_to_meeting:
      "இந்த அமர்வுக்கு மக்களை அழைக்கவும். நபர்களின் மின்னஞ்சல் முகவரியைத் தட்டச்சு செய்து, அழைப்பிதழை அனுப்ப பட்டியலில் சேர்க்கவும்.",
    invitSlide_err_invalid_id: "தவறான மின்னஞ்சல் அடையாளம்",
    //participantsChat
    particiChat_no_chat_msg: "இதுவரை அரட்டை செய்திகள் இல்லை!",
    particiChat_start_conversation:
      "இங்கே செய்திகளைக் காண உரையாடலைத் தொடங்கவும்.",

    //components - lobbyparticipants
    lobbyPartici_no_participants: "பங்கேற்பாளர்கள் இல்லை",
    lobbyPartici_no_participants_lobby:
      "கூடத்தில் பங்கேற்பாளர்கள் யாரும் இல்லை.",

    //conference
    //simulcast
    simulcast_alert_decline_access: "தொகுப்பாளர் அணுகலை மறுத்துவிட்டார்",

    simulcast_invalid_url: "தவறான இணையதள முகவரி",
    simulcast_no_host_available:
      "இந்த நேரத்தில் எந்த தொகுப்பாளறும் கிடைக்கவில்லை, திரையைப் பகிர தொகுப்பாளராகுங்கள்",
    //simulcastVAD & // Conference.js
    conference_access_to_participants: "பங்கேற்பாளர்களுக்கான அணுகல்",
    conference_screen_share: "திரை பகிர்",
    conference_chat: "அரட்டை",
    conference_lock_all: "அனைத்தையும் பூட்டு",
    conference_lock_conf: "பூட்டு மாநாடு",
    conference_become_host: "தொகுப்பாளர் ஆக",
    conference_you_are_host: "நீங்கள் தொகுப்பாளர்",
    conference_share: "பகிர்",
    conference_document_share: "ஆவணப் பகிர்வு",
    conference_content_share: "உள்ளடக்க பகிர்வு",
    conference_more: "மேலும்...",
    conference_become_host: "தொகுப்பாளர் ஆக",
    conference_alert_no_host_aval_screen:
      "இந்த நேரத்தில் எந்த தொகுப்பாளறும் கிடைக்கவில்லை, தயவுசெய்து, திரையைப் பகிர தொகுப்பாளராகுங்கள்",
    conference_alert_no_host_aval_doc:
      "இந்த நேரத்தில் எந்த தொகுப்பாளறும் கிடைக்கவில்லை, தயவுசெய்து, ஆவணத்தைப் பகிர தொகுப்பாளராகுங்கள்",
    conference_alert_err_sip_device: "சிப் சாதனத்தை இணைக்கும்போது பிழை",
    conference_alert_host_decline_access: "தொகுப்பாளர் அணுகலை மறுத்துவிட்டது",
    conference_alert_invalid_url: "தவறான இணையதள முகவரி",
    conference_unmute_mic_start_talk: "பேசத் தொடங்க உங்கள் ஒலிவாங்கியை முடக்கு",

    // tools
    confTools_new_whiteboard: "உங்கள் புதிய வெண்பலகை இங்கே வருகிறது",
    confTools_video_sync: "உங்கள் காணொலி ஒத்திசைவு",
    confTools_microphone: "ஒலிவாங்கி",
    confTools_type_text_here: "உங்கள் உரையைத் தட்டச்சு செய்க ...",
    whiteboard: "வெண்பலகை",

    //meetingRecording
    meetRec_video_rec_meeting_name: "அமர்வு பெயரின் வீடியோ பதிவுகள்",
    meetRec_page_view: "பக்கக் காட்சி:",
    //meetingRecording- recordinglistview
    recListView_title_name_rec: "பதிவின் தலைப்பு பெயர்",
    recListView_name_user: "பயனரின் பெயர்",

    // /////////////////////////////////////////////////////////////////////
    //Src
    //component - common - BrowserUpgrade
    brwUpg_req_fun_not_avail:
      "உங்கள் உலாவியில் தேவையான செயல்பாடு கிடைக்கவில்லை",
    brwUpg_meeting_req_fun_sup:
      "இந்த அமர்வு சேவைக்கு உங்கள் உலாவியால் ஆதரிக்கப்படாத செயல்பாட்டாளர் தேவை.",
    brwUpg_plz_upgrade:
      "மேம்படுத்தவும், வேறு உலாவிக்கு மாறவும் அல்லது உங்கள் அமைப்புகளை சரிபார்க்கவும். ஆதரவு உலாவிகள்:",
    //"    Samsung Internet
    //component - common - header - header.js
    header_content: "உள்ளடக்கம்",
    header_loading: "ஏற்றுகிறது...",

    //containers/admin/plans/components/createPlan.js
    crtePln_plz_enter_name: "தயவுசெய்து,திட்டத்தின் பெயரை உள்ளிடவும்",
    crtePln_plz_amount_Plan: "தயவுசெய்து,திட்டத்தின் தொகையை உள்ளிடவும்",
    crtePln_plz_enter_des: "தயவுசெய்து, விளக்கத்தை உள்ளிடவும்",
    crtePln_Plz_sel_product: "தயவுசெய்து, தயாரிப்பைத் தேர்ந்தெடுக்கவும்",
    crtePln_plz_sel_no_host:
      "தயவுசெய்து, தொகுப்பாளர்களின் எண்ணிக்கையைத் தேர்ந்தெடுக்கவும்",
    crtePln_plz_enter_no_participants:
      "தயவுசெய்து,பங்கேற்பாளர்களின் எண்ணிக்கையை உள்ளிடவும்",
    crtePln_plz_enter_roomno: "தயவுசெய்து,  எண்ணிக்கையை உள்ளிடவும்",
    crtePln_select_period: "தயவுசெய்து,காலத்தைத் தேர்ந்தெடுக்கவும்",
    crtePln_sel_interval: "தயவுசெய்து, இடைவெளியைத் தேர்ந்தெடுக்கவும்",
    crtePln_update_succ: "வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    crtePln_err_creating_plan: "திட்டத்தை உருவாக்குவதில் பிழை",

    //containers/broadcast/components/BroadcastHandRaise.js
    brdcRaise_alert_question_50_char:
      "உங்கள் கேள்விக்கு குறைந்தபட்சம் 50 எழுத்துக்கள் அரட்டை இருக்க வேண்டும்",
    //containers/conference/components/components
    cofCom_no_part_lobby: "கூடத்தில் பங்கேற்பாளர் இல்லை",
    //containers/conference/components/ConfirmUserDetails.js
    confmUser_plz_provide_name_email:
      "தயவுசெய்து, உங்கள் பெயர் மற்றும் மின்னஞ்சலை வழங்கவும்",
    confmUser_notes: "குறிப்புகள்",
    //containers/conference/ConferenceSetup.js
    confSetup_telepresence: "தொலைப்பேசி",
    confSetup_alert_not_generate_meetingID:
      "அமர்வு ஐடியை உருவாக்க முடியவில்லை, சிறிது நேரம் கழித்து முயற்சிக்கவும்",
    confSetup_auth_part_can_join:
      "அங்கீகரிக்கப்பட்ட பங்கேற்பாளர்கள் மட்டுமே சேர முடியும்!",
    confSetup_invalid_link: "தவறான இணைப்பு",
    confSetup_meeting_notyet_started:
      "இந்த அமர்வு இன்னும் தொடங்கப்படவில்லை. தயவுசெய்து பின்னர் சேரவும்!. நீங்கள் ஒரு புரவலராக இருந்தால், தயவுசெய்து instaVC இல் உள்நுழைந்து சந்திப்பைத் தொடங்கவும்",
    confSetup_meeting_locked_byhost: "இந்த அமர்வு ஹோஸ்ட்டால் பூட்டப்பட்டுள்ளது",
    confSetup_meeting_notyet_started_wait_host:
      "இந்த அமர்வு இன்னும் தொடங்கப்படவில்லை. தொகுப்பாளர் அமர்வைத் தொடங்கும் வரை காத்திருக்கவும்!",
    //containers/conference/components/NewChat.js",
    newChat_panel_chat: "பலகம் அரட்டை",
    //containers/conference/libs/InstaVC.js
    instaVc_server_busy:
      "சேவையகம் பிஸியாக இருப்பதாகத் தெரிகிறது! மற்றொரு சேவையகத்தை இணைக்க முயற்சிக்கிறது ...",
    //"    load-message",சுமை செய்தி
    instaVc_server_busy_reload_tojoin:
      "சேவையகம் பிஸியாக இருப்பதாகத் தெரிகிறது! மாநாடு சேர மீண்டும் ஏற்றவும்.",
    instaVc_broadcast_scr_failed: "ஒளிபரப்பு திரை தோல்வியுற்றது",
    instaVc_broadcast_failed: "ஒளிபரப்பு தோல்வியடைந்தது",
    instaVc_waiting_for_host: "தொகுப்பாளர் காணொலிக்காக காத்திருக்கின்றோம்",
    //containers/content/components/contentQuestionnaire/modal-create-quest-group.js
    modlCreate_plz_enter_title: "தயவுசெய்து தலைப்பை உள்ளிடவும்",
    modlCreate_poll: "கருத்து கணிப்பு",
    //containers/content/components/contentQuestionnaire/modal-create-poll-question.js
    mdlCretPoll_plz_enter_quest: "தயவுசெய்து, கேள்வியை உள்ளிடவும்",
    poll_submitted: "வாக்கெடுப்பு வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது.",
    mdlCretPoll_option_should_not_same:
      "விருப்பங்கள் ஒரே மாதிரியாக இருக்கக்கூடாது",
    mdlCretPoll_plz_enter_option: "தயவுசெய்து, விருப்பங்களை உள்ளிடவும்",
    mdlCretPoll_plz_select_type_option:
      "தயவுசெய்து, விருப்பங்களின் வகையைத் தேர்ந்தெடுக்கவும்",
    alert_server_error: "உள் சேவையக பிழை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்",
    mdlCretPoll_update_ques: "வாக்கெடுப்பு கேள்விகளைப் புதுப்பிக்கவும்",
    mdlCretPoll_create_ques: "கேள்வியை உருவாக்கவும்",
    mdlCretPoll_enter_que_here: "உங்கள் கேள்வியை இங்கே உள்ளிடவும்",
    mdlCretPoll_end: "முடிவு",
    //containers/content/components/contentQuestionnaire/viewQuestionnaire.js
    delete_successfully: "வெற்றிகரமாக நீக்கப்பட்டது",

    //containers/content/components/hozContentNavBlock.js / managecontent-index.js
    // "mngContent_mngContent_content" : "உள்ளடக்கம்",
    // "mngContent_mngContent_participants" : "பங்கேற்பாளர்கள்",
    mngContent_mngContent_fav_prog_lang:
      "உங்களுக்கு பிடித்த புரோகிராமிங் மொழி எது?",
    mngContent_mngContent_pollings: "வாக்குப்பதிவு",

    //containers/contentShare/showQuestions.js
    showQue_obtained_marks: "பெறப்பட்ட மதிப்பெண்கள்:",
    //containers/contentShare/viewUserScore.js
    viewUser_your_grade: "உங்கள் தரம்:",
    //containers/packages/Package.js
    package_one_host: "1 தொகுப்பாளர் மற்றும்",
    //"package_participants" : "பங்கேற்பாளர்கள்",
    // SOHO
    //"    SMB 300
    package_concurrentUser_room2: "20 ஒரே நேரத்தில் பயனர்கள் - 2 அறைகள்",
    package_concurrentUser_room5: "30 ஒரே நேரத்தில் பயனர்கள் - 5 அறைகள்",
    package_concurrentUser_room20: "100 ஒரே நேரத்தில் பயனர்கள் - 20 அறைகள்",
    package_concurrentUser_room30: "200 ஒரே நேரத்தில் பயனர்கள் - 30 அறைகள்",
    package_concurrentUser_room50: "500 ஒரே நேரத்தில் பயனர்கள் - 30 அறைகள்",

    //containers/schedule/components/PastMeetingItem.js
    pastMeeting_rn: "ஆர்.என்",
    pastMeeting_chat_history_deleted: "அரட்டை வரலாறு வெற்றிகரமாக நீக்கப்பட்டது",
    pastMeeting_past_meeting_dtls: "கடந்த சந்திப்பு விவரங்கள்",
    pastMeeting_duration: "காலம்:",
    pastMeeting_download_parti_atten:
      "பங்கேற்பாளர் மற்றும் பங்கேற்பாளர்களைப் பதிவிறக்குக",
    pastMeeting_download_webinar: "வலை கருத்தரங்கு பதிவிறக்கவும்",
    // "pastMeeting_participants" : "பங்கேற்பாளர்கள்",
    pastMeeting_attendees: "பங்கேற்றோர்",
    pastMeeting_chat_history: "அரட்டை வரலாறு",
    pastMeeting_recordings: "பதிவுகள்",
    pastMeeting_webinar_user: "வலை கருத்தரங்கு பயனர்கள்",
    pastMeeting_webinar_chat: "வலை கருத்தரங்கு அரட்டை",
    pastMeeting_no_participants_in_meeting:
      "இந்த அமர்வில் பங்கேற்பாளர்கள் இல்லை!",
    pastMeeting_no_parti_attended_meeting:
      "இந்த அமர்வில் பங்கேற்பாளர்கள் யாரும் இல்லை.",
    pastMeeting_guest_list: "விருந்தினர் பட்டியல்",
    pastMeeting_no_guest_in_meeting: "இந்த அமர்வில் விருந்தினர்கள் இல்லை!",
    "pastMeeting_no_guests_were_invited ":
      "இந்த அமர்வில் அழைக்கப்பட்ட அல்லது கலந்து கொண்ட விருந்தினர்கள் யாரும் இல்லை.",
    pastMeeting_meeting_chat_history: "அமர்வு அரட்டை வரலாறு",
    pastMeeting_delete_all: "அனைத்தையும் நீக்கு",
    pastMeeting_no_chat_msg_inmeeting: "இந்த அமர்வில் அரட்டை செய்திகள் இல்லை!",
    pastMeeting_no_conver_during_meeting:
      "அமர்வின் போது அரட்டையில் எந்த உரையாடலும் இல்லை.",
    pastMeeting_no_user_inwebinar: "இந்த வலை கருத்தரங்கில் பயனர்கள் இல்லை!",
    pastMeeting_no_user_attand_webinar:
      "இந்த வலை கருத்தரங்கில் கலந்து கொண்ட பயனர்கள் யாரும் இல்லை",
    pastMeeting_webinar_chat_history: "வலை கருத்தரங்கு அரட்டை வரலாறு",
    pastMeeting_no_chat_msg_inwebinar:
      "இந்த வலை கருத்தரங்கில் அரட்டை செய்திகள் இல்லை!",
    pastMeeting_no_conver_during_webinar:
      "வலை கருத்தரங்கின் போது அரட்டையில் உரையாடல்கள் எதுவும் இல்லை.",
    pastMeeting_del_chat_history: "அரட்டை வரலாற்றை நீக்கு",
    pastMeeting_delete_all_chat_history:
      "எல்லா அரட்டை வரலாற்றையும் நிரந்தரமாக நீக்க விரும்புகிறீர்களா?",
    pastMeeting_delete: "அழி",
    //containers/schedule/components/Schedules.js
    schedul_webinar_description: "வலை கருத்தரங்கு விளக்கம்",
    schedul_upload_custom_banner:
      "உங்கள் வலை கருத்தரங்கு நிகழ்வுக்காக தனிப்பயன் பதாகையைப் பதிவேற்றவும்.",
    schedul_setting: "அமைப்புகள்",
    //containers/schedule/components/SchedulesView.js
    schedulView_time: "நேரம்",
    schedulView_edit: "தொகு",
    schedulView_enable_training_mode: "பயிற்சி பயன்முறையை இயக்கு",
    schedulView_audio_conference: "கேட்பொலி மாநாடு",
    schedulView_enable_mix_video: "இயல்பாக கலவை காணொலியாக இயக்கவும்",

    //class components
    //content - components - hozContentNavBlock
    // "hozConNav_content" : "உள்ளடக்கம்",
    //scheduleMeeting
    scheMeet_room_reserved_from: "அறை ஒதுக்கப்பட்டுள்ளது",
    scheMeet_meeting_name: "அமர்வு பெயருடன்",
    //dashboard - component -contract
    contact_alert_already_in_call:
      "நீங்கள் ஏற்கனவே அழைப்பில் இருக்கும்போது மற்ற பயனரை அழைக்க முடியாது",
    contact_alert_user_offline: "பயனர் அகல்நிலை",
    //dashboard - dashboard.js
    dashboard_alert_cannot_start:
      "நீங்கள் வேறு அழைப்பில் இருக்கும்போது மாநாட்டைத் தொடங்க முடியாது",
    dashboard_alert_cannot_join:
      "நீங்கள் வேறு அழைப்பில் இருக்கும்போது மாநாட்டில் சேர முடியாது",
    dashboard_quick_start_conf: "விரைவு தொடக்க மாநாடு",
    dashboard_maintenance_msg:
      "தயவுசெய்து, வழக்கமான பராமரிப்பு காரணமாக ஏப்ரல் 22, 2020 அன்று 8.30 PM IST முதல் 9.00 PM IST வரை சேவையக வேலையில்லா நேரத்தை அனுபவிப்போம் என்பதை நினைவில் கொள்க.",
    //coBrowsing
    "coBrows_host_share-video":
      "தயவுசெய்து காத்திருங்கள்! தொகுப்பாளர் ஒரு காணொலியைப் பகிர உள்ளார்.",
    //Additionalcamera
    addCam_add_device: "சாதனத்தைச் சேர்க்கவும்",

    // genral same lang
    answer_list: "பதில்கள் பட்டியல்",
    answer: "பதில்கள்",
    answered: "பதில்",
    correct_answer: "சரியான பதில்",
    please_try_again: "தயவுசெய்து மீண்டும் முயற்சி செய்க",
    question: "கேள்வி",
    cancel: "ரத்துசெய்",
    questionnaire: "கேள்வித்தாள்",
    content: "உள்ளடக்கம்",
    address_book: "முகவரி புத்தகம்",
    view: "காண்க",
    rn: "ஆர்.என்",

    // new langs
    plz_enter_marks: "தயவுசெய்து கேள்வியின் மதிப்பெண்களை உள்ளிடவும்",
    plz_sel_crtans: "தயவுசெய்து, சரியான பதிலைத் தேர்ந்தெடுக்கவும்",
    truefalse_choice: "உண்மை/பொய் தேர்வு",
    questionnarie: "கேள்வித்தாள்",
    content_title: "உள்ளடக்க தலைப்பு",
    media_title: "ஊடக தலைப்பு",
    add_url_add: "சீரான வள முகவரியைச் சேர் …",
    val_shuld_grtr_from_val: "மதிப்பை விட மதிப்பை விட அதிகமாக இருக்க வேண்டும்",

    val_shuld_grtr_grade: "மதிப்பு தரத்தை விட அதிகமாக இருக்க வேண்டும்",
    to_val: "மதிப்புக்கு",
    enable_hand_raise:
      "கை எழுப்பலை இயக்கு / வலை கருத்தரங்கில் கேள்வியைக் கேளுங்கள்",
    enable_waiting_room: "காத்திருப்பு அறையை இயக்கு",
    allow_only_invite: "அழைப்பாளர்களை மட்டுமே மாநாட்டில் சேர அனுமதிக்கவும்",
    guest_login_anonymous: "விருந்தினர் அநாமதேயராக உள்நுழையலாம்",
    give_name_webinar: "உங்கள் வலை கருத்தரங்கிருக்கு ஒரு பெயரைக் கொடுங்கள்",
    Webinar: "வலை கருத்தரங்கு",
    video_syn: "காணொலி ஒத்திசைவு",
    notepad: "குறிப்பு திண்டு",
    enable_handraise: "வலை கருத்தரங்கில் கை உயர்த்துவதை இயக்கவும்",
    //new one venkatesh
    polls_list: "கருத்து கணிப்பு பட்டியல்",
    no_poll_assign: "எந்த கருத்து கணிப்பும் இதுவரை ஒதுக்கப்படவில்லை!",
    poll_view: "கருத்து கணிப்பு பார்வை",

    // new Prudhvi
    filter_block: "வடிகட்டி தொகுதி",
    file_size: "கோப்பின் அளவு",
    select_room: "தயவுசெய்து, ஒரு அறையைத் தேர்ந்தெடுக்கவும்",
    provide_event_name: "தயவுசெய்து, நிகழ்வு பெயரை வழங்கவும்",
    end_time_greater_start_time:
      "இறுதி நேரம் தொடக்க நேரத்தை விட அதிகமாக இருக்க வேண்டும்!",
    invite_people_meeting: "இந்த அமர்வுக்கு மக்களை அழைக்கவும்",
    download_ical: "ICal யை பதிவிறக்கவும்",
    download: "பதிவிறக்கம்",
    delete_meeting: "இந்த அமர்வை நீக்கு",
    room: "அறை",
    new_event: "புதிய நிகழ்வு",
    end_repeat: "முடிவு மீண்டும்",
    invite_users_timezone: "பின்வரும் நேர மண்டலத்துடன் பயனர்களை அழைக்கவும்",
    update_event: "நிகழ்வைப் புதுப்பிக்கவும்",
    create_event: "நிகழ்வை உருவாக்கவும்",
    wrong_password: "தவறான கடவுச்சொல்",
    college: "கல்லூரி",
    university: "பல்கலைக்கழகம்",
    country: "நாடு",
    time_period: "கால கட்டம்:",
    currently_working_here: "தற்போது இங்கு பணிபுரிகிறார்",
    from: "இருந்து:",
    to: "இடத்திற்கு",
    graduated: "பட்டம் பெற்றார்",
    enter_description: "உங்கள் விளக்கத்தை இங்கே உள்ளிடவும்...",
    concentration: "செறிவு",
    school: "பள்ளி",
    poll_question: "கருத்துக்கணிப்பு கேள்விகள்",
    create_poll_ques: "வாக்கெடுப்பு கேள்வியை உருவாக்கவும்",
    options: "விருப்பங்கள்",
    no_ques_assigned_yet: "இதுவரை எந்த கேள்விகளும் ஒதுக்கப்படவில்லை!",
    create_new_ques_click_create_ques:
      "மேலே உள்ள கேள்வியை உருவாக்கு பொத்தானை சொடுக்கு செய்து புதிய கேள்விகளை உருவாக்கவும்.",
    enter_room_name: "அறை பெயரை உள்ளிடவும்",
    billed_annually: "* ஆண்டுதோறும் கட்டணம் வசூலிக்கப்படுகிறது",
    subscribe_now: "இப்போது குழுசேரவும்",
    group: "குழு",
    sample_webinar: "மாதிரி வலை கருத்தரங்கு",
    webinar_affiliate: "இணைப்பாளர்களைப் பற்றிய வலைக்கருத்தரங்கு",
    webinar_one: "வலை கருத்தரங்கு ஒன்று",
    workspace: "பணியிடம்",
    company: "நிறுவனம்",
    add_another: "இன்னொன்றை சேர்",

    instavc_myreferral: "எனது பரிந்துரைகள்",
    pastMeeting_notes: "குறிப்புகள்",
    assignment: "வகுப்பீடு",
    assignments: "வகுப்பீடுகள்",
    create_new_poll: "ஒதுக்க, தொடங்க புதிய வாக்கெடுப்பு கேள்வியை உருவாக்கவும்.",
    plz_title_url: "தயவுசெய்து, தலைப்பு மற்றும் இணையதள முகவரியை உள்ளிடவும்",
    votes: "வாக்குகள்",
    enter_content_title: "தயவுசெய்து, உள்ளடக்கத்தின் தலைப்பை உள்ளிடவும்",
    failed_result: "முடிவு தோல்வியுற்றது",
    removed_successfully: "வெற்றிகரமாக அகற்றப்பட்டது",
    enter_duration: "தயவுசெய்து, கால அளவை உள்ளிடவும்",
    select_questionnarie: "தயவுசெய்து, கேள்வித்தாளைத் தேர்ந்தெடுக்கவும்",
    no_assignments: "வகுப்பீடுகள்  எதுவும் இல்லை",
    create_new_assignment:
      "புதிய வகுப்பீடுயை உருவாக்கவும், உருவாக்க மேலே உள்ள வகுப்பீடுயை உருவாக்கவும் என்ற பொத்தானை சொடுக்கவும்.",
    create_assignment: "பணியை உருவாக்கவும்",
    assignments_list: "வகுப்பீடுகளின் பட்டியல்",
    assignment_description: "வகுப்பீடுயின் விளக்கம்",
    assignment_name: "வகுப்பீடுயின் பெயர்",
    update_assignment: "வகுப்பீடுயை புதுப்பிக்கவும்",
    add_new_assignment: "புதிய பணியைச் சேர்க்கவும்",
    assignment_list: "ஒதுக்கீட்டு பட்டியல்",
    assign_assignments: "பணிகளை ஒதுக்குங்கள்",
    assigned_assignments_list: "வகுப்பீடுகளுக்கான பட்டியல்",
    assignment_answer: " வகுப்பீடுக்கான பதில்",
    no_assig_submitted: "இதுவரை எந்த  வகுப்பீடுகளும் சமர்ப்பிக்கப்படவில்லை.",
    no_assig_submitted_participants:
      "எந்தவொரு பங்கேற்பாளரிடமிருந்தும் இதுவரை வகுப்பீடுகள் எதுவும் சமர்ப்பிக்கப்படவில்லை.",
    view_assignment: "வகுப்பீடுயைக் காண்க",
    assigned_participants: "நியமிக்கப்பட்ட பங்கேற்பாளர்கள்",
    select_assignment: "வகுப்பீடுயைத் தேர்ந்தெடுக்கவும்",
    fill_your_assignment: "உங்களுக்கு வகுப்பீடுயின் விவரங்களை நிரப்பவும்",
    submit_assignment: "வகுப்பீடுயைச் சமர்ப்பிக்கவும்",
    assignment_details: "வகுப்பீடுயின் விவரங்கள்",
    assignment_submit_success: "வகுப்பீடு வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது",
    assignment_saved_success: "பணி வெற்றிகரமாக சேமிக்கப்பட்டது",
    how_to_get_started: "எப்படி தொடங்குவது.",
    create_new_room: "புதிய அறையை உருவாக்கவும்",
    create_room_add_participants:
      "ஒரு புதிய அறையை உருவாக்கி, பங்கேற்பாளர்களை அறையில் சேர்க்கவும்.",
    repeats_every: "ஒவ்வொன்றையும் மீண்டும் மீண்டும் செய்கிறது",
    now: "இப்போது",
    Plz_enter_title_meeting: "அமர்வின் தலைப்பை உள்ளிடவும்",
    no_start_time: "தொடக்க நேரம் இல்லை",
    no_end_time: "இறுதி நேரம் இல்லை",
    item_id_not_found: "பொருள் ஐடி கிடைக்கவில்லை",
    msg_title_not_found: "செய்தி தலைப்பு கிடைக்கவில்லை",
    plz_join_conf_clicking_link:
      "தயவுசெய்து, பின்வரும் இணைப்பைக் சொடுக்கு செய்வதன் மூலம் மாநாட்டில் சேரவும்",
    hi_there: "ஹாய் அங்கே",
    room_permanently: "அறை நிரந்தரமாக?",
    sure_want_to_delete_participants:
      "நிச்சயமாக, இந்த பங்கேற்பாளரை நீக்க விரும்புகிறீர்களா?",
    delete_participant: "பங்கேற்பாளரை நீக்கு",
    add_email: "மின்னஞ்சல் சேர்க்கவும்",
    add_participants_to_the_room:
      "பங்கேற்பாளர்களின் மின்னஞ்சல் முகவரியை கீழே உள்ளீட்டு பெட்டியில் தட்டச்சு செய்வதன் மூலம் இந்த அறையில் சேர்க்கவும்.",
    no_of_users: "பயனர்கள் இல்லை",
    edit_the_name:
      "இந்த அறையின் பெயரையும் பயனரின் எண்ணையும் நீங்கள் திருத்தலாம்.",
    delete_room: "அறையை நீக்கு",
    are_you_sure_delete: "இதை நீக்க வேண்டும் என்பதில் உறுதியாக இருக்கிறீர்களா",
    delete_this_room: "இந்த அறையை நீக்கு",
    delete_room_will_parmanently:
      "நீக்கு என்பதைக் சொடுக்குச் செய்வதன் மூலம், இந்த அறை நிரந்தரமாக நீக்கப்படும்.",
    enable_storage: "சேமிப்பிடத்தை இயக்கு",
    enable_recordings: "பதிவுகளை இயக்கு",
    enable_SIP: "SIPயை இயக்கு",
    addons: "துணை நிரல்கள்",
    expires_on: "காலாவதியாகிறது",
    purchased_on: "வாங்கப்பட்டது",
    more_storage: "அதிக சேமிப்பு",
    total_storage: "மொத்த சேமிப்பு",
    storage_occupied: "சேமிப்பு ஆக்கிரமிக்கப்பட்டுள்ளது",
    added: "சேர்க்கப்பட்டது",
    open_graphs: "வரைபடங்களைத் திறக்கவும்",
    participant_controls: "பங்கேற்பாளர் கட்டுப்பாடுகள்",
    "dashboard_controls ": "முகப்புப்பக்கம் கட்டுப்பாடுகள்",
    start_meeting: "ஒரு அமர்வைத் தொடங்குங்கள்",
    join_a_meeting: "ஒரு அமர்வில் சேரவும்",
    meeting_settings: "சந்திப்பு அமைப்புகள்",
    videos_to_get_started: "தொடங்குவதற்கான காணொலிகள்",
    if_you_are_host:
      "நீங்கள் தொகுப்பாளராக இருந்தால், அமர்வைத் தொடங்க கீழே உள்ள பொத்தானைக் கிளிக் செய்யவும்",
    guest_link: "விருந்தினர் இணைப்பு",
    pay_now: "இப்போது செலுத்த",
    promo_code_apply_here: "விளம்பர குறியீடு உள்ளதா? இங்கே விண்ணப்பிக்கவும்",
    per_month: "மாதத்திற்கு",
    billed_for: "கட்டணம்",
    gst_applicable:
      "அரசாங்க விதிமுறைகளுக்கு இணங்க, இந்தியாவில் வாடிக்கையாளர்களுக்கு கூடுதலாக 18% ஜிஎஸ்டி பொருந்தும்.",
    select_country_code: "நாட்டின் குறியீட்டைத் தேர்ந்தெடுக்கவும்",
    country_code: "நாட்டின் குறியீடு",
    enter_email_id: "மின்னஞ்சல் முகவரியை உள்ளிடவும் ...",
    downLoad_chat: "அரட்டையை பதிவிறக்கவும்",
    allow_guest_control_their:
      "விருந்தினரின் காணொலி / கேட்பொலியைக் கட்டுப்படுத்த அனுமதிக்கவும்",
    below_list_people_invited: "அழைக்கப்பட்டவர்களின் பட்டியல் கீழே",
    verification_code: "சரிபார்ப்புக் குறியீடு",
    open_link_enter_verify_code:
      "கீழே உள்ள இணையதள முகவரி இணைப்பைத் திறந்து, ஒருங்கிணைப்பிற்காக உங்கள் சரிபார்ப்புக் குறியீட்டை உள்ளிடவும்",
    social_media_integration: "சமூக ஊடக ஒருங்கிணைப்பு",
    integrate_social_media_platform:
      "நீங்கள் சமூக ஊடக தளங்களை ஒருங்கிணைக்க முடியும், ஒரு பொத்தானைச் சொடுக்கு செய்வதன் மூலம், நீங்கள் சரிபார்ப்புக் குறியீட்டைப் பெறுவீர்கள், அதை ஒருங்கிணைப்பிற்குப் பயன்படுத்தலாம்.",
    plz_enter_val_email: "தயவுசெய்து, செல்லுபடியாகும் மின்னஞ்சலை உள்ளிடவும்",
    record: "பதிவு",
    in_conference: "மாநாட்டில்",
    password_if_any: "கடவுச்சொல் (ஏதேனும் இருந்தால்)",
    stop_send: "நிறுத்தி அனுப்புங்கள்",
    broadcast_not_enabled_meeting: "இந்த அமர்வுக்கு ஒளிபரப்பு இயக்கப்படவில்லை",
    facebook_url: "முகநூல் இணையதள முகவரி",
    enter_facebook_url: "இணையதள முகவரியை உள்ளிடுக",
    add_facebook_url: "முகநூல் RTMP இணையதள முகவரியை சேர்க்கவும்",
    youtube_url: "வலையொளி இணையதள முகவரி",
    enter_youtube_url: "வலையொளி RTMP இணையதள முகவரியை உள்ளிடுக",
    add_youtube_url: "வலையொளி RTMP இணையதள முகவரியை சேர்க்கவும்",
    register: "பதிவு",
    time_of_program: "திட்டத்தின் நேரம்",
    date_of_program: "திட்டத்தின் தேதி",
    name_program_interested: "ஆர்வமுள்ள திட்டத்தின் பெயர்",
    email_id: "மின்னஞ்சல் முகவரி",
    dob: "பிறந்த தேதி",
    applicant_address: "விண்ணப்பதாரரின் முகவரி",
    qualification: "தகுதி",
    designation: "பதவி",
    org_name_address: "நிறுவனத்தின் பெயர் மற்றும் முகவரி",
    fullname_participant: "பங்கேற்பாளரின் முழு பெயர்",
    registration_form: "பதிவு படிவம்",
    thanks_submitting_data: "உங்கள் தரவை சமர்ப்பித்ததற்கு நன்றி",
    manage_content: "உள்ளடக்கத்தை நிர்வகிக்கவும்",
    API_settings: "API அமைப்புகள்",
    schedule_API: "அட்டவணை API",
    image_upload_success: "படம் வெற்றிகரமாக பதிவேற்றப்பட்டது",
    less_than_10MB: "தயவுசெய்து, 10MB க்கும் குறைவான கோப்பை பதிவேற்றவும்",
    at_time_of_event: "நிகழ்வு நேரத்தில்",
    min_5: "5 நிமிடங்களுக்கு முன்",
    min_10: "10 நிமிடங்களுக்கு முன்",
    min_15: "15 நிமிடங்களுக்கு முன்",
    min_30: "30 நிமிடங்களுக்கு முன்",
    hrs_1: "1 மணி நேரத்திற்கு முன்",
    hrs_2: "2 மணி நேரத்திற்கு முன்e",
    day_1: "1 நாட்களுக்கு முன்பு",
    day_2: "2 நாட்களுக்கு முன்பு",
    jan: "ஜனவரி",
    feb: "பிப்ரவரி",
    mar: "மார்ச்",
    apr: "ஏப்ரல்",
    may: "மே",
    jun: "ஜூன்",
    jul: "ஜூலை",
    aug: "ஆகஸ்ட்",
    sep: "செப்டம்பர்",
    oct: "அக்டோபர்",
    nov: "நவம்பர்",
    dec: "டிசம்பர்",
    mon: "திங்கள்",
    tue: "செவ்வாய்",
    wed: "புதன்",
    thu: "வியாழன்",
    fri: "வெள்ளிக்கிழமை",
    sat: "சனிக்கிழமை",
    sun: "ஞாயிற்றுக்கிழமை",
    all_day: "நாள் முழுவதும்",
    starts_ddmmyyyy: "தொடக்க தேதி (dd/mm/yyyy)",
    ends_ddmmyyyy: "கடைசி தேதி (dd/mm/yyyy)",
    ddmmyyyy: "(dd/mm/yyyy)",
    by_dayweek: "நாள் / வாரம்",
    never: "ஒருபோதும்",
    on_date: "குறித்த நாளில்",
    alert: "எச்சரிக்கை",
    multi_factor_auth: "பல காரணி அங்கீகாரத்தை (MFA) இயக்கு",
    advanced_settings: "மேம்பட்ட அமைப்புகள்",
    verify_Otp: "Otpயை சரிபார்க்கவும்",
    resend_Otp: "Otpயை மீண்டும் அனுப்பு",
    otp_sent_mobile: "உங்கள் செல்பேசி எண்ணுக்கு அனுப்பப்பட்ட OTPயை உள்ளிடவும்",
    update_mobile: "செல்பேசி புதுப்பிக்கவும்",
    verify_mobile: "செல்பேசி சரிபார்க்கவும்",
    mob_verfi_pending: "உங்கள் செல்பேசி சரிபார்ப்பு நிலுவையில் உள்ளது.",
    mobile_number: "செல்பேசி எண்",
    enter_Otp: "ஒரு முறை கடவுச்சொல்லை உள்ளிடவும்",
    enter_mob_no: "தயவுசெய்து, செல்பேசி எண்ணை உள்ளிடவும்",
    sure_want_to_delete_rec: "நீங்கள் நிச்சயமாக பதிவை நீக்க விரும்புகிறீர்களா?",
    delete_recording: "பதிவை நீக்கு",
    invalid_credentials: "தவறான ஆவண சான்றுகள்",
    join_conf_by_clicking_link:
      "தயவுசெய்து, பின்வரும் இணைப்பைச் சொடுக்கு செய்வதன் மூலம் மாநாட்டில் சேரவும்.",
    hi_there: "ஹாய் அங்கே,",
    valid_room_name: "தயவுசெய்து, செல்லுபடியாகும் அறை பெயரை உள்ளிடவும்",
    internal_server_error:
      "உள் சேவையக பிழை, தயவுசெய்து மீண்டும் முயற்சிக்கவும்",
    room_limit_exceed: "அறை வரம்பு மீறியது",
    cant_start_meeting_already_goingon:
      "ஒரு அமர்வை நீங்கள் தொடங்க முடியாது, ஏனெனில் ஒரு அமர்வு ஏற்கனவே நடந்து கொண்டிருக்கிறது.",

    //new
    social_integration: "சமூக ஒருங்கிணைப்பு",
    advanced: "மேம்படுத்தபட்ட",
    add_youtube: "Youtube ஐச் சேர்க்கவும்",
    plugins: "செருகுநிரல்கள்",
    subtitles: "வசன வரிகள்",
    view_local: "உள்ளூர் காண்க",
    hide_local: "உள்ளூர் மறை",
    switch_conf_mode: "மாநாட்டு பயன்முறைக்கு மாறவும்",
    switch_pres_mode: "தொகுப்பாளர் பயன்முறைக்கு மாறவும்",
    conference_locked: "மாநாடு பூட்டப்பட்டது",
    conference_unlocked: "மாநாடு திறக்கப்பட்டது",
    sharing_tools: "பகிர்வு கருவிகள்",
    record: "பதிவு",
    recording: "பதிவு",
    plz_wait_host_shr_video:
      "தயவுசெய்து காத்திருங்கள்! புரவலன் ஒரு வீடியோவைப் பகிர உள்ளார்",
    supported_sources_include: "ஆதரிக்கப்படும் ஆதாரங்கள் அடங்கும்",

    team_plugins: "குழு செருகுநிரல்கள்",
    open: "திற",
    click: "கிளிக் செய்க",
    more_app: "மேலும் பயன்பாடுகள்",
    upload_custom_app: "தனிப்பயன் பயன்பாட்டைப் பதிவேற்றுக",
    download_team_plugin: "குழு செருகுநிரலைப் பதிவிறக்குக",
    install_mng_app_microsoft_team:
      "மைக்ரோசாப்ட் குழுக்களில் பயன்பாட்டை எவ்வாறு நிறுவுவது மற்றும் நிர்வகிப்பது",
    microsoft_step1: "படி 1: மைக்ரோசாப்ட் அணிகளைத் திறக்கவும்",
    microsoft_step1_para1:
      "தொடங்குவதற்கு, முதலில் இந்த பக்கத்தின் மேலே கிடைக்கும் உங்கள் கணினியில் குழு சொருகினை பதிவிறக்கம் செய்ய வேண்டும். உங்கள் மைக்ரோசாஃப்ட் அணிகளைத் திறந்து தேர்வு செய்யவும்",
    microsoft_step1_para2:
      " குழு பயன்பாடுகளைக் காண பக்க வழிசெலுத்தலில் இருந்து விருப்பங்கள்.",
    microsoft_step2: "படி 2: கூடுதல் பயன்பாடுகளுக்குச் செல்லவும்",
    microsoft_step2_para1:
      "மேலும் பயன்பாடுகள் என்ற பொத்தானுடன் சில பயன்பாடுகளை இங்கே காணலாம். கிளிக் செய்யவும்",
    microsoft_step2_para2:
      "தனிப்பயன் பதிவேற்ற விருப்பம் மற்றும் பிற கடை விருப்பங்களை மேலும் சரிபார்க்க.",
    microsoft_step3: "படி 3: பயன்பாட்டைப் பதிவேற்றுக",
    microsoft_step3_para1:
      "நீங்கள் கடையைத் திறந்ததும், நீங்கள் ஒன்றைக் காணலாம்",
    microsoft_step3_para2:
      " இடது வழிசெலுத்தலில் விருப்பம். அதைக் கிளிக் செய்து உங்கள் பதிவிறக்கிய சொருகி பயன்பாட்டை இங்கே பதிவேற்றவும்.",
    microsoft_step4:
      "படி 4: சேமிப்பிலிருந்து InstaVC பயன்பாட்டைத் தேர்ந்தெடுக்கவும்",
    microsoft_step4_para1:
      "சாளரம் கேட்கும் போது, ​​பதிவிறக்கம் செய்யப்பட்ட உங்கள் கணினியிலிருந்து InstaVC சொருகி பயன்பாட்டைத் தேர்ந்தெடுத்து (படி 1) கிளிக் செய்யவும்",
    microsoft_step5: "படி 5: மைக்ரோசாஃப்ட் குழுக்களில் பதிவேற்றப்பட்ட பயன்பாடு",
    microsoft_step5_para1:
      "கோப்பை பதிவேற்றிய பிறகு, இது மைக்ரோசாப்ட் குழு பயன்பாடுகள் பட்டியலில் பதிவேற்றப்படும். பயன்பாட்டைக் காண நீங்கள் அதைக் கிளிக் செய்து அணிகளில் சேர்க்கலாம்.",
    microsoft_step6: "படி 6: InstaVC பயன்பாட்டைத் திறக்கவும்",
    microsoft_step6_para1:
      "நீங்கள் InstaVC பயன்பாட்டைக் கிளிக் செய்தவுடன், இப்போது ஒரு பொத்தானைக் கொண்டு சொருகி பயன்பாட்டின் முழுமையான விவரங்களையும் பார்க்கலாம்",
    microsoft_step6_para2:
      "மைக்ரோசாஃப்ட் குழுக்களில் இந்த பயன்பாட்டைச் சேர்க்க பொத்தானை அழுத்தவும்.",
    microsoft_step7: "படி 7: மைக்ரோசாஃப்ட் குழுக்களில் InstaVC சேர்க்கப்பட்டது",
    microsoft_step7_para1:
      "இப்போது உங்கள் பயன்பாடு எளிதான மற்றும் தனிப்பயனாக்கக்கூடிய பயன்பாட்டிற்காக இடது பக்க வழிசெலுத்தலில் உள்ள மைக்ரோசாஃப்ட் அணிகளில் சேர்க்கப்படும்.",

    ddyymm: "DD/MM/YYYY",
    fill_details_for_webinar:
      "தயவுசெய்து,வலைக்கருத்தரங்குக்கான உங்கள் பதிவு விவரங்களை நிரப்பவும்",
    microsoft_teams: "மைக்ரோசாப்ட் அணிகள்",
    microsoft_outlook: "மைக்ரோசாப்ட் அவுட்லுக்",
    select_the_plan: "தயவுசெய்து, திட்டத்தைத் தேர்ந்தெடுக்கவும்",
    enter_company_code: "தயவுசெய்து, நிறுவனத்தின் குறியீட்டை உள்ளிடவும்",
    enter_code: "தயவுசெய்து, குறியீட்டை உள்ளிடவும்",
    enter_valid_coupon_code: "தயவுசெய்து, சரியான கூப்பன் குறியீட்டை உள்ளிடவும்",
    coupon_alreadt_taken: "இந்த கூப்பன் குறியீடு ஏற்கனவே எடுக்கப்பட்டது",
    error_updating_plan: "திட்டத்தை புதுப்பிப்பதில் பிழை",
    unit: "அலகு",
    referrals: "பரிந்துரைகள்",
    sel_coupon: "தயவுசெய்து, கூப்பனைத் தேர்ந்தெடுக்கவும்",
    share_val_0_99: "பங்கு மதிப்பு 0 முதல் 99 வரை இருக்க வேண்டும்",
    enter_share_val: "தயவுசெய்து, பகிர்வு மதிப்பை உள்ளிடவும்",
    valid_commission_per:
      "தயவுசெய்து, செல்லுபடியாகும் விற்பனை பங்கு சதவீதத்தை உள்ளிடவும்",
    enter_commission_per: "தயவுசெய்து, விற்பனை பங்கு சதவீதத்தை உள்ளிடவும்",
    enter_commission_name: "தயவுசெய்து, விற்பனை பங்கு பெயரை உள்ளிடவும்",
    sync_successfully: "பயனர்கள் ஒத்திசைக்கிறார்கள்",
    room_deleted_suc: "அறை வெற்றிகரமாக நீக்கப்பட்டது",
    lic_deleted_suc: "உரிமம் வெற்றிகரமாக நீக்கப்பட்டது",
    female: "பெண்",
    male: "ஆண்",
    insta_conference: "உடனடி மாநாடு",
    quick_meeting_by: "விரைவு அமர்வு மூலம்",
    in_lobby: "கூடத்தில்",
    switch_to_broadcast: "ஒளிபரப்புக்கு மாறவும்",
    Broadcasters_5: "ஒளிபரப்பாளர்கள் (5)",
    Participants_5: "பங்கேற்பாளர்கள் (5)",
    search_participants: "பங்கேற்பாளர்களைத் தேடுங்கள்",
    host_controls: "தொகுப்பாளர் கட்டுப்பாடுகள்",
    deleteroom: "அறையை நீக்கு",
    pm: "PM",
    am: "AM",
    email_exist_inroom: "மின்னஞ்சல் ஏற்கனவே இந்த அறையில் உள்ளது",
    type_a_message: "ஒரு செய்தியைத் தட்டச்சு செய்க ...",
    please_enter_user_limit: "தயவுசெய்து, பயனர் வரம்பை உள்ளிடவும்",
    user_limit_exceeded: "பயனர் வரம்பு மீறப்பட்டுள்ளது",
    sel_country_code: "தயவுசெய்து, நாட்டின் குறியீட்டைத் தேர்ந்தெடுக்கவும்",
    available_storage: "கிடைக்கும் சேமிப்பு",
    enter_phone_number: "தொலைபேசி எண்ணை உள்ளிடவும்",
    startdate_less_enddate:
      "தயவுசெய்து, தொடக்க தேதியை இறுதி தேதியை விட குறைவாக தேர்ந்தெடுக்கவும்",
    havent_add_data:
      "நீங்கள் இதுவரை எந்த தரவையும் சேர்க்கவில்லை, தயவுசெய்து தரவைச் சேர்க்கவும்.",
    professional_skills: "வல்லுநர் திறன்கள்",
    enter_prof_skills: "தொழில்முறை திறன்களை உள்ளிடவும்",
    Present_Invitations: "தற்போதைய அழைப்புகள்",
    sending: "அனுப்புகிறது ...",
    sent: "அனுப்பப்பட்டது",
    invite_10ppl_only: "நீங்கள் 10 பேரை மட்டுமே அழைக்க முடியும்",
    join_meeting: "அமர்வில் சேரவும்",
    enter_doc_title: "ஆவணத் தலைப்பை உள்ளிடவும்",
    meeting_name: "அமர்வு பெயர்",
    select_the_weeks: "தயவுசெய்து, வாரங்களைத் தேர்ந்தெடுக்கவும்",
    grade: "தரம்",
    coference_ID: "மாநாட்டு ஐடி ...",
    dont_find_room_meetingid:
      "இந்த அமர்வு ஐடியுடன் தொடர்புடைய எந்த அறையும் எங்களிடம் இல்லை",
    wireless_share: "கம்பியில்லா பகிர்வு",
    video_layout: "காணொளி தளவமைப்பு",
    speaker_screen: "பேச்சாளர் திரை",
    presentation_screen: "விளக்கக்காட்சி திரை",
    multiple_display: "பல காட்சி",
    hellow: "வணக்கம்",
    enter_passcode: "கடவுக்குறியீட்டை உள்ளிடவும்",
    another_meeting_stillon:
      "மற்றொரு அமர்வு இன்னும் உள்ளது, இந்த அமர்வை நீங்கள் இப்போது தொடங்க முடியாது",
    SIP_device: "SIP சாதனம்",
    instavc_whiteBoard: "InstaVC வெண்பலகை",
    speaker: "ஒலிப்பெட்டி",
    instavc_notepad: "InstaVC குறிப்பு திண்டு",
    promote_in: "ஊக்குவிக்கவும்",
    guest: "விருந்தினர்",
    breakout_rooms: "பிரேக்அவுட் அறைகள்",
    stop_broadcast: "ஒளிபரப்பை நிறுத்து",
    noise_suppress: "சத்தம் ஒடுக்கம்",
    echo_cancel: "எதிரொலி ரத்து:",
    enter_name_here: "பெயரை இங்கே உள்ளிடவும்",
    Viewer: "பார்வையாளர்",
    SIP_user: "SIP பயனர்",
    remove_participants: "பங்கேற்பாளர்களை அகற்று",
    disable_audio_video: "தொலை கேட்பொலி மற்றும் காணொளியை முடக்கு",
    disable_audio: "கேட்பொலியை முடக்கு",
    enable_audio: "கேட்பொலியை செயல்பட செய்யவும்",
    disable_video: "காணொளியை முடக்கு",
    enable_video: "காணொளியை செயல்பட செய்யவும்",
    audio_video: "கேட்பொலி & காணொளி",
    audio_only: "கேட்பொலி மட்டும்",
    video_only: "காணொளி மட்டும்",
    outlook_addins: "அவுட்லுக் துணை நிரல்கள்",
    install_microsoft:
      "மைக்ரோசாப்ட் அவுட்லுக்கில் துணை நிரல்களை எவ்வாறு நிறுவுவது மற்றும் நிர்வகிப்பது",
    outlook_step1: "படி 1: இணைப்பை நகலெடுத்து அவுட்லுக்கைத் திறக்கவும்",
    first_copy_link: "முதலில் இணைப்பை நகலெடுக்கவும்",
    add_plugin_oulook: "இங்கே இருந்து உங்கள் அவுட்லுக்கு சொருகி சேர்க்கவும்.",
    outlook_step2: "படி 2: துணை நிரல்களைப் பெறுங்கள்",
    outlook_step2_para:
      "இப்போது அவுட்லுக்கைத் திறந்து முகப்பு தாவலின் கீழ் நீங்கள் துணை நிரல்களைப் பெற ஒரு விருப்பத்தை நீங்கள் காணலாம்.துணை நிரல்கள் மற்றும் பிற தனிப்பயன் விருப்பங்களைக் காண அதை சொடுக்கவும்.",
    outlook_step3: "படி 3: எனது துணை நிரல்கள்",
    outlook_step3_para:
      "இடது வழிசெலுத்தல் மூலம் நீங்கள் இப்போது துணை நிரல்களைக் காணலாம். உங்கள் துணை நிரல்களை நிர்வகிக்க எனது துணை நிரல்களுக்குச் செல்லவும்.",
    outlook_step4: "படி 4: தனிப்பயன் துணை நிரல்களைச் சேர்க்கவும்",
    outlook_step4_para:
      "எனது செருகுநிரல்கள் பக்கத்தில் தனிப்பயன் துணை நிரல்களின் கீழ் தனிப்பயன் செருகு நிரலைச் சேர் இங்கே காணலாம். கீழ்தோன்றலில் இருந்து URL இலிருந்து சேர் என்பதைத் தேர்ந்தெடுக்கவும்.",
    outlook_step5:
      "படி 5: இணையதள முகவரிலிருந்து தனிப்பட்ட செருகு நிரலைச் சேர்க்கவும்",
    outlook_step5_para:
      "இணையதள முகவரிலிருந்து தனிப்பட்ட செருகுநிரலைச் சேர்க்கக் கேட்கும் மேல்விரி சாளரம் ஒன்றை இப்போது நீங்கள் காணலாம். இப்போது நீங்கள் நகலெடுத்த இணைப்பை (படி 1) உள்ளீட்டு புலத்தில் ஒட்டவும், சரி என்பதைக் சொடுக்கு செய்யவும்,  அது அவுட்லுக்கிற்கு துணை நிரல்களை நிறுவுகிறது.",
    outlook_step6: "படி 6: InstaVC எனது துணை நிரல்களில் சேர்க்கப்பட்டது",
    outlook_step6_para:
      "சேர்த்த பிறகு, உங்கள் எனது துணை நிரல்கள் பட்டியலில் சேர்க்கப்பட்டதை நீங்கள் சரிபார்க்கலாம். இங்கிருந்து உங்கள் செருகு நிரல்களை மேலும் நிர்வகிக்கலாம்.",
    outlook_step7: "படி 7: அவுட்லுக்கை மூடி மீண்டும் திறக்கவும்",
    outlook_step7_para:
      "நிறுவிய பின், முழுமையாக அவுட்லுக்கை ஒரு முறை மூடிவிட்டு, நிரல்களைக் காண மீண்டும் திறக்கவும்.",
    outlook_step8: "படி 8: புதிய உருப்படிகளுக்குச் செல்லவும்",
    outlook_step8_para:
      "அவுட்லுக்கைத் திறந்த பிறகு, நீங்கள் இப்போது புதிய கூட்டங்களுக்குச் செல்லலாம்; அவுட்லுக்கில் சேர்க்கப்பட்ட இன்ஸ்டாவிசி துணை நிரல்களைக் காண சந்திப்பு.",
    outlook_step9: "படி 9: InstaVC கூட்டத்தைத் திறக்கவும்",
    outlook_step9_para:
      "நீங்கள் கூட்டங்களைத் திறந்ததும், கூட்டங்கள் தாவலின் கீழ் மேல் பட்டியில் இயக்கப்பட்ட இன்ஸ்டாவிசி சந்திப்பு துணை நிரல்களுடன் ஒரு தொகுத்தல் அஞ்சல் சாளரத்துடன் திறக்கப்படுவீர்கள்.",
    outlook_step10: "படி 10: அட்டவணையை உருவாக்குங்கள்",
    outlook_step10_para:
      "எழுது அஞ்சல் தளவமைப்பிலிருந்து, புதிய அட்டவணையை உருவாக்க Instavc கூட்டங்களில் சொடுக்கு செய்க. முதல் முறையாக இருந்தால் வலது பக்கத்தில் உள்ள இன்ஸ்டாவிசி சந்திப்பு உள்நுழைவுடன் நீங்கள் திறக்கப்படுவீர்கள். ஏற்கனவே உள்நுழைந்த பயனர்களுக்கு, அவர்கள் அறைகள் பட்டியலுக்கு அனுப்பப்படுவார்கள், மேலும் ஒரு அட்டவணையை உருவாக்க முடியும்.",
    outlook_step11: "படி 11: இன்ஸ்டாவிசி கூட்டத்தைத் திறக்கவும்",
    outlook_step11_para:
      "நீங்கள் ஒரு குறிப்பிட்ட அறையில் ஒரு கூட்டத்தைத் திட்டமிட இடது பக்கத்தில் ஒரு அட்டவணையை உருவாக்கி வலது பக்கத்தில் ஒரு அறையைத் தேர்ந்தெடுக்கலாம். நீங்கள் ஒரு அட்டவணையை உருவாக்கியதும், இப்போது தொடக்க சந்திப்பு பொத்தானைக் காணலாம். இங்கிருந்து நீங்கள் சொடுக்கு செய்து கூட்டத்தைத் தொடங்கலாம்.",
    outlook_step12: "படி 12: நாட்காட்டியில் அட்டவணையைக் காண்க",
    outlook_step12_para:
      "நீங்கள் ஒரு அட்டவணையை உருவாக்கியதும், அடுத்த முறை நீங்கள் நாட்காட்டியைத் திறக்கும்போது, ​​நாட்காட்டிலும் உங்கள் அட்டவணைகளைக் காணலாம்.",
    outlook_step13: "படி 13: அட்டவணை உருவாக்கப்பட்டது",
    outlook_step13_para:
      "நீங்கள் ஒரு அட்டவணையை உருவாக்கியதும், வலதுபுறத்தில் ஒரு தொடக்க சந்திப்பு பொத்தானுடன் இயற்றப்பட்ட அஞ்சலைக் காணலாம்.",
    sel_declaration: "தயவுசெய்து, பிரகடனத்தைத் தேர்ந்தெடுக்கவும்",
    enter_company_code: "தயவுசெய்து, நிறுவனத்தின் குறியீட்டை உள்ளிடவும்.",
    invalid_company_code: "தவறான நிறுவனத்தின் குறியீடு",
    affiliate_acc: "உங்கள் துணை கணக்கு ஒப்புதல் நிலுவையில் உள்ளது.",
    aff_acc_approved: "உங்கள் இணை கணக்கு அங்கீகரிக்கப்பட்டுள்ளது.",
    aff_acc_rej: "உங்கள் இணை கணக்கு நிராகரிக்கப்பட்டது.",
    aff_TC: "இணைப்பு விதிமுறைகள் மற்றும் நிபந்தனைகள்",
    ref_par_agreement: "பரிந்துரை கூட்டாளர் ஒப்பந்தம்",
    aff_partner_agreement:
      'இந்த கவர் பக்கம் மற்றும் இணைக்கப்பட்ட வணிக விதிமுறைகள் (கூட்டாக, இந்த "ஒப்பந்தம்") அடங்கிய இந்த கூட்டாளர் ஒப்பந்தம், பீப்பிள்லிங்க் யூனிஃபைட் கம்யூனிகேஷன்ஸ் பிரைவேட் லிமிடெட் (பீப்பிள்லிங்க் என குறிப்பிடப்படுகிறது) மற்றும் “கூட்டாளர்” அல்லது “நீங்கள் ”. "கூட்டாளர்" அல்லது "நீங்கள்" என்பது சமர்ப்பிக்கப்பட்ட படிவத்தில் விவரிக்கப்பட்ட நபர் அல்லது நிறுவனம் (நிறுவனத்தின் பெயர் மற்றும் பிற தகவல்கள் உட்பட). இந்த ஒப்பந்தத்தை நீங்கள் ஏற்றுக்கொண்டதைக் குறிக்க பரிந்துரை கூட்டாளர் நிரல் படிவத்தை ("படிவம்") பூர்த்தி செய்து சமர்ப்பித்தவுடன் ஒப்பந்தம் பிணைக்கப்படும். பீப்பிள்லிங்க் மற்றும் கூட்டாளர் சில நேரங்களில் "கட்சி" என்றும், ஒன்றாக "கட்சிகள்" என்றும் குறிப்பிடப்படுகின்றன.',
    background: "பின்னணி",
    aff_market_advertise:
      'பீப்பிள்லிங்க் இன்ஸ்டாவிசி ஒருங்கிணைந்த தகவல் தொடர்பு சேவைகள் மற்றும் தீர்வுகளை வழங்குகிறது. இந்த ஒப்பந்தத்தின் படி, பீப்பிள்லிங்க் தயாரிப்புகள் மற்றும் சாத்தியமான பீப்பிள்லிங்க் வாடிக்கையாளர்களுக்கு ("பரிந்துரைகள்") அதன் வலைத்தளம் (கள்) மற்றும் பிற சந்தைப்படுத்தல் சேனல்கள் மூலம் விளம்பரப்படுத்தவும் சந்தைப்படுத்தவும் விளம்பரப்படுத்தவும் கூட்டாளர் விரும்புகிறார்.',
    agreement: "ஒப்பந்தம்",
    aff_parties_agree: "கட்சிகள் பின்வருமாறு ஒப்புக்கொள்கின்றன:",
    heading1: "நிரல் கடமைகள்",
    heading2: "தகுதிவாய்ந்த பரிந்துரைகள், விற்பனை பங்கு”",
    heading3: "கால மற்றும் முடித்தல்",
    heading4: "பொது",
    the_program: "நிகழ்ச்சி",
    to_participate_program_partner:
      'நிரல் கூட்டாளர் பங்கேற்க, மக்கள் இணைப்பு அல்லது அதனுடன் தொடர்புடைய வலைத்தளங்களில் ("தளம்") காணப்படும் திட்டத்தில் பங்கேற்பதற்கான ஆன்லைன் விண்ணப்பத்தை பூர்த்தி செய்து இந்த ஒப்பந்தத்தை உள்ளிட வேண்டும். பீப்பிள்லிங்க் எந்தவொரு பயன்பாட்டையும் அதன் சொந்த விருப்பப்படி ஏற்கலாம் அல்லது நிராகரிக்கலாம்.',
    aff_str11: "சட்ட ஒப்பந்தங்கள்.",
    aff_str12: "பதவி உயர்வு, பரிந்துரை நடவடிக்கைகள்:",
    aff_str13: "தடைசெய்யப்பட்ட நடவடிக்கைகள்.",
    aff_str14: "மக்கள் இணைப்பு மதிப்பெண்களின் அனுமதிக்கப்பட்ட பயன்பாடு",
    aff_str15: "பொறுப்புகள்.",
    aff_str16: "வாடிக்கையாளர் உறவுகள்.",
    aff_str11_para:
      "திட்டத்தில் பங்கேற்பதன் ஒரு பகுதியாக மற்றும் பீப்பிள்லிங்கின் கூட்டாளராக செயல்படுவதில், கூட்டாளர் இதன்மூலம் இந்த ஒப்பந்தத்தின் விதிமுறைகள் மற்றும் திட்டத்தின் விதிமுறைகள், வழிகாட்டுதல்கள் மற்றும் அவ்வப்போது பீப்பிள்லிங்க் அமைக்கும் வேறு ஏதேனும் கோரிக்கைகள் மற்றும் விதிகளை அதன் நியாயமான முறையில் ஒப்புக்கொள்கிறார். விவேகம், கூட்டாளரின் திட்டத்தில் தொடர்ந்து பங்கேற்பது மற்றும் மக்கள் இணைப்பு தயாரிப்புகள், தீர்வுகள் மற்றும் பரிந்துரைகளுக்கான சேவையை மேம்படுத்துதல் தொடர்பாக. இந்த ஒப்பந்தத்தின் கீழ் அதன் அனைத்து நடவடிக்கைகளிலும், கூட்டாளர் பீப்பிள்லிங்கின் ஊக்குவிப்பு தொடர்பான குறிப்பிட்ட செயல்பாடுகளிலும், கூட்டாளர் பீப்பிள்லிங்குடன் ஒத்துழைத்து நல்ல நம்பிக்கையுடன் செயல்படுவார். இந்த ஒப்பந்தத்தில் நுழைவதன் மூலம், கூட்டாளர் மக்கள் இணைப்பின் சேவை விதிமுறைகளில் அமைக்கப்பட்டுள்ள விதிமுறைகளையும் விதிகளையும் மேலும் அங்கீகரித்து ஏற்றுக்கொள்கிறார்",
    aff_str12_para:
      "உரிமம் பெற்ற மதிப்பெண்கள் மற்றும் சந்தைப்படுத்தல் பொருட்களைப் பயன்படுத்தி பல்வேறு சந்தைப்படுத்தல் சேனல்களில் மக்கள் இணைப்பு தயாரிப்புகள் மற்றும் தீர்வுகளின் செயலில் ஊக்குவிக்க பங்குதாரர் ஒப்புக்கொள்கிறார், மேலும் இந்த ஒப்பந்தத்தின் விதிமுறைகளுக்கு இணங்க அவ்வாறு செய்யுங்கள்.",
    aff_str13_para:
      'எந்தவொரு வகையிலும் சட்டவிரோதமான, அல்லது தீங்கு விளைவிக்கும், அச்சுறுத்தும், அவதூறான, ஆபாசமான, தாக்குதல், துன்புறுத்தல், பாலியல் ரீதியான, வன்முறை, பாகுபாடு, அல்லது பீப்பிள்லிங்கின் முழு விருப்பப்படி ஆட்சேபனைக்குரிய உள்ளடக்கத்துடன் சந்தைப்படுத்தல் பொருட்களை இணைக்க வேண்டாம் என்று கூட்டாளர் ஒப்புக்கொள்கிறார். மக்கள் இணைப்பு சேவைகள் மற்றும் தீர்வுகளை மேம்படுத்துவதில் தொடர்பில்லாத பல பெறுநர்களுக்கு ("ஸ்பேமிங்") கோரப்படாத மின்னணு செய்திகளை அனுப்ப வேண்டாம், அல்லது இந்த ஒப்பந்தத்தின் கீழ் சிந்திக்கப்படும் நடவடிக்கைகள் தொடர்பாக சட்டத்தால் தடைசெய்யப்பட்ட வேறு எந்த வகையான மின்னணு தகவல்தொடர்புகளிலும் ஈடுபட கூட்டாளர் ஒப்புக்கொள்கிறார்.',
    aff_str14_para1:
      "உரிமம் பெற்ற மதிப்பெண்களைப் பயன்படுத்துவதில் மற்றும் சந்தைப்படுத்தல் பொருட்களை உருவாக்குவதில் பங்குதாரர் இங்கே உள்ள அனைத்து விதிமுறைகளுக்கும் இணங்க ஒப்புக்கொள்கிறார்.",
    aff_str14_para2:
      "வழிகாட்டுதல்கள் மூலமாகவும், இல்லையெனில், மார்க்கெட்டிங் பொருட்களை உருவாக்குவதிலும், மக்கள் இணைப்பு சேவையை மேம்படுத்துவதிலும் உரிமம் பெற்ற மதிப்பெண்களை கூட்டாளர் அனுமதிக்கும் வகையில் அவ்வப்போது விவரக்குறிப்புகள் மற்றும் பிற வழிமுறைகளை பீப்பிள்லிங்க் வழங்கும். இதுபோன்ற அனைத்து விவரக்குறிப்புகள் மற்றும் வழிமுறைகளுக்கு இணங்க கூட்டாளர் மேலும் ஒப்புக்கொள்கிறார்.",
    aff_str14_para3:
      "அதன் மார்க்கெட்டிங் பொருட்களில் தோன்றும் அனைத்து உரிமம் பெற்ற மதிப்பெண்களும் வழிகாட்டுதல்களில் மக்கள் இணைப்பால் அங்கீகரிக்கப்பட்ட வடிவத்தில் இருப்பதை பங்குதாரர் உறுதிசெய்கிறார், இல்லையெனில், எந்தவொரு பீப்பிள்லிங்க் அடையாளங்களையும் மாற்றியமைக்க மாட்டார் அல்லது பீப்பிள்லிங்க் வழங்கிய நியாயமான அறிவுறுத்தல்களுக்கு மாறாக பிற சந்தைப்படுத்தல் பொருட்களை கணிசமாக மாற்றியமைக்க மாட்டார், மேலும் மேலும் இணங்க வேண்டும் மார்க்கெட்டிங் பொருட்களின் வடிவம், உள்ளடக்கம் மற்றும் காட்சி குறித்து மக்கள் இணைப்பிலிருந்து நியாயமான வழிமுறைகளுடன். எந்தவொரு காரணத்திற்காகவும் இந்த ஒப்பந்தத்தை முடித்தவுடன், அல்லது பீப்பிள்லிங்கின் எழுத்துப்பூர்வ கோரிக்கையின் பேரில், இங்கு வழங்கப்பட்ட உரிமம் காலாவதியாகிவிடும், மேலும் இந்த ஒப்பந்தத்தின் கீழ் கூட்டாளர் அதன் அனைத்து நடவடிக்கைகளையும் உடனடியாக நிறுத்திவிடுவார்.",
    aff_str15_para:
      "இந்த ஒப்பந்தத்தின் கீழ் உருவாக்கப்பட்ட மற்றும் பயன்படுத்தப்பட்ட கூட்டாளரின் செயல்பாடுகள் மற்றும் பொருட்களின் சட்டபூர்வமான தன்மை உட்பட, இந்த ஒப்பந்தத்தின் கீழ் செயல்படுவதில் அதன் செயல்பாடுகளுக்கு பங்குதாரர் மட்டுமே பொறுப்பாவார். ஒரு பீப்பிள்லிங்க் மார்க் மூன்றாம் தரப்பினரின் வர்த்தக முத்திரை உரிமைகளை மீறுவதாகக் கூறப்படும் ஒரு கூற்றைத் தவிர, கூட்டாளரின் சந்தைப்படுத்தல் பொருட்களின் வளர்ச்சி, செயல்பாடு அல்லது உள்ளடக்கத்திற்கு பீப்பிள்லிங்க் பொறுப்பேற்காது மற்றும் எந்தவொரு உரிமைகோரல்கள், செயல்கள், காரணங்கள் கூட்டாளர் சந்தைப்படுத்தல் பொருட்களின் வளர்ச்சி, செயல்பாடு, உள்ளடக்கம் மற்றும் பராமரிப்பு தொடர்பான நடவடிக்கை, சேதங்கள் அல்லது செலவுகள் (வழக்கறிஞர் கட்டணம் உட்பட).",
    aff_str16_para:
      "காலத்தின் போதும் அதற்குப் பின்னரும், பீப்பிள்லிங்க் சேவையைப் பயன்படுத்துவதற்கு பீப்பிள்லிங்க் உடன் ஒப்பந்தம் செய்யும் பரிந்துரைகளை அடையாளம் காணும் எந்தவொரு மற்றும் அனைத்து தகவல்களும் உட்பட, பீப்பிள்லிங்க் சேவையைப் பொறுத்தவரையில் பீப்பிள்லிங்க் மற்றும் பரிந்துரைகள் மத்தியில் கூட்டாளர் வழியாக உருவாக்கப்பட்ட அனைத்து உறவுகளின் பிரத்யேக உரிமையாளராக பீப்பிள்லிங்க் இருக்கும். பீப்பிள்லிங்க் சேவைக்கான விதிமுறைகள், தனியுரிமைக் கொள்கை மற்றும் பீப்பிள்லிங்கின் விதிகள் மற்றும் நடைமுறைகள் இந்த பரிந்துரைகளுக்குப் பொருந்தும், மேலும் கூட்டாளருக்கு முன் அறிவிப்பின்றி பீப்பிள்லிங்கால் மாற்றப்படலாம், மேலும் விதிமுறைகளின் கீழ் பீப்பிள்லிங்குடனான அவர்களின் உறவுகளின் தன்மையை ரெஃபரல்ஸுக்கு தெரிவிக்க கூட்டாளர் ஒப்புக்கொள்கிறார்.",
    aff_str20_para1:
      "பீப்பிள்லிங்கிற்கு கூட்டாளரால் குறிப்பிடப்படுகிறது மற்றும் கீழேயுள்ள பிரிவு 3 (பி) இல் விவரிக்கப்பட்டுள்ள நடைமுறைக்கு ஏற்ப பதிவுபெறும் நடைமுறையை நிறைவு செய்பவர்கள்;",
    aff_str20_para2:
      "பீப்பிள்லிங்க் சேவையுடன் பீப்பிள்லிங்கிற்கு எந்த பதிவும் இல்லை, அல்லது பங்குதாரரால் பீப்பிள்லிங்கைக் குறிப்பிடும் நேரத்தில், எந்தவொரு ஒப்பந்த உறவுகளிலும் அல்லது பீப்பிள்லிங்க் சேவையுடன் மக்கள் பேச்சுவார்த்தைகளில் இல்லை;",
    aff_str20_para3:
      "விதிமுறைகளை ஏற்றுக்கொண்டு, ஒரு பரிந்துரையின் சொந்த விருப்பப்படி மற்றும் கூட்டாளரிடமிருந்து எந்தவொரு பண அல்லது பிற சலுகைகளையும் பெறாமல், பீப்பிள்லிங்க் வலைத்தளங்களில் பட்டியலிடப்பட்டுள்ள பின்வரும் மக்கள் இணைப்பு சேவை திட்ட மூட்டைகளில் குறைந்தபட்சம் வருடாந்திர சந்தாக்கள் அல்லது (iv) நிராகரிக்கப்படாதவர்கள் மக்கள் இணைப்பு, மற்றும் மக்கள் இணைப்பு சேவையைப் பெற குறைந்தபட்சம் ஒரு கட்டணம் (வருடாந்திர முன்கூட்டியே) அல்லது மூன்று கொடுப்பனவுகளை (ஆண்டு கால, மாத பில்லிங்) செய்யுங்கள்.",
    aff_str21: "பரிந்துரை நடைமுறை.",
    aff_str22: "விற்பனை பங்குகள் பொறுப்புகள்.",
    aff_str221: "பரிந்துரை கட்டணம்.",
    aff_str222: "ஒரு பரிந்துரையிலிருந்து நடந்துகொண்டிருக்கும் விற்பனை",
    aff_str223: "தொடர்புடைய கட்டணங்கள்.",
    aff_str23: "விற்பனை / விற்பனை பங்கு அறிக்கைகள்.",
    aff_str21_para:
      "ஒவ்வொரு பரிந்துரையும் கூட்டாளருக்கு பீப்பிள்லிங்க் வழங்கிய நிகழ்நிலை இணையதள முகவரி மூலம் கூட்டாளரால் பீப்பிள்லிங்கிற்கு பரிந்துரைக்கப்படும், விற்பனை செயல்முறையை பரிந்துரைக்கு ஊக்குவிப்பதில் கட்சிகளின் தொடர்ச்சியான நல்ல நம்பிக்கை ஒத்துழைப்புக்கு உட்பட்டு அனைத்து பரிந்துரைகளுக்கும் விற்பனை செயல்முறைக்கு பீப்பிள்லிங்க் பொறுப்பாகும்.",
    aff_str22_para:
      "பீப்பிள்லிங்க் சேவைக்கான பரிந்துரைகளிலிருந்து பீப்பிள்லிங்க் அனைத்து கட்டணங்களையும் நேரடியாக பரிந்துரைகளிடமிருந்து சேகரிக்கும்.",
    aff_str22_para1:
      "ஒரு பரிந்துரை ஒரு தகுதிவாய்ந்த பரிந்துரையாக மாறியவுடன், மக்கள் பட்டியலிடப்பட்ட கட்டணங்களின் அடிப்படையில் நிலுவைத் தொகையில் கூட்டாளர் பரிந்துரைக் கட்டணத்தை பீப்பிள்லிங்க் செலுத்த வேண்டும். ",
    aff_str22_para12:
      "(எந்த தள்ளுபடியையும் தவிர்த்து) தகுதிவாய்ந்த பரிந்துரை மூலம் செலுத்தப்படும். அத்தகைய பரிந்துரைக் கட்டணங்கள் செலுத்தப்பட வேண்டும் மற்றும் கட்டண சேவை தொடக்க தேதியிலிருந்து வழங்கப்பட்ட தொண்ணூறு (90) நாட்களுக்குள் பங்குதாரருக்கு செலுத்தப்படும் கட்டணக் கடமைகள் அடையப்படும்.",
    aff_str22_para2:
      "பரிந்துரை ஆரம்பத்தில் சமர்ப்பிக்கப்பட்ட தேதியிலிருந்து முதல் 90 நாட்களுக்குள் நடைபெறும் தகுதிவாய்ந்த பரிந்துரையிலிருந்து கூடுதல் விற்பனைக்கான பரிந்துரைக் கட்டணத்தை கூட்டாளர் பெறுவார்.",
    aff_str22_para3:
      "பரிந்துரைக் கட்டணத்தில் விதிக்கப்படும் அனைத்து வரிகள், கடமைகள், அரசாங்கக் கட்டணங்கள் மற்றும் பிற கட்டணங்களை செலுத்துவதற்கு பங்குதாரர் பொறுப்பேற்க வேண்டும், மேலும் பீப்பிள்லிங்கிலிருந்து வெளிவரும் அல்லது அனைத்து கட்டணங்களுடனும் எழும் அல்லது தொடர்பான எந்தவொரு உரிமைகோரல்களிலிருந்தும் அல்லது அதற்கு எதிராகவும் பீப்பிள்லிங்கை பாதிப்பில்லாமல், பாதுகாத்து வைத்திருக்கும். பரிந்துரை கட்டணம் செலுத்துதல்.",
    aff_str23_para:
      "பீப்பிள்லிங்க் தங்கள் நிகழ்நிலை முகப்புபக்க அறிக்கையில் கூட்டாளரின் விற்பனை நடவடிக்கைகள் மற்றும் பரிந்துரைகளிலிருந்து பெறப்பட்ட தகுதிவாய்ந்த பரிந்துரைகளுக்கான அதன் விற்பனை பங்குகளை சுருக்கமாகக் கூறுகிறது. பரிந்துரைகள் மற்றும் தகுதிவாய்ந்த பரிந்துரைகள் பற்றிய பெயர்கள் அல்லது பிற தனிப்பட்ட தகவல்களை மக்கள் இணைப்பு வெளியிடாது.",
    aff_str31: "ஆரம்ப காலம்.",
    aff_str32: "புதுப்பித்தல் காலம்.",
    aff_str33: "ஆரம்ப முடிவு. காரணம் இல்லாமல்.",
    aff_str34: "காரணத்திற்காக.",
    aff_str35: "முடித்தலின் விளைவு.",
    aff_str31_para:
      'இந்த ஒப்பந்தம் பயனுள்ள தேதியிலிருந்து நடைமுறைக்கு வரும், மேலும் பன்னிரண்டு (12) மாதங்களுக்கு ("ஆரம்ப கால") தொடரும், இந்த நிகழ்ச்சியில் பங்கேற்க கூட்டாளர் விண்ணப்பத்தை பீப்பிள்லிங்க் நிராகரிக்கவில்லை.',
    aff_str32_para:
      'ஆரம்ப காலத்தின் காலாவதியானதைத் தொடர்ந்து, இந்த ஒப்பந்தம் தானாகவே தொடர்ச்சியாக பன்னிரண்டு (12) மாதங்களுக்கு (ஒவ்வொன்றும், "புதுப்பித்தல் கால") புதுப்பிக்கப்படும், ஒரு கட்சி மற்ற கட்சிக்கு குறைந்தபட்சம் முப்பது (30) ) ஆரம்ப கால அல்லது ஏதேனும் புதுப்பித்தல் காலத்தின் முடிவிற்கு முந்தைய நாட்கள்.',
    aff_str33_para:
      "கூட்டாளருக்கு ஐந்து (5) நாட்களுக்கு முன்னதாக எழுதப்பட்ட அறிவிப்பை வழங்குவதன் மூலம் எந்த நேரத்திலும் எந்த காரணத்திற்காகவும் இந்த ஒப்பந்தத்தை எந்த நேரத்திலும் நிறுத்த பீப்பிள்லிங்கிற்கு உரிமை உண்டு.",
    aff_str34_para:
      "எந்தவொரு கட்சியும் இந்த ஒப்பந்தத்தை எந்த நேரத்திலும் நிறுத்தலாம், இந்த ஒப்பந்தத்தை பொருள் ரீதியாக மீறிய பிற கட்சிக்கு எழுதப்பட்ட அறிவிப்பின் பேரில் உடனடியாக அமல்படுத்தப்படலாம், இந்த ஒப்பந்தத்தை முடிப்பதற்கு முன்னர் நிறுத்தப்பட்ட கட்சி அத்தகைய பொருள் மீறல் மற்றும் முப்பது (30) நாட்கள் அத்தகைய மீறலை குணப்படுத்த மீறும் கட்சிக்கு வாய்ப்பு.",
    aff_str35_para:
      "இந்த ஒப்பந்தம் முடிவடைந்த தேதியிலிருந்து மற்றும் பின்வருபவை இந்த ஒப்பந்தத்தின் கீழ் கூட்டாளரின் உரிமைகள் நிறுத்தப்படும், மேலும் இந்த ஒப்பந்தத்தின் முடிவிற்கு முன்னர் சம்பாதித்த அல்லது சம்பாதித்த விற்பனை பங்குகள் அல்லது கொடுப்பனவுகளைத் தவிர வேறு எந்த பரிந்துரைக் கட்டணங்களையும் அல்லது இந்த ஒப்பந்தத்தின் கீழ் வேறு எந்தவொரு கொடுப்பனவுகளையும் பெற பங்குதாரருக்கு உரிமை இல்லை.",
    aff_str41: "வகுப்பீடு.",
    aff_str42: "அறிவுசார் சொத்து உரிமைகள்.",
    aff_str43: "தள்ளுபடி இல்லை.",
    aff_str44: "வரையறுக்கப்பட்ட உத்தரவாதம்.",
    aff_str45: "உத்தரவாதத்தின் மறுப்பு.",
    aff_str46: "பொறுப்பிற்கான வரம்பு.",
    aff_str47: "சுயாதீன ஒப்பந்தக்காரர்கள்.",
    aff_str48: "இழப்பீடு.",
    aff_str49: "கட்டாய மஜூர்",
    aff_str410: "முழு ஒப்பந்தம்; தீவிரத்தன்மை.",
    aff_str411: "எதிர் பகுதிகள்;அறிவிப்புகள்.",
    aff_str412: "ஆளும் சட்டம்; அதிகார வரம்பு; சர்ச்சைத் தீர்வு.",
    aff_str41_para:
      "மக்கள் ஒப்பந்தத்தை எந்த நேரத்திலும் ஒதுக்கலாம். பீப்பிள்லிங்கின் முன் எழுத்துப்பூர்வ அனுமதியின்றி கூட்டாளர் இந்த ஒப்பந்தத்தை ஒதுக்கவோ மாற்றவோ கூடாது, அத்தகைய ஒப்புதல் நியாயமற்ற முறையில் நிறுத்தப்படக்கூடாது.",
    aff_str42_para:
      "பீப்பிள்லிங்க் மதிப்பெண்கள், பீப்பிள்லிங்க் சேவை மற்றும் உலகெங்கிலும் உள்ள தொடர்புடைய உள்ளடக்கம் மற்றும் தொழில்நுட்பம் (பீப்பிள்லிங்க் ஐபி உரிமைகள்) பீப்பிள்லிங்க் மற்றும் அதன் துணை நிறுவனங்களின் பிரத்யேக சொத்தாக அவை இருக்கும். உரிமம் பெற்ற மதிப்பெண்களைப் பயன்படுத்துவதற்கான பங்குதாரரின் உரிமை பீப்பிள்லிங்கின் விருப்பப்படி உள்ளது, மேலும் இந்த ஒப்பந்தத்தின் விதிமுறைகள், வழிகாட்டுதல்கள் மற்றும் பொருந்தக்கூடிய அனைத்து சட்டங்கள் மற்றும் விதிமுறைகளுடன் கூட்டாளர் இணங்குவதற்கு உட்பட்டது. கூட்டாளர் ஒப்புக்கொள்கிறார் (அ) இந்த ஒப்பந்தத்தை மீறுவதற்கு நியாயமான முறையில் எந்த பீப்பிள்லிங்க் ஐபி உரிமைகளையும் பயன்படுத்த வேண்டாம்; (ஆ) எந்தவொரு மக்கள் இணைப்பு ஐபி உரிமைகளுக்கும் போட்டியிடும் அல்லது பலவீனப்படுத்தும் எதையும் செய்ய வேண்டாம்; (இ) எந்தவொரு மக்கள் இணைப்பு ஐபி உரிமைகளுக்கும் கணிசமாக ஒத்த எந்தவொரு அறிவுசார் சொத்துரிமைகளையும் (வர்த்தக முத்திரைகள், வர்த்தக பெயர்கள், லோகோக்கள், காப்புரிமைகள், பதிப்புரிமை, டொமைன் பெயர்கள் மற்றும் வழித்தோன்றல் உரிமைகள் போன்றவை) உருவாக்கவோ பெறவோ கூடாது; (ஈ) கூட்டாளர் உண்மையான அறிவைக் கொண்ட எந்தவொரு பீப்பிள்லிங்க் ஐபி உரிமைகளின் அங்கீகாரமற்ற பயன்பாட்டை உடனடியாக பீப்பிள்லிங்கிற்கு அறிவிக்கவும்; மற்றும் (இ) வழிகாட்டுதல்களுக்கு இணங்க எப்போதும் உரிமம் பெற்ற மதிப்பெண்கள் மற்றும் பிற மக்கள் இணைப்பு மதிப்பெண்களைப் பயன்படுத்துங்கள். கூட்டாளர் வழங்கிய எந்தவொரு சந்தைப்படுத்தல் பொருட்களின் பீப்பிள்லிங்க் அவ்வப்போது மதிப்புரைகளைச் செய்யக்கூடும், மேலும் கூட்டாளர் வழங்கிய எந்தவொரு சந்தைப்படுத்தல் பொருட்களையும் அகற்றவும் / அல்லது திருத்தவும் உத்தரவிட பிரத்யேக அதிகாரமும் விவேகமும் இருக்கும்.",
    aff_str43_para:
      "இந்த ஒப்பந்தத்தின் எந்தவொரு விதியையும் மற்ற கட்சியின் கடுமையான செயல்திறனை அமல்படுத்துவதில் கட்சி தோல்வியுற்றது, அத்தகைய ஏற்பாட்டை அல்லது இந்த ஒப்பந்தத்தின் வேறு ஏதேனும் விதிமுறைகளை அமல்படுத்துவதற்கான முதல் கட்சியின் உரிமையை விட்டுக்கொடுப்பதாக இருக்காது.",
    aff_str44_para:
      "காலப்பகுதியில் எல்லா நேரங்களிலும் அவை பொருந்தக்கூடிய அனைத்து சட்டங்கள், ஒழுங்குமுறைகள், நடைமுறைக் குறியீடுகள் மற்றும் இந்த ஒப்பந்தம், விதிமுறைகள், தனியுரிமைக் கொள்கை மற்றும் வழிகாட்டுதல்களுடன் இணங்குகின்றன என்று இரு கட்சிகளும் உத்தரவாதம் அளிக்கின்றன. எந்தவொரு காரணத்திற்காகவும், எந்தவொரு காரணத்திற்காகவும் அது நிறுத்தப்பட்ட பின்னர், பீப்பிள்லிங்கின் வணிகம், ஆர்வங்கள் அல்லது நற்பெயருக்கு சேதம் விளைவிக்கும் என்று நியாயமான முறையில் எதிர்பார்க்கக்கூடிய எதையும் செய்யக்கூடாது என்று கூட்டாளர் வெளிப்படையாக மேற்கொள்கிறார், மேலும் எந்தவொரு இழிவான கருத்துக்களையும் வெளியிடவோ, அனுமதிக்க மாட்டார். மக்கள் இணைப்பு, அதன் பிரதிநிதிகள் அல்லது மக்கள் இணைப்பு சேவை குறித்து.",
    aff_str45_para:
      "முந்தைய துணை (இ) இன் கீழ் பீப்பிள்லிங்கின் எக்ஸ்பிரஸ் உத்தரவாதத்தைத் தவிர, பீப்பிள்லிங்க் வேறு எந்த உத்தரவாதத்தையும், வெளிப்படுத்தவோ அல்லது மறைமுகமாகவோ செய்யாது, மேலும் எந்தவொரு உத்தரவாதங்களையும் நிபந்தனைகளையும் பீப்பிள்லிங்க் வெளிப்படையாக மறுக்கிறது, இதில் எந்தவொரு வணிகரீதியான உத்தரவாதமும், ஒரு குறிப்பிட்டவருக்கான உடற்தகுதி உட்பட இந்த ஒப்பந்தத்தின் பொருள் நோக்கம், கிடைக்கும் தன்மை, பாதுகாப்பு, தலைப்பு மற்றும் / அல்லது மீறல்.",
    aff_str46_para:
      "பீப்பிள்லிங்க் அல்லது எந்தவொரு அதிகாரி, பணியாளர், இயக்குனர் அல்லது பீப்பிள்லிங்கின் வேறு எந்த பிரதிநிதியும் கூட்டாளர் அல்லது எந்தவொரு மூன்றாம் தரப்பினருக்கும், இந்த ஒப்பந்தம் அல்லது அதன் முடிவின் கீழ் அல்லது ஒப்பந்தம், ஒப்பந்தத்திற்கு முந்தைய, டார்ட் அல்லது வேறுவழியில் (i ) எந்தவொரு பொருளாதார இழப்பும் (வருவாய் இழப்பு, இலாபங்கள், ஒப்பந்தங்கள், வணிகம் அல்லது எதிர்பார்க்கப்பட்ட சேமிப்பு உட்பட) அல்லது (ii) நல்லெண்ணம் அல்லது நற்பெயரின் இழப்பு. இத்தகைய இழப்புகள் வரம்பில்லாமல், எந்தவொரு சிறப்பு, மறைமுக, தற்செயலான, சட்டரீதியான, தண்டனையான, அல்லது அதன் விளைவாக ஏற்படும் இழப்புகள் அல்லது சேதங்கள் மற்றும் செயல்பாடுகளின் குறுக்கீட்டால் ஏற்படும் இழப்புகள் அல்லது சேதங்கள் ஆகியவை அடங்கும். கட்சிகளிடையே எந்தவொரு உறவையும் சுற்றியுள்ள வேறு சூழ்நிலைகள் அல்லது புரிதல்கள் இருந்தபோதிலும், இந்த ஒப்பந்தத்தின் கீழ் கூட்டாளருக்கான பீப்பிள்லிங்கின் முழுப் பொறுப்பும் இந்த ஒப்பந்தத்தின் கீழ் கூட்டாளரால் செய்யப்பட்ட எந்தவொரு சேதத்திற்கும் எந்தவொரு மற்றும் அனைத்து உரிமைகோரல்களுக்கும் INR (இந்திய ரூபாய் ஆயிரம் மட்டும்) ஐ விட அதிகமாக இருக்காது. இந்த ஒப்பந்தத்தில் நுழைவதன் மூலம் பீப்பிள்லிங்கின் பொறுப்பு குறித்த வரம்புகளை கூட்டாளர் அங்கீகரிக்கிறார்.",
    aff_str47_para:
      "இங்குள்ள கட்சிகள் சுயாதீன ஒப்பந்தக்காரர்களாக தங்கள் சார்பாக செயல்படுகின்றன. இந்த ஒப்பந்தத்தில் குறிப்பிடப்பட்டுள்ள உறவுகளுக்கு அப்பாற்பட்ட எந்தவொரு கூட்டுத் தொழில், நிறுவனம், உரிமையாளர், விற்பனை பிரதிநிதி, வேலைவாய்ப்பு அல்லது கட்சிகளுக்கிடையில் வேறு எந்த உறவையும் இந்த ஒப்பந்தத்தில் எதுவும் உருவாக்க முடியாது, மேலும் பீப்பிள்லிங்க் சார்பாக செயல்படுவதிலிருந்து கூட்டாளர் வெளிப்படையாக விலக்கப்படுகிறார். இந்த ஒப்பந்தத்தின் கீழ் பங்குதாரரின் உரிமம் பெற்ற மதிப்பெண்கள், கூட்டாளர் வழங்கிய பிற உள்ளடக்கம், அல்லது கூட்டாளர் மற்றும் மூன்றாம் தரப்பினரிடையேயான தொடர்பு ஆகியவை இங்கு விவரிக்கப்பட்டுள்ள உறவுகளை தவறாக சித்தரிக்காது.",
    aff_str48_para:
      'பீப்பிள்லிங்க் மற்றும் அதன் துணை நிறுவனங்கள், துணை நிறுவனங்கள், அதிகாரிகள் மற்றும் ஊழியர்கள் ("பீப்பிள்லிங்க் நஷ்டஈடு பெற்ற கட்சிகள்") எந்தவொரு செலவுகள், பொறுப்புகள், இழப்புகள் மற்றும் செலவினங்களிலிருந்து (நியாயமான வக்கீல் கட்டணங்கள் உட்பட ஆனால் அவை மட்டுமின்றி) பாதிப்பில்லாதவை, பங்குதாரர் இழப்பீடு, பாதுகாத்தல் மற்றும் வைத்திருத்தல். பின்வருவனவற்றில் இருந்து எழும் பீப்பிள்லிங்க் இழப்பீடு இல்லாத கட்சிகளுக்கு எதிராக எந்தவொரு மூன்றாம் தரப்பினரால் கொண்டுவரப்பட்ட எந்தவொரு உரிமைகோரல், வழக்கு, நடவடிக்கை, கோரிக்கை அல்லது நடவடிக்கை: (i) கூட்டாளர் ஒப்பந்தத்தை மீறுதல்; (ii) கூட்டாளர் அல்லது அதன் ஊழியர்கள், முகவர்கள் அல்லது ஒப்பந்தக்காரர்களின் அலட்சியம், மொத்த அலட்சியம் அல்லது வேண்டுமென்றே தவறான நடத்தை; அல்லது (iii) இங்கு குறிப்பிடப்பட்டுள்ள சட்டங்கள் மற்றும் விதிமுறைகளுக்கு இணங்க பங்குதாரர் அல்லது அதன் ஊழியர்கள், முகவர்கள், ஒப்பந்தக்காரர்கள் அல்லது அழைப்பாளர்களால் தோல்வி.',
    aff_str49_para:
      'ஒரு கட்சி தனது கடமைகளை இங்கு செய்ய கடமைப்பட்டிருக்காது. "ஃபோர்ஸ் மேஜூர்" நிகழ்வுகளில் கடவுளின் செயல்கள், அரசாங்கத்தின் செயல்கள், இயற்கையின் செயல்கள், வேலைநிறுத்தங்கள் அல்லது கலவரங்கள் உள்ளிட்ட கட்சிகளின் நியாயமான கட்டுப்பாட்டிற்கு அப்பாற்பட்ட நிகழ்வுகள் அடங்கும், அத்துடன் மக்கள் இணைப்புகள் வழங்குநர்களின் முறையற்ற செயல்திறன் அல்லது பொருள்கள், பொருட்கள் அல்லது மென்பொருளில் உள்ள குறைபாடுகள் ஆகியவை அடங்கும். மூன்றாம் தரப்பினரின். பலவந்தமான சூழ்ச்சியின் நிலைமை முப்பது (30) நாட்களுக்கு மேல் நீடித்தால், மற்ற கட்சிக்கு எழுத்துப்பூர்வ அறிவிப்பின் பேரில் கட்சி இந்த ஒப்பந்தத்தை நிறுத்தலாம்.',
    aff_str410_para:
      "இந்த ஒப்பந்தம் அதன் பொருள் மற்றும் கட்சிகளின் அந்தந்த கடமைகள் மற்றும் கடமைகள் தொடர்பான கட்சிகளிடையே உள்ள முழு ஒப்பந்தத்தையும் குறிக்கிறது. கட்சிகளிடையே வேறு எந்த ஆவணங்களும் அல்லது வாய்வழி அல்லது எழுதப்பட்ட ஒப்பந்தங்களும் இந்த ஒப்பந்தத்தில் குறிப்பிடப்பட்டுள்ள ஒப்பந்தங்களைப் பற்றி எந்த வகையிலும் பிரதிபலிக்கவில்லை, மேலும் இரு தரப்பினரும் நிறைவேற்றிய எழுத்தில் தவிர இந்த ஒப்பந்தம் மாற்றப்படாது. எப்போது வேண்டுமானாலும், இந்த ஒப்பந்தத்தின் ஒவ்வொரு ஏற்பாடும் பொருந்தக்கூடிய சட்டத்தின் கீழ் பயனுள்ள மற்றும் செல்லுபடியாகும் வகையில் விளக்கப்படும், ஆனால் இந்த ஒப்பந்தத்தின் எந்தவொரு ஏற்பாடும் தடைசெய்யப்பட்டால் அல்லது பொருந்தக்கூடிய சட்டத்தின் கீழ் செல்லுபடியாகாது எனில், அத்தகைய ஏற்பாடு பயனற்றதாக இருக்கும் அத்தகைய தடை அல்லது செல்லுபடியாகாத அளவு, அத்தகைய ஏற்பாட்டின் மீதமுள்ள அல்லது இந்த ஒப்பந்தத்தின் மீதமுள்ள விதிகளை செல்லாது.",
    aff_str411_para:
      "இந்த ஒப்பந்தம் சகாக்களில் கையெழுத்திடப்படலாம், மேலும் இதுபோன்ற சகாக்கள் செல்லுபடியாகும் மற்றும் அசல் கையொப்பங்கள் பரிமாறிக்கொள்ளப்பட்டதைப் போலவே கட்சிகளிடமும் பிணைக்கப்படும்.",
    aff_str412_para:
      "இந்த ஒப்பந்தம் ஹைதராபாத், தெலுங்கானா, இந்தியாவின் சட்ட வரம்புகளால் நிர்வகிக்கப்படும், சட்ட முரண்பாடுகளின் எந்தவொரு கொள்கைகளையும் செயல்படுத்தாமல். இந்தியாவின் தெலுங்கானா, ஹைதராபாத் மாவட்ட நீதிமன்றங்களில் அதிகார வரம்பு பிரத்தியேகமாக இருக்கும். இந்த ஒப்பந்தத்தில் இருந்து எழும் எந்தவொரு வழக்குக்கும் ஒரே மற்றும் பிரத்தியேக அதிகார வரம்பு மற்றும் இடம் ஹைதராபாத், தெலுங்கானா, இந்தியாவில் அமைந்துள்ள பொருத்தமான மாவட்ட அல்லது மாநில நீதிமன்றமாக இருக்கும், மேலும் கட்சிகள் எழுப்ப வேண்டாம் என்று ஒப்புக்கொள்கின்றன, இதன்மூலம் இடத்தின் அடிப்படையில் எந்தவொரு ஆட்சேபனைகளையும் பாதுகாப்புகளையும் தள்ளுபடி செய்கின்றன. அல்லது மன்றம் அச on கரியம். இந்த ஒப்பந்தத்தின் கீழ் அல்லது தொடர்புடைய எந்தவொரு சட்ட நடவடிக்கையையும் தொடங்குவதற்கு முன்பு, ஒரு கட்சி மற்ற தரப்பினருக்கு ஒரு சர்ச்சை குறித்த எழுத்துப்பூர்வ அறிவிப்பை வழங்கும், மேலும் முப்பது (30 க்குள் ) அத்தகைய அறிவிப்பைப் பெற்ற வணிக நாட்கள்.",
    aff_str40: "ஒப்பந்தத்தின் மாற்றம்.",
    aff_str40_para:
      "தளத்தில் மாற்றத்தை இடுகையிடுவதன் மூலம் (www.peoplelinkvc.com/affiliatestermsofservice இல்) அல்லது மின்னஞ்சல் வழியாக கூட்டாளருக்கு அறிவிப்பதன் மூலம் மக்கள் ஒப்பந்தத்தை அவ்வப்போது அதன் நியாயமான விருப்பப்படி மாற்றியமைக்கலாம். அத்தகைய மாற்றத்தை கூட்டாளர் எதிர்த்தால், கூட்டாளர் இந்த ஒப்பந்தத்தை காரணத்திற்காக நிறுத்தலாம். இந்த ஒப்பந்தத்தில் மாற்றங்கள் குறித்த அறிவிப்பைப் பெற்றதைத் தொடர்ந்து கூட்டாளர் தொடர்ந்து பங்கேற்பது இந்த ஒப்பந்தத்தை திருத்தப்பட்டதாக ஏற்றுக்கொள்வதாகும்.",
    qualified_ref: "தகுதிவாய்ந்த பரிந்துரைகள்",
    mean_referrals: "சராசரி பரிந்துரைகள்",
    apply: "விண்ணப்பிக்கவும்",
    company_code_validate: "சரிபார்க்க, நிறுவனத்தின் குறியீட்டை உள்ளிடவும்",
    golive_company_code: "கோலிவ் கம்பெனி குறியீடு",
    accept_TC:
      "மேற்கண்ட விதிமுறைகளையும் நிபந்தனைகளையும் நான் ஏற்றுக்கொள்கிறேன்",
    by_sub_referral:
      "பரிந்துரை கூட்டாளர் விண்ணப்பத்தை சமர்ப்பிப்பதன் மூலம், கூட்டாளர் இந்த ஒப்பந்தத்தை படித்தார், புரிந்துகொள்கிறார், ஏற்றுக்கொள்கிறார் என்பதை பிரதிநிதித்துவப்படுத்துகிறார் மற்றும் உத்தரவாதம் அளிக்கிறார்.",
    term: "விதிமுறை",
    found_at: "இல் காணப்பட்டது",
    our_privacy_policy: "எங்கள் தனியுரிமைக் கொள்கை",
    privacy_policy: "தனியுரிமைக் கொள்கை",
    as_applicable: "பொருந்தும்.",
    "screen-sharing": "திரை பகிர்வு",
    whiteboard_access: "வைட்போர்டு அணுகல்",
    Document_access: "ஆவண அணுகல்",
    share_the_screen: "திரையைப் பகிரவும்!",
    to_collaborate: "ஒத்துழைக்க!",
    share_document: "பகிர்வு ஆவணம்!",

    exit_or_end: "வெளியேறு அல்லது அமர்வை முடிக்கவா?",
    exit_from_meeting: "அமர்விலிருந்து வெளியேறவா?",
    are_sure_exit_meeting_everyone:
      "அமர்விலிருந்து நிச்சயமாக வெளியேற விரும்புகிறீர்களா? நீங்கள் அனைவருக்கும் அமர்வை முடிக்கலாம் அல்லது மீட்டிங்கில் இருந்து வெளியேறலாம்.",
    are_sure_exit_meeting:
      "அமர்விலிருந்து நிச்சயமாக வெளியேற விரும்புகிறீர்களா?",
    exit_meeting: "அமர்விலிருந்து வெளியேறு",
    end_for_all: "அனைவருக்கும் அமர்வு முடிவு",
    end_meeting: "அமர்வு முடிவு",
    will_let_alone_exit:
      "அமர்விலிருந்து வெளியேறவும் அல்லது வெளியேறவும் உங்களை அனுமதிக்கும்.",
    will_end_for_everyone:
      "மாநாட்டில் உள்ள அனைவருக்கும் (அனைத்து பங்கேற்பாளர்கள் மற்றும் பங்கேற்பாளர்கள்) அமர்வு முடிவடையும்.",
    user_already_exists: "பயனர்கள் ஏற்கனவே உள்ளனர்",
    already_user_avail: "மாநாட்டில் ஏற்கனவே சில பயனர்கள் உள்ளனர். ",
    if_like_continue: "நீங்கள் தொடர விரும்பினால், கிளிக் செய்யவும்",
    force_start_meetinh: "மற்றொரு அமர்வை கட்டாயப்படுத்தவும் ",
    otherwise_click: "இல்லையெனில், கிளிக் செய்யவும்",
    to_go_back: "திரும்பிச்செல்ல. ",

    //New by Keerthi - 17th Sep 2020
    lang_settings: "மொழி அமைப்புகள்",
    lang_info:
      "பயன்பாட்டைப் பயன்படுத்த உங்களுக்கு விருப்பமான மொழியைத் தேர்ந்தெடுக்கவும்.",
    select_language: "மொழியை தேர்ந்தெடுங்கள்",
    settings_languages: "மொழிகள்",

    rec_plugin: "Recording Plugin",
    rec_heading1:
      "How to install and manage InstaVC Screen-Video Recorder with the plugin",
    rec_step1: "Step 1: Copy & open Link in Chrome",
    rec_step1_para: "First copy the link ",
    rec_step1_para_br:
      "from here and open it in chrome to add the plugin to your browser. Click on ",
    rec_step1_para_bold: "Add to Chrome",
    rec_step1_para_ct: "to add this extension.",

    rec_step2: "Step 2: Pop Up for Permission",
    rec_step2_para_br:
      "When you click on Add to chrome, here appears a popup asking for permission to display notification access your content. Click on ",
    rec_step2_para_bold: "Add Extension",
    rec_step2_para_ct: "to proceed.",

    rec_step3: "Step 3: Extension Added to Chrome",
    rec_step3_para:
      "When the extension is added to chrome, it shows a window giving you an information with a plugin icon and how to manage this plugin from here.",

    rec_step4: "Step 4: Pin the plugin on the toolbar",
    rec_step4_para_br:
      "To pin the plugin to your toolbar, you need to click on manage extensions, go to ",
    rec_step4_para_bold: "InstaVC Screen-Recording",
    rec_step4_para_ct: "and click on the pin icon to add.",

    rec_step5: "Step 5: Extension/Plugin Pinned to Toolbar",
    rec_step5_para:
      "Once the extension is pinned, you can now see an instavc recording icon in your browser toolbar and start using it for easy access.",

    rec_step6: "Step 6: InstVC Recorder Setup",
    rec_step6_para_br:
      "Once you have installed the plugin and the next time when you open it, you can now see the ",
    rec_step6_para_bold: "InstaVC Recorder Setup",
    rec_step6_para_ct:
      "page to enable or disable the recording tools. By default both the options will be enabled. Click on ",
    rec_step6_para_bold1: "Next",
    rec_step6_para_ct1: "to continue.",

    rec_step7: "Step 7: Additional Permissions",
    rec_step7_para_br:
      "Once the Next button is clicked, system will then show you a popup asking for additional permissions to read and change your data. Click ",
    rec_step7_para_bold: "Allow",
    rec_step7_para_ct: "to continue.",

    rec_step8: "Step 8: Permissions Allowed",
    rec_step8_para:
      "After allowing the permission, this page now gets frozen or in a disabled mode from where you can now start exploring recording options now.",

    rec_heading2: "Desktop Screen-Recording Plugin",

    rec_step9: "Step 9: Desktop Screen-Recording",
    rec_step9_para_br:
      "After allowing all permissions, you can now access recording menus from the plugin extension in your toolbar. Click on it to see further options. Here we have selected ",
    rec_step9_para_bold: "Desktop Screen Recording",
    rec_step9_para_ct: "and click on the",
    rec_step9_para_bold1: "Record",
    rec_step9_para_ct1: "button to start.",

    rec_step9a: "Step 9(a): Share your Screen Popup",
    rec_step9a_para_br:
      "Now the system shows up this popup asking to select the contents of your screen, whether its an Entire Screen or only application window. Click on the tab which you want to share and click on ",
    rec_step9a_para_bold: "Share",
    rec_step9a_para_ct:
      "button and go to that screen which you want to start recording.",

    rec_step9b: "Step 9(b): Desktop Screen Recording Started",
    rec_step9b_para_br:
      "The Desktop Screen recording is now started and you can see a blink in the toolbar while its in recording mode. Also, you can see a tab at the bottom showing buttons for ",
    rec_step9b_para_bold: "Stop Sharing",
    rec_step9b_para_ct: "or",
    rec_step9b_para_bold1: "Hide",
    rec_step9b_para_ct1:
      ". You can see the bottom message on any screen you are opening until you are in the desktop screen recording mode.",

    rec_step9c: "Step 9(c): Restart / Pause or Stop Desktop Screen Recording",
    rec_step9c_para_br:
      "Once you want to stop Recording. Click on the plugin in the toolbar and here you can see the options to ",
    rec_step9c_para_bold: "Restart, Pause",
    rec_step9c_para_ct: "and",
    rec_step9c_para_bold1: "Stop",
    rec_step9c_para_ct1: "buttons. You can click any of those accordingly.",

    rec_step9d: "Step 9(d):Recent Recording View",
    rec_step9d_para_br:
      "Once you stop the recording from the toolbar, the recent recording will now automatically open the recording in a new tab along with Title and ",
    rec_step9d_para_bold: "Download",
    rec_step9d_para_ct:
      "option in the top and the recording details in the right column.",

    rec_heading3: "Browser Tab Screen-Recording Plugin",

    rec_step10: "Step 10: Browser Tab Screen-Recording",
    rec_step10_para_br: "When we want to select ",
    rec_step10_para_bold: "Browser Tab",
    rec_step10_para_ct:
      "option for recording your browser screen. First open your screen(url) in chrome whichever you want to record and then open the plugin and click on Browser Tab, adjust microphone options and then click",
    rec_step10_para_bold1: "Record",
    rec_step10_para_ct1: "button to start recording.",

    rec_step10a: "Step 10(a): Browser Tab is being Recorded",
    rec_step10a_para:
      "Once the Browser tab is started recording, you can see a red dot blinking in your toolbar which indicates the tab is being recorded and also a blue box blinking in your browser title bar",

    rec_step10b: "Step 10(b): Record another tab",
    rec_step10b_para_br:
      "At the time of current screen recording, if you open another url and open the plugin, it will show you the recording status along with an option",
    rec_step10b_para_bold: "Record This Tab",
    rec_step10b_para_ct:
      "if you want to change the recording scree to the new url. Meanwhile the blue box blinking in the title bar of the browser indicates the tab that is being recorded at the moment.",

    rec_step10c: "Step 10(C): Stop and View recording",
    rec_step10c_para_br:
      "Later, when you stop the recording, the browser itself opens the recording in a new tab along with Title and",
    rec_step10c_para_bold: "Download",
    rec_step10c_para_ct:
      "Option at the top and the recording details in the right column.",

    rec_heading4: "Webcam Recording",

    rec_step11: "Step 11: Start Webcam Screen Recording",
    rec_step11_para_br:
      "When you start with Webcam screen recording, make sure to select the microphone & camera settings among the devices detected by the plugin. and then click on the",
    rec_step11_para_bold: "Record",
    rec_step11_para_ct: "button to start with.",

    rec_step11a: "Step 11(a): Webcam opens Self Video and starts Recording",
    rec_step11a_para_br:
      "The recording opens a web page with yourself video with",
    rec_step11a_para_bold: "Pause",
    rec_step11a_para_ct: "and",
    rec_step11a_para_bold1: "Stop",
    rec_step11a_para_ct1: "recording options at the bottom.",

    rec_step11b: "Step 11(b): View Webcam Recorded Video",
    rec_step11b_para:
      "When you stop the recording in the previous screen, the browser then opens the recording in a new tab to view and download along with the recording details.",

    rec_heading5: "Top Menus in Recording Plugin",

    rec_step12: "Step 12: Navigation Menus",
    rec_step12_para_br:
      "The plugin has few navigation menus to fetch your data as well as manage different actions related to the plugin. One of them is a",
    rec_step12_para_bold: "Hamburger Menu",
    rec_step12_para_ct: "Click on it to open.",

    rec_step12a: "Step 12(a): Open Hamburger Menu",
    rec_step12a_para_br: "On click of",
    rec_step12a_para_bold: "Hamburger Menu",
    rec_step12a_para_ct: ", you can find 2 tabs named",
    rec_step12a_para_bold1: "My Recordings",
    rec_step12a_para_ct1: "and",
    rec_step12a_para_bold2: "Options",
    rec_step12a_para_ct2:
      "which manages all the data you have been recording and options you have enabled or disabled for that plugin. Click on",
    rec_step12a_para_bold3: "My Recordings",
    rec_step12a_para_ct3: "to see the videos you have recorded till date.",

    rec_step12b: "Step 12(b): Access My Recordings",
    rec_step12b_para_br: "There is another way of accessing",
    rec_step12b_para_bold: "My Recordings",
    rec_step12b_para_ct:
      ", page from the top menu in the plugin which can be considered as a shortcut to navigate.",

    rec_step12c: "Step 12(c): My Recordings",
    rec_step12c_para:
      "Here will be the detailed list of videos(recordings) you have recorded till date. Each video contains the date, duration, size of the video along with delete icon in the thumbnail view. When you click on any video it opens the details in the view recording page. Note that all the videos will be stored locally here.",

    rec_step12d: "Step 12(d): Delete All recordings",
    rec_step12d_para_br:
      "Looking at My recordings Page, there is a more icon in the top right corner which opens the",
    rec_step12d_para_bold: "Delete All",
    rec_step12d_para_ct:
      "option to easily delete all recordings with a single click.",

    rec_step12e: "Step 12(e): Side Navigation",
    rec_step12e_para_br:
      "Instead of opening the plugin again and change, You can directly navigate to another tab from here using the Hamburger Menu in the top left corner of the page that opens the navigation to navigate to the",
    rec_step12e_para_bold: "Options",
    rec_step12e_para_ct: "page",

    rec_heading6: "Plugin Options",

    rec_step13: "Step 13: Plugin Options",
    rec_step13_para_br:
      "On click on Hamburger Menu, you can find another tab named Options which manages all the options you have enabled or disabled for that plugin. Click on",
    rec_step13_para_bold: "Options",
    rec_step13_para_ct: "to see the options that are enabled for you.",

    rec_step13a: "Step 13(a): Recorder Options",
    rec_step13a_para:
      "Recorder Options ask you for various options like video storage, Notifications, Keyboard Shortcuts",

    rec_step13b: "Step 13(b): Recorder Options",
    rec_step13b_para:
      "Recorder Options contain various other options like Recording Settings and advanced.",

    rec_heading7: "Plugin Notifications",

    rec_step14: "Step 14: Plugin Notifications",
    rec_step14_para:
      "On the top navigation part, you can find a bell icon for notifications if any related to instavc screen recording plugin.",

    rec_step14a: "Step 14(a): Open Notifications",
    rec_step14a_para:
      "On click on the notification icon, you can find the list of notifications if any or it shows an empty slide in.",

    rec_heading8: "Recording Settings",

    rec_step15: "Step 15: Settings",
    rec_step15_para_br:
      "Then comes the last navigation menu on the top right corner named",
    rec_step15_para_bold: "Settings",
    rec_step15_para_ct:
      "where you can open and manage the recording settings accordingly.",

    rec_step15a: "Step 15(a): Advanced Settings Options",
    rec_step15a_para:
      "Here you can adjust the settings based on the Resize tab, Limit resolution and maximum frame rate which are given by plugin.",

    crteContent_upload_medialist: "Uploaded Media List",
    content_upld_desc_txt:
      "The files you upload here will be available to users who view content.",
    content_browse_txt: "Browse Files to Upload",
    content_upld_types:
      "Files with only .jpg, .jpeg, .png, and .pdf are allowed limiting the max size upto 15MB",

    video_qlty: "வீடியோ தரம்",
    audio_qlty: "ஆடியோ தரம்",
    cntnt_shrng: "உள்ளடக்க பகிர்வு",
    fdb_poor: "ஏழை",
    fdb_good: "நல்ல",
    fdb_avg: "சராசரி",
    fdb_excellent: "அருமை",
    share_feedback: "உங்கள் ஃபீட்பேக்கைப் பகிரவும்",
    ovrl_rating: "ஒட்டுமொத்த மதிப்பீடு",
    fdb_cmnts: "உங்கள் கருத்துகள் மிகவும் பாராட்டப்படுகின்றன",
    no_thnks: "இல்லை நன்றி",
    upload_size_max_15mb: "நீங்கள் பதிவேற்றலாம் அதிகபட்ச அளவு வரம்பு 15MB",

    pastMeeting_feedback: "பின்னூட்டம்",
    pastMeeting_comments: "கருத்துரைகள்",

    microsoft_webplugin: "மைக்ரோசாப்ட் அவுட்லுக் வலை செருகுநிரல்",
    microsoft_installable: "மைக்ரோசாப்ட் அவுட்லுக் நிறுவக்கூடிய செருகுநிரல்",
    outlook_installable: "அவுட்லுக் நிறுவக்கூடியது",
    customization_installer: "தனிப்பயனாக்குதல் நிறுவியை எவ்வாறு அணுகுவது",
    plugin_step1: "படி 1: கோப்பைப் பதிவிறக்க இணைப்பைக் கிளிக் செய்க",
    click_link_download: "கோப்பைப் பதிவிறக்குவதற்கான இணைப்பைக் கிளிக் செய்க",
    first_click_link: "முதலில் கீழேயுள்ள இணைப்பைக் கிளிக் செய்க",
    to_download_file:
      "உங்கள் கணினியில் கோப்பை பதிவிறக்க. நிறுவலைத் தொடங்க பதிவிறக்கிய கோப்பைத் திறந்து கிளிக் செய்க",
    install_txt: "நிறுவு",
    plugin_step2: "படி 2: தனிப்பயனாக்கம் நிறுவப்பட்டது",
    plugin_step2_para:
      "Once you start installing, wait untill the file gets installed and you get a popup showing successfully Installed and then close.",
    plugin_step3: "படி 3: அவுட்லுக்கைத் திறந்து கூட்டங்களுக்குச் செல்லுங்கள்",
    plugin_step3_para:
      "நிறுவிய பின், மைக்ரோசாஃப்ட் அவுட்லுக்கைத் திறந்து அமர்வுக்குச் செல்லவும்.",
    plugin_step3_para1: "புதிய மின்னஞ்சல் > அமர்வுகளுக்குச் செல்லவும்",
    plugin_step4: "படி 4: அமர்வைத் திறக்கவும்",
    plugin_step4_para:
      "அமர்வுகள் சாளரம் திறந்தவுடன் மேலே உள்ள தாவல்களின் பட்டியலில் நகர்த்தவும், பின்னர் நீங்கள் ஒரு தாவலைக் கிளிக் செய்வதைத் தொடரலாம்.",
    plugin_step4_para1: "மக்கள் இணைப்பு",
    plugin_step5: "படி 5: அட்டவணை மாநாடு",
    plugin_step5_para: "பீப்பிள்லிங்கின் கீழ் உங்களுக்கு ஒரு துணை தாவல் உள்ளது",
    plugin_step5_para1: "அட்டவணை மாநாடு.",
    plugin_step5_para2:
      "அதைக் கிளிக் செய்து, சாளரத்தின் வலது பக்கத்தில் அட்டவணை விருப்பங்களைக் காணலாம். இங்கே நீங்கள் inVC அட்டவணைகளை நிர்வகிக்கலாம்.",
    plugin_step6: "படி 6: அட்டவணைகளை நிர்வகிக்கவும் அல்லது தனிப்பயனாக்கவும்",
    plugin_step6_para:
      "இங்கே நீங்கள் அறைகள், நேரங்களின் பட்டியல் மூலம் அட்டவணைகளை நிர்வகிக்கலாம் அல்லது தனிப்பயனாக்கலாம் மற்றும் இங்கிருந்து ஒரு புதிய அட்டவணையை உருவாக்கலாம், இது உங்களை உலாவிக்கு திருப்பி விடுகிறது மற்றும் கண்ணோட்டத்திற்கு திரும்பும்.",
    plugin_step6_para1:
      "அட்டவணையில் நீங்கள் சரியாகிவிட்டால், நீங்கள் கிளிக் செய்யலாம்",
    plugin_step6_para2: "இணைப்பைப் பெறுங்கள்",
    plugin_step7: "இணைப்பு உருவாக்கப்பட்டது",
    plugin_step7_para:
      "அஞ்சலில் உருவாக்கப்பட்ட மற்றும் இயற்றப்பட்ட இணைப்பை இங்கே பெறுகிறது, இது ஆன்லைனில் பகிர்வதற்கு நீங்கள் பயன்படுத்தலாம் அல்லது மேலும் தொடரலாம்.",

    instavc_schedulemeeting_namesplchar:
      "No special characters allowed except @ # $ % ^ & * _ - ?",

    sessions: "அமர்வுகள்",
    schedule_session: "அட்டவணை அமர்வு",
    join_session: "அமர்வில் சேரவும்",
    no_of_sessions_attended_by_teacher:
      "ஆசிரியர்கள் கலந்து கொண்ட அமர்வுகளின் எண்ணிக்கை",
    no_of_sessions_attended_by_student:
      "மாணவர்கள் கலந்து கொண்ட அமர்வுகளின் எண்ணிக்கை",
    teacher_attendance: "ஆசிரியர் வருகை",
    students_attendance: "மாணவர்கள் வருகை",
    virtual_classroom:
      "இணையற்ற அனுபவத்துடன் ஆன்லைன் மெய்நிகர் வகுப்பறை இயங்குதளம்",
    today_sessions: "இன்றைய அமர்வுகள்",
    no_sessions: "அமர்வுகள் இல்லை...",
    session_quote:
      "அமர்வு கடவுச்சொல் உருவாக்கத்தை இயக்குதல் அல்லது டைனமிக் மீட்டிங் ஐடியை இயக்குதல், அடிப்படை மற்றும் மேம்பட்ட சந்திப்பு அம்சங்களுடன் புதிய அமர்வைத் திட்டமிடவும்.",
    session_title: "அமர்வு தலைப்பு",
    create_session_name: "அமர்வு பெயரை உருவாக்கவும்",
    session_password: "அமர்வு கடவுச்சொல்",
    meeting_password: "அமர்வு கடவுச்சொல்லை உருவாக்கவும்",
    selectClass: "வகுப்பைத் தேர்ந்தெடுக்கவும்",
    selectSubject: "பாடத்தைத் தேர்ந்தெடுக்கவும்",
    select_time: "நேரத்தைத் தேர்ந்தெடுக்கவும்",
    select_meeting_date_time: "அமர்வு தேதி & நேரத்தைத் தேர்ந்தெடுக்கவும்",
    select_slot: "ஸ்லாட்டைத் தேர்ந்தெடுக்கவும்",
    select_numberof_participant_seats:
      "பங்கேற்பாளர் இருக்கைகளின் எண்ணிக்கையைத் தேர்ந்தெடுக்கவும்",
    advanced_options: "மேம்பட்ட விருப்பங்கள்",
    custom_registration_url: "தனிப்பயன் பதிவு URL",
    custom_feedback_url: "தனிப்பயன் கருத்து URL",
    allow_guest_control: "விருந்தினர்களைக் கட்டுப்படுத்த அனுமதிக்கவும்",
    meeting_details: "அமர்வு விவரங்கள்",
    meeting_title: "அமர்வு தலைப்பு",
    meeting_type: "அமர்வு வகை",
    seats: "இருக்கைகள்",
    meeting_Password: "அமர்வு கடவுச்சொல்",
    meeting_only_url: "அமர்வு மட்டும் URL:",
    join_meeting_quote: "பங்கேற்பாளர்களுடன் அல்லது அழைக்காமல் அமர்வில் சேரவும்",
    copy_invitation: "அழைப்பிதழை நகலெடுக்கவும்",
    invite_users_list: "அழை - பயனர்கள் பட்டியல்",
    update_meeting: "அமர்வை புதுப்பிக்கவும்",
    custom: "தனிப்பயன்",
    frequency: "அதிர்வெண்",
    occurences_end: "நிகழ்வு முடிவடைகிறது",
    occurences: "நிகழ்வுகள்",
    hr: "மணி",
    every_day: "தினமும்",
    hours: "மணி",
    hour: "மணி",
    errorTxt_slots:
      "நீங்கள் வழக்கமான நேரத்தை நிரப்ப வேண்டும் - மணிநேரம் அல்லது நிமிடங்கள்",
    participantSeats: "பங்கேற்பாளர் இருக்கைகள்",
    participant_seat: "பங்கேற்பாளர் இருக்கை",
    subjects: "பாடங்கள்",
    visible: "தெரியும்",
    hidden: "மறைக்கப்பட்டது",
    create_topic: "தலைப்பை உருவாக்கவும்",
    edit_topic: "தலைப்பைத் திருத்து",
    topicName: "தலைப்பு பெயர்",
    topicDescripiton: "தலைப்பு விளக்கம்",
    public: "பொது",
    classDescription: "வகுப்பு விளக்கம்",
    editNewClass: "புதிய வகுப்பைத் திருத்தவும்",
    topics: "தலைப்புகள்",
    topicView: "தலைப்பு பார்வை",
    no_of_sessions_conducted: "நடத்தப்பட்ட அமர்வுகளின் எண்ணிக்கை",
    no_of_students_attended_session:
      "உங்கள் அமர்வுகளில் கலந்து கொண்ட மாணவர்களின் எண்ணிக்கை",
    yourAssignments: "உங்கள் பணிகள்",
    attendance: "வருகை",
    recent_topics: "சமீபத்திய தலைப்புகள்",
    no_subjects: "இதுவரை பாடங்கள் எதுவும் உருவாக்கப்படவில்லை!",
    no_subjects_create:
      "மேலே உள்ள விஷயத்தை உருவாக்கு பொத்தானைக் கிளிக் செய்வதன் மூலம் புதிய விஷயத்தை உருவாக்கவும்",
    no_topics: "இதுவரை தலைப்புகள் எதுவும் உருவாக்கப்படவில்லை!",
    no_topics_create:
      "மேலே உள்ள தலைப்பை உருவாக்கு பொத்தானைக் கிளிக் செய்வதன் மூலம் ஒரு தலைப்பை உருவாக்கவும்",
    assgnlist_noassignments: "இதுவரை பணிகள் எதுவும் ஒதுக்கப்படவில்லை!",
    assgnlist_assign_new_assign:
      "மேலே உள்ள Assign Assignment பட்டனைக் கிளிக் செய்ய புதிய Assignment ஐ ஒதுக்கவும்",
    start_date_time: "தொடக்க தேதி & நேரம்",
    end_date_time: "முடிவு தேதி & நேரம்",
    join_conference_quote:
      "அமர்வில் சேர, கீழே உள்ள உள்ளீட்டு பெட்டியில் அமர்வு ஐடியை வழங்கவும்",
    edit_student: "மாணவர் திருத்தவும்",
    editTeacher: "ஆசிரியர் திருத்தவும்",
    subject_name: "பொருள் பெயர்",
    subject_description: "பொருள் விளக்கம்",
    select_type: "வகையைத் தேர்ந்தெடுக்கவும்",
    others: "மற்றவைகள்",
    Institute_name: "நிறுவனத்தின் பெயர்",
    first_name_contact: "தொடர்பின் முதல் பெயர்",
    last_name_contact: "தொடர்பின் கடைசி பெயர்",
    institute_type: "நிறுவன வகை",
    institute_name: "நிறுவனத்தின் பெயர்",
    contact_number: "தொடர்பு எண்",
    signup_as_institute: "நிறுவனமாக பதிவு செய்யவும்",
    signup_as_student: "மாணவராக பதிவு செய்யவும்",
    state: "நிலை",
    city: "நகரம்",
    institute_name_error:
      "நிறுவனத்தின் பெயர் எழுத்துகளாக மட்டுமே இருக்க வேண்டும்",
    institute_type_error: "நிறுவன வகை தேர்ந்தெடுக்கப்பட வேண்டும்",
    address_error: "முகவரி சிறப்பு எழுத்துக்களை ஏற்கலாம்",
    student: "மாணவர்",
    institute: "நிறுவனம்",
    signUpas: "என பதிவு செய்யவும்",
    submitted: "சமர்ப்பிக்கப்பட்டது",
    notSubmitted: "சமர்ப்பிக்கவில்லை",
    review: "விமர்சனம்",
    inReview: "மதிப்பாய்வில்",
    questionTitle: "கேள்வி தலைப்பு",
    questionDescription: "கேள்வி விளக்கம்",
    questionnaireTitle: "கேள்வி தலைப்பு",
    started: "தொடங்கப்பட்டது",
    testName: "சோதனை பெயர்",
    timeTaken: "எடுக்கப்பட்ட நேரம்",
    showAnswers: "பதில்களைக் காட்டு",
    downloadCertificate: "சான்றிதழைப் பதிவிறக்கவும்",
    startTime: "ஆரம்பிக்கும் நேரம்",
    endTime: "முடிவு நேரம்",
    assignmentTitle: "பணியின் தலைப்பு",
    editor: "ஆசிரியர்",
    save_submit: "சேமி & சமர்ப்பிக்கவும்",
    assigned_students: "ஒதுக்கப்பட்ட மாணவர்கள்",
    total_marks: "மொத்த மதிப்பெண்கள்",
    not_yet_Submitted: "இன்னும் சமர்ப்பிக்கப்படவில்லை",
    completed: "நிறைவு",
    due_date: "இறுதி தேதி",
    marks_obtained: "பெற்ற மதிப்பெண்கள்",
    assign_marks: "மதிப்பெண்களை ஒதுக்குங்கள்",
    home_inclass_copyright: "© 2022 InstaVC Inc. All Rights Reserved.",
    // "© 2022 InstaVC Inc. எல்லாம் சரி | சக்தியூட்டப்பட்டது Peoplelink Unified Communications Pvt. லிமிடெட்",
    back_to_classes: "வகுப்புகளுக்குத் திரும்பு",
    className: "வகுப்பின் பெயர்",
    attendanceReports: "வருகை அறிக்கைகள்",
    present: "தற்போது",
    absent: "இல்லாதது",
    ratio: "விகிதம்",
    sessionsAttended: "அமர்வுகள் கலந்துகொண்டன",
    totalSessions: "மொத்த அமர்வுகள்",
    filters: "வடிப்பான்கள்",
    teacher: "ஆசிரியர்",
    userType: "பயனர் வகை",
    class: "வர்க்கம்",
    clear: "தெளிவு",
    sessionsConducted: "அமர்வுகள் நடத்தப்பட்டன",
    Topic: "தலைப்பு",
    uploadMediaSizeLimit: "அளவு வரம்பு 15MB வரை.",
    assessments: "மதிப்பீடுகள்",
    assessment: "மதிப்பீடு",
    totalStudents: "மொத்த மாணவர்கள்",
    totalAssignments: "மொத்த பணிகள்",
    assignmentsCompleted: "பணிகள் முடிக்கப்பட்டன",
    assignmentsPending: "பணிகள் நிலுவையில் உள்ளன",
    score: "மதிப்பெண்",
    submittedDate: "சமர்ப்பிக்கப்பட்ட தேதி",
    dueDateOfSubmission: "சமர்ப்பிக்க வேண்டிய தேதி",
    clearSelections: "தேர்வுகளை அழிக்கவும்",
    noschedule_meetings: "உங்களுக்கு வரவிருக்கும் அமர்வுகள் எதுவும் இல்லை.",
    nopast_meetings: "உங்களிடம் கடந்த அமர்வுகள் எதுவும் இல்லை",
    id: "ஐடி",
    export: "ஏற்றுமதி",
    import: "இறக்குமதி",
    sample_excel: "எக்செல் மாதிரி",
    subject_access: "பொருள் அணுகல்",
    submitted_date_time: "சமர்ப்பிக்கப்பட்ட தேதி/நேரம்",
    passed: "தேர்ச்சி பெற்றார்",
    failed: "தோல்வி",
    average_score: "சராசரி மதிப்பெண்",
    total_reviewed: "மொத்தம் மதிப்பாய்வு செய்யப்பட்டது",
    pending_review: "மதிப்பாய்வு நிலுவையில் உள்ளது",
    total_students_finished: "மொத்த மாணவர்கள் முடிந்தது",
    total_students_passed: "மொத்த மாணவர்கள் தேர்ச்சி பெற்றனர்",
    total_students_failed: "மொத்த மாணவர்கள் தோல்வியடைந்தனர்",
    total_students_absent: "மொத்தமாக வராத மாணவர்கள்",
    time_exceed: "நேர வரம்பு மீறப்பட்டது",
    time_exceed_assgn_msg:
      "இந்தப் பணியைச் சமர்ப்பிப்பதற்கான காலக்கெடு மீறப்பட்டுள்ளது",
    time_exceed_quess_msg:
      "இந்தக் கேள்வித்தாளைச் சமர்ப்பிப்பதற்கான காலக்கெடு மீறப்பட்டுள்ளது",
    class_code: "வகுப்பு பெயர்",
    updateQuestion: "கேள்வியைப் புதுப்பிக்கவும்",
    enroll: "பதிவு செய்யுங்கள்",
    create_new_passwd: "புதிய கடவுச்சொல்லை உருவாக்கவும்",
    actions: "செயல்கள்",
    please_enter_topic_name: "தலைப்பின் பெயரை உள்ளிடவும்",
    please_enter_topic_description: "தலைப்பு விளக்கத்தை உள்ளிடவும்",
    plz_select_questionary: "கேள்வியைத் தேர்ந்தெடுக்கவும்.",
    plz_select_duration_checkbox:
      "தயவுசெய்து கால தேர்வுப்பெட்டியைத் தேர்ந்தெடுக்கவும்.",
    Plz_select_assignment: "பணியைத் தேர்ந்தெடுக்கவும்.",
    plz_select_valid_date_time: "சரியான தேதி நேரத்தைத் தேர்ந்தெடுக்கவும்.",
    Plz_enter_valid_marks: "சரியான மதிப்பெண்களை உள்ளிடவும்.",
    Plz_enter_subject_title: "தயவுசெய்து பொருள் தலைப்பை உள்ளிடவும்.",
    class_code:"வகுப்பு குறியீடு",
    Plz_enter_class_name: "வகுப்பின் பெயரை உள்ளிடவும்",
    Plz_enter_subject_description: "தயவுசெய்து பொருள் விளக்கத்தை உள்ளிடவும்.",
    Plz_enter_subject_type: "தயவுசெய்து பொருள் வகையை உள்ளிடவும்.",
    Plz_enter_subject_code: "பொருள் குறியீட்டை உள்ளிடவும்.",
    Plz_enter_valid_subject_code: "சரியான பொருள் குறியீட்டை உள்ளிடவும்",
    Plz_enter_class_code: "வகுப்புக் குறியீட்டை உள்ளிடவும்.",
    Plz_enter_valid_class_code: "சரியான வகுப்புக் குறியீட்டை உள்ளிடவும்",
    plz_enter: "தயவுசெய்து உள்ளீடவும்",
    Plz_enter_valid: "செல்லுபடியாகும் என உள்ளிடவும்",
    Plz_enter_title: "தயவுசெய்து தலைப்பை உள்ளிடவும்.",
    Plz_enter_description: "தயவுசெய்து விளக்கத்தை உள்ளிடவும்.",
    Plz_select_class: "வகுப்பைத் தேர்ந்தெடுக்கவும்",
    Plz_select_subject: "ஒரு பாடத்தைத் தேர்ந்தெடுக்கவும்.",
    something_went_wrong: "ஏதோ தவறு நடைபெற்றிருக்கிறது.",
    data_is_not_selected: "தரவு தேர்ந்தெடுக்கப்படவில்லை",
    data_added_successfully: "தரவு வெற்றிகரமாக சேர்க்கப்பட்டது",
    plz_enter_question: "தயவுசெய்து கேள்வியை உள்ளிடவும்",
    plz_enter_marks: "மதிப்பெண்களை உள்ளிடவும்",
    Plz_select_type: "தயவுசெய்து வகையைத் தேர்ந்தெடுக்கவும்",
    opt_should_have_minimum: "விருப்பங்களில் குறைந்தபட்சம் 2 இருக்க வேண்டும்",
    opt_should_not_empty: "விருப்பங்கள் காலியாக இருக்கக்கூடாது",
    opt_should_not_duplicate: "விருப்பங்கள் நகலெடுக்கக்கூடாது",
    plz_select_the_answer: "தயவுசெய்து பதிலைத் தேர்ந்தெடுக்கவும்",
    question_updated_successfully: "கேள்வி வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    question_created_successfully: "கேள்வி வெற்றிகரமாக உருவாக்கப்பட்டது",
    marks_less_than_total_marks:
      "உள்ளிடப்பட்ட மதிப்பெண்கள் மொத்த மதிப்பெண்களை விட குறைவாக இருக்க வேண்டும்",
    marks_not_negative: "மதிப்பெண்கள் எதிர்மறையாக இருக்கக்கூடாது",
    assgn_successfully_verifed:
      "பணிச் சேமிப்பு வெற்றிகரமாகச் சரிபார்க்கப்பட்டது.",
    assgn_save_submited_succes:
      "பணி சேமித்து வெற்றிகரமாகச் சமர்ப்பிக்கப்பட்டது",
    assgn_save_succes: "பணியைச் சேமிக்கவும்",
    Plz_enter_valid_content: "சரியான உள்ளடக்கத்தை உள்ளிடவும்.",
    Assgn_updated_success: "பணி வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    Assgn_created_success: "பணி வெற்றிகரமாக உருவாக்கப்பட்டது",
    Assgn_assigned_success: "பணி வெற்றிகரமாக ஒதுக்கப்பட்டது",
    Assgn_disabled_success: "பணி முடக்கப்பட்டது.",
    Assgn_enabled_success: "பணி வெற்றிகரமாக இயக்கப்பட்டது.",
    Assgn_deleted_success: "பணி வெற்றிகரமாக நீக்கப்பட்டது.",
    Quest_creat_success: "கேள்வித்தாள் வெற்றிகரமாக உருவாக்கப்பட்டது",
    Quest_updated_success: "கேள்வித்தாள் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    Poll_created_success: "கருத்துக்கணிப்பு வெற்றிகரமாக உருவாக்கப்பட்டது",
    Poll_updated_success: "வாக்கெடுப்பு வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    opt_minimum:
      "விருப்பங்கள் குறைந்தபட்சம் 2 விருப்பங்களைக் கொண்டிருக்க வேண்டும்",
    Poll_deleted_success: "வாக்கெடுப்பு வெற்றிகரமாக நீக்கப்பட்டது",
    Poll_enabled_success: "வாக்குப்பதிவு வெற்றிகரமாக இயக்கப்பட்டது",
    Poll_disabled_success: "வாக்குப்பதிவு வெற்றிகரமாக முடக்கப்பட்டது",
    Quest_deleted_success: "கேள்வி வெற்றிகரமாக நீக்கப்பட்டது",
    Invit_send_success: "அழைப்பிதழ் வெற்றிகரமாக அனுப்பப்பட்டது",
    teacher_deleted_success: "ஆசிரியர் வெற்றிகரமாக நீக்கப்பட்டார்",
    error_some_thing_went_wrong: "பிழை, ஏதோ தவறாகிவிட்டது.",
    user_updated_success: "பயனர் நிலை வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    teacher_updated_success: "ஆசிரியர் வெற்றிகரமாக புதுப்பிக்கப்பட்டார்",
    student_remove_success: "மாணவர் அகற்றப்பட்டார்",
    teachers_created_success: "ஆசிரியர்கள் வெற்றிகரமாக உருவாக்கினர்",
    error_occured_try_again: "பிழை ஏற்பட்டது, மீண்டும் முயற்சிக்கவும்!",
    please_select_less:
      "தயவு செய்து 15எம்பி கோப்பு அளவு குறைவாக உள்ளதைத் தேர்ந்தெடுக்கவும்.",
    submit_success: "வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது",
    grad_updat_success: "கிரேடுகள் மேம்படுத்தல்கள் வெற்றிகரமாக",
    Quest_delet_succes: "கேள்வித்தாள் வெற்றிகரமாக நீக்கப்பட்டது",
    Quest_disab_succes: "கேள்வித்தாள் வெற்றிகரமாக முடக்கப்பட்டது",
    Quest_enabled_succes: "கேள்வித்தாள் வெற்றிகரமாக இயக்கப்பட்டது",
    student_add_succes: "மாணவர் சேர்க்கப்பட்டது",
    plz_select_atleast_std: "குறைந்தது 1 மாணவரையாவது தேர்ந்தெடுக்கவும்",
    fail_add_some_student: "சில மாணவர்களைச் சேர்க்க முடியவில்லை",
    std_add_succes: "மாணவர்கள் வெற்றிகரமாக சேர்க்கப்பட்டனர்",
    sub_updat_succes: "தலைப்பு வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    sub_creat_succes: "தலைப்பு வெற்றிகரமாக உருவாக்கப்பட்டது",
    sub_dlt_succes: "தலைப்பு வெற்றிகரமாக நீக்கப்பட்டது",
    sub_enabl_succes: "தலைப்பு வெற்றிகரமாக இயக்கப்பட்டது",
    sub_disab_succes: "தலைப்பு வெற்றிகரமாக முடக்கப்பட்டது",
    tchr_add_success: "ஆசிரியர் வெற்றிகரமாக சேர்க்கப்பட்டார்",
    plz_slc_atlst_tchr: "குறைந்தது 1 ஆசிரியரையாவது தேர்ந்தெடுக்கவும்",
    tchr_remo_success: "ஆசிரியர் வெற்றிகரமாக அகற்றினார்",
    plz_etr_valid_duration: "சரியான கால அளவை உள்ளிடவும்",
    topic_updat_success: "தலைப்பு வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    class_dlt_success: "வகுப்பு வெற்றிகரமாக நீக்கப்பட்டது",
    class_upt_succes: "வகுப்பு வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
    class_creat_succes: "வகுப்பு வெற்றிகரமாக உருவாக்கப்பட்டது",
    plz_select_quest: "கேள்வித்தாளைத் தேர்ந்தெடுக்கவும்",
    first_add_data: "தரவைச் சேர்க்க பிளஸ் பொத்தானைக் கிளிக் செய்யவும்",
    certfct_generat_success: "சான்றிதழ் வெற்றிகரமாக உருவாக்கப்பட்டது",
    plz_select_min_seats: "குறைந்தபட்சம் 2 இருக்கைகளைத் தேர்ந்தெடுக்கவும்",
    plz_enter_mtng_name: "அமர்வு பெயரை உள்ளிடவும்",
    fail_to_updt_mtng_try_again:
      "அமர்வைப் புதுப்பிக்க முடியவில்லை! மீண்டும் முயற்சி செய்",
    fail_update_scdle: "அட்டவணையைப் புதுப்பிக்க முடியவில்லை",
    std_delet_success: "மாணவர் வெற்றிகரமாக நீக்கப்பட்டார்",
    std_updat_succes: "மாணவர் வெற்றிகரமாக புதுப்பிக்கப்பட்டார்",
    std_creat_succes: "மாணவர் வெற்றிகரமாக உருவாக்கப்பட்டது",
    fail_create_some_std: "சில மாணவர்களை உருவாக்க முடியவில்லை",
    std_creat_success: "மாணவர்கள் வெற்றிகரமாக உருவாக்கினர்",
    tchr_creat_succes: "ஆசிரியர் வெற்றிகரமாக உருவாக்கினார்",
    fail_crt_some_user: "சில பயனர்களை உருவாக்க முடியவில்லை",
    fail_create_mtg_try_again:
      "அமர்வை உருவாக்க முடியவில்லை! மீண்டும் முயற்சி செய்",
    fail_create_schedu: "அட்டவணையை உருவாக்க முடியவில்லை",
    plz_enter_metng_title: "அமர்வு தலைப்பை உள்ளிடவும்",
    invalid_phn_nmb: "தவறான தொலைபேசி எண்",
    plz_enter_phn_num: "தொலைபேசி எண்ணை உள்ளிடவும்",
    topic_crt_succes: "தலைப்பு வெற்றிகரமாக உருவாக்கப்பட்டது",
    topic_enabled_succes: "தலைப்பு வெற்றிகரமாக இயக்கப்பட்டது",
    topic_disabl_success: "தலைப்பு வெற்றிகரமாக முடக்கப்பட்டது",
    topic_delet_success: "தலைப்பு வெற்றிகரமாக நீக்கப்பட்டது",
    Media_delet_success: "மீடியா வெற்றிகரமாக நீக்கப்பட்டது",
    plz_enter_title_upload_doc:
      "முதலில் தலைப்பை உள்ளிட்டு ஆவணத்தைப் பதிவேற்றவும்",
    doc_add_succes: "ஆவணம் வெற்றிகரமாக சேர்க்கப்பட்டது",
    plz_fst_ent_title_and_media:
      "முதலில் தலைப்பை உள்ளிட்டு மீடியா கோப்பை உள்ளிடவும்",
    media_add_success: "மீடியா வெற்றிகரமாக சேர்க்கப்பட்டது",
    plz_first_title_and_URL:
      "முதலில் தலைப்பை உள்ளிட்டு மீடியா URL ஐ உள்ளிடவும்",
    plz_etr_valid_url: "சரியான url ஐ உள்ளிடவும்",
    generate: "உருவாக்கு",
    issue_cert: "சான்றிதழ் வழங்கவும்",
    total_score: "மொத்த மதிப்பெண்",
    created_by: "உருவாக்கியது",
    certificate: "சான்றிதழ்",
    not_completed: "முழுமையடையவில்லை",
    view_cert: "சான்றிதழைப் பார்க்கவும்",
    issue_certificate: "சான்றிதழ் வழங்கவும்",
    title: "தலைப்பு",
    issue_date: "வழங்கப்பட்ட தேதி",
    note_edit_and_delete_txt:
      "குறிப்பு: திருத்து மற்றும் நீக்கு பொத்தான்கள் சோதனைக்கு 10 நிமிடங்களுக்கு முன் மறைக்கப்படும்",
    verify_email_msg:
      "உறுதிப்படுத்தல் குறியீட்டிற்கு உங்கள் மின்னஞ்சலைச் சரிபார்க்கவும்.",
    start_time_greater_currnt_time:
      "தொடக்க நேரம் தற்போதைய நேரத்திற்குப் பிறகு 10 நிமிடங்களுக்கு மேல் இருக்க வேண்டும்",

    copi_to_clipboard: "கிளிப்போர்டுக்கு நகலெடுக்கப்பட்டது!",
    host_msg: "தொகுப்பாளர்",
    date_time: "தேதி நேரம்",
    invities: "அழைப்பாளர்கள்",
    no_chat_history_avai: "அரட்டை வரலாறு எதுவும் இல்லை.",
    no_feedbacks_avai: "கருத்துகள் எதுவும் இல்லை",
    no_invities_list_avai: "அழைக்கப்பட்டவர்கள் பட்டியல் இல்லை",
    no_conference_note_avai: "மாநாட்டு குறிப்புகள் எதுவும் கிடைக்கவில்லை.",
    total_notes: "மொத்த குறிப்புகள் ( 15 )",
    view_log_history: "பதிவு வரலாற்றைக் காண்க",
    total_duration: "மொத்த காலம்:",
    min: "குறைந்தபட்சம்",
    total_time_spent: "செலவழித்த மொத்த நேரம்:",
    entry: "நுழைவு",
    exit: "வெளியேறு",
    time_spent: "செலவிட்ட நேரம்",
    no_conference_recording_avai: "மாநாட்டு பதிவுகள் எதுவும் இல்லை",
    no_meetings: "அமர்வுகள் இல்லை!",
    this_brow_dont_support_video_tag:
      "இந்த உலாவி வீடியோ குறிச்சொல்லை ஆதரிக்காது.",
    no_participants_list_avai: "பங்கேற்பாளர்கள் பட்டியல் இல்லை.",
    total_number_session: "அமர்வுகளின் மொத்த எண்ணிக்கை",
    start_date: "தொடக்க தேதி:",
    join_mtg_provide_id_below_input:
      "அமர்வில் சேர, கீழே உள்ள உள்ளீட்டு பெட்டியில் அமர்வு ஐடியை வழங்கவும்.",
    You_enter_inva_meet: "தவறான அமர்வு ஐடியை உள்ளிட்டுள்ளீர்கள்.",
    no_ques_creat_yet: "அட்டவணையைப் புதுப்பிக்க முடியவில்லை",
    creat_quest_click_creat:
      "கேள்வித்தாளை உருவாக்கு பொத்தானைக் கிளிக் செய்வதன் மூலம் கேள்வித்தாளை உருவாக்கவும்.",
    only_invit_can_join: "அழைக்கப்பட்டவர்கள் மட்டுமே சேர முடியும்",
    invc_login_mandato: "inVC உள்நுழைவு கட்டாயம்",
    training_mode: "பயிற்சி முறை",
    audio_only_mode: "ஆடியோ பயன்முறை மட்டும்",
    mute_parti_upon_entry: "நுழைந்தவுடன் பங்கேற்பாளர்களை முடக்கு",
    join_before_host: "புரவலன் முன் சேரவும்",
    enable_breakout_session: "பிரேக்அவுட் அமர்வுகளை இயக்கவும்",
    anonymous_access: "அநாமதேய அணுகல்",
    send_invite: "அழைப்பை அனுப்பவும்",
    add_part_email_address_mobil_msg:
      "பங்கேற்பாளர்களின் மின்னஞ்சல் முகவரி அல்லது மொபைல் எண்ணைச் சேர்ப்பதன் மூலம், பல உள்ளீடுகளுக்கு enter ஐ அழுத்தவும்.",
    add_email_mobile: "மின்னஞ்சல் / மொபைல் எண்ணைச் சேர்க்கவும்",
    make_sure_the_msg:
      "1 - மொபைல் எண் நாட்டின் குறியீட்டுடன் இருக்க வேண்டும் என்பதை உறுதிப்படுத்தவும் (எ.கா: +91-99XXXXXXXX)",
    email_id_note:
      "2 - மின்னஞ்சல் ஐடி சிறிய எழுத்தாக இருக்க வேண்டும் (எ.கா: username@xxx.com)",
    meet_before_schedul_time:
      "திட்டமிட்ட நேரத்திற்கு முன் இந்த அமர்வில் சேர முடியாது.",
    go_to_dashboard: "டாஷ்போர்டுக்குச் செல்லவும்",
    if_you_are_host_msg:
      "நீங்கள் ஒரு புரவலராக இருந்தால், உங்கள் டாஷ்போர்டிலிருந்து மற்றொரு விரைவு அமர்வைத் தொடங்கவும்",
    this_meet_expir_on: "இந்த அமர்வு காலாவதியானது",
    this_meet_link__expired: "இந்த அமர்வு இணைப்பு காலாவதியானது",
    this_meet_schedul_for: "இந்த அமர்வு திட்டமிடப்பட்டுள்ளது",
    meet_min_before_schedule_time:
      "திட்டமிடப்பட்ட நேரத்திற்கு 5 நிமிடங்களுக்கு முன்னதாக நீங்கள் இந்த அமர்வில் சேரலாம்.",
    this_assign_start_yet: "இந்தப் பணிக்கான நேரம் இன்னும் தொடங்கப்படவில்லை...",
    time_not_yet_start: "நேரம் இன்னும் தொடங்கவில்லை",
    field_once_generat_cannot_edit:
      "தயவு செய்து அனைத்து புலங்களையும் ஒருமுறை உருவாக்கினால் திருத்த முடியாது",
    certificate_title: "சான்றிதழ் தலைப்பு",
    invalid_meet_code: "தவறான அமர்வுக் குறியீடு",
    meeting_id_below_input_box:
      "அமர்வில் சேர மற்றும் திரையைப் பகிர, கீழே உள்ள உள்ளீட்டுப் பெட்டியில் அமர்வு ஐடியை வழங்கவும்.",
    meeting_configuration: "அமர்வு கட்டமைப்பு",
    room_participant_limit_exceed: "அறையில் பங்கேற்பாளர் வரம்பு மீறப்பட்டது.",
    only_audio_call_auto_mute_enabl:
      "ஆடியோ அழைப்பு & தானாக முடக்குதல் மட்டுமே இயக்கப்பட்டது",
    you_audio_video_mute: "உங்கள் ஆடியோ & வீடியோ ஒலியடக்கப்பட்டது!",
    only_audio_call: "ஆடியோ அழைப்பு மட்டுமே",
    your_video_mute: "உங்கள் வீடியோ முடக்கப்பட்டுள்ளது!",
    your_name: "உங்கள் பெயர்",
    ok_you_r_ready: "சரி, நீங்கள் தயார்",
    room_empty_meeting_wait_until_host_join:
      "அறை காலி! அமர்வைத் தொடங்க நீங்கள் உள்நுழையலாம் அல்லது ஹோஸ்ட் சேரும் வரை காத்திருக்கலாம்",
    room_lock_hang_until_somebody_lets:
      "அறை பூட்டப்பட்டுள்ளது - யாராவது உங்களை உள்ளே அனுமதிக்கும் வரை காத்திருங்கள் ...",
    your_audio_is_muted: "உங்கள் ஆடியோ ஒலியடக்கப்பட்டது!",
    view_assignment: "பணியைப் பார்க்கவும்",
    assigned_assignment: "ஒதுக்கப்பட்ட பணி",
    attempte_assignment_written_anything:
      "நீங்கள் வேலையை முயற்சி செய்துள்ளீர்கள் ஆனால் அதில் எதையும் எழுதவில்லை.",
    Marks_not_alloted: "மதிப்பெண்கள் அனுமதிக்கப்படவில்லை",
    view_questionnaire: "வினாத்தாளைப் பார்க்கவும்",
    assign_questionnaire_list: "கேள்வித்தாள் பட்டியலை ஒதுக்கவும்",
    assign_assignment: "பணிகள் பட்டியலை ஒதுக்கவும்",
    type: "வகை",
    class_description: "வகுப்பு விளக்கம்",
    password_updated: "கடவுச்சொல் புதுப்பிக்கப்பட்டது!",
    numberOfLicense: "உரிமம் எண்",
    topic: "தலைப்பு",
    del_poll: "வாக்கெடுப்பு",
    std: "மாணவர்",
    profile: "சுயவிவரம்",
    your_test: "உங்கள் சோதனை",
    unattended_incomplete_Questionaire_txt_msg:
      "சில காரணங்களால் கவனிக்கப்படாமல் அல்லது முழுமையடையாமல் இருந்தது. எனவே மதிப்பெண் அட்டையை உருவாக்க முடியவில்லை",
    Assgnmnt_time_not_started: "பணி நேரம் இன்னும் தொடங்கவில்லை...",
    submitted_cnt: "சமர்ப்பிக்கப்பட்ட உள்ளடக்கம்",
    stud_list: "மாணவர் பட்டியல்",
    test_submitted_successfully: "உங்கள் சோதனை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது",
    score_time_finished_successfully:
      "நேரம் முடிந்ததும் மதிப்பெண் காட்டப்படும்",
    topics_list: "தலைப்புகள் பட்டியல்",
    upload_highResImg: "உயர் தெளிவுத்திறன் கொண்ட படங்களை மட்டும் பதிவேற்றவும்",
    meetingList_upcoming_meetings: "வரவிருக்கும் அமர்வுகள்",
    subject_list: "பொருள் பட்டியல்",
    plz_enter_valid_number_license: "உரிமத்தின் சரியான எண்ணை உள்ளிடவும்",
    no_class_assigned: "வகுப்புகள் எதுவும் ஒதுக்கப்படவில்லை",
    class_list: "வகுப்பு பட்டியல்",
    plz_fill_all_details: "அனைத்து விவரங்களையும் நிரப்பவும்",
    plz_click_upload_media_url:
      "மீடியா url ஐப் பதிவேற்று என்பதைக் கிளிக் செய்யவும்",
    please_enter_msg: "தயவுசெய்து உள்ளீடவும்",
    Media_msg: "ஊடகம்.",
    media_url: "மீடியா URL.",
    title: "தலைப்பு",
    and_msg: "மற்றும்",
    wrong_answer: "தவறான பதில்",
    right_answer: "சரியான விடை",
    User_list: "பயனர்கள் பட்டியல்",
    questionaire_time_not_yet_start:
      "கேள்வித்தாள் நேரம் இன்னும் தொடங்கவில்லை...",
    submitted_list: "சமர்ப்பிக்கப்பட்ட பட்டியல்",
    search_by_name: "பெயர் மூலம் தேடவும்",
    scheduleDate: "அட்டவணை தேதி",
    view_all: "அனைத்தையும் காட்டு",
    view_card: "பார்வை அட்டை",
    confirm_submit: "நீங்கள் நிச்சயமாக வேலையைச் சமர்ப்பிக்க விரும்புகிறீர்களா?",
    confirm_finish: "நீங்கள் நிச்சயமாக சோதனையை முடிக்க விரும்புகிறீர்களா?",
    questionaire: "கேள்வித்தாள்",
    list_of_questns_for_above_questionaire:
      "மேலே உள்ள கேள்வித்தாளுக்கு ஒதுக்கப்பட்ட கேள்விகளின் பட்டியல் கீழே உள்ளது",
    view_all_assignments: "அனைத்து பணிகளையும் காண்க",
    action: "செயல்",
    start_dte: "தொடக்க தேதி",
    subject: "பொருள்",
    digital_file_upload_and_digital_signature:
      "இங்கு பதிவேற்றப்படும் டிஜிட்டல் கோப்புகள் மாணவர்களுக்கு வழங்கப்படும் டிஜிட்டல் சான்றிதழ்களில் தோன்றும்",
    upload_logo: "லோகோவைப் பதிவேற்று",
    upload_signature: "கையொப்பத்தை பதிவேற்றவும்",
    upload_stamp: "முத்திரையைப் பதிவேற்றவும்",
    drag_and_drop_file: "உங்கள் கோப்பை இங்கே இழுத்து விடுங்கள் அல்லது",
    max_file_mb_dimensions: "அதிகபட்ச கோப்பு அளவு 20MB பரிமாணங்கள் ",
    note_assgn_qusnr_text:
      "குறிப்பு *: பணி தொடங்குவதற்கு 10 நிமிடங்களுக்கு முன்பு உங்களால் உங்கள் உள்ளீடுகளைத் திருத்தவோ நீக்கவோ முடியாது",
    note_qusnr_text:
      " குறிப்பு *: கேள்வித்தாள் தொடங்குவதற்கு 10 நிமிடங்களுக்கு முன் உங்கள் உள்ளீடுகளைத் திருத்தவோ நீக்கவோ முடியாது",
    not_attended: "கலந்து கொள்ளவில்லை",
    not_started: "துவங்கவில்லை",
    dont_have_stu_acc: "மாணவர் கணக்கு இல்லை",
    buy_more: "மேலும் வாங்கவும்",
    product: "தயாரிப்பு",
    no_subject_assigned: "பாடங்கள் எதுவும் ஒதுக்கப்படவில்லை",
    logo: "சின்னம்",
    stamp: "முத்திரை",
    signature: "கையெழுத்து",
    uploaded_successfully: "பதிவேற்றம் செய்யப்பட்டது",
    renewal: "புதுப்பித்தல்",
    domain_name: "டொமைன் பெயர்",
    pls_sel_frequency:
      "வாரத்தின் எந்த நாளை நீங்கள் திட்டமிட விரும்புகிறீர்கள் என்பதைத் தேர்ந்தெடுக்கவும்",
    your_test_successfully_submitted:
      "உங்கள் சோதனை வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது",
    score_will_finished: "நேரம் முடிந்ததும் மதிப்பெண் காட்டப்படும்",
    license_expired: "உரிமம் காலாவதியானது ",
    application_longer_accessed_since__license_expired:
      "உங்கள் உரிமம் காலாவதியாகிவிட்டதால், விண்ணப்பத்தை அணுக முடியாது. அணுகலை மீண்டும் செயல்படுத்த,",
    respective_admin_license_renewal:
      "உரிமம் புதுப்பித்தலுக்கு உரிய நிர்வாகியைத் தொடர்பு கொள்ளவும்.",
    okay: "சரி",
    delete_recurring_schedule: "தொடர் அட்டவணையை நீக்கு",
    are_you_sure_delete_recurring_schedule:
      "இந்த தொடர்ச்சியான அட்டவணையை நிச்சயமாக நீக்க விரும்புகிறீர்களா?",
    delete_all_recurring_days_completely:
      "தொடர்ந்து வரும் அனைத்து நாட்களையும் முழுவதுமாக நீக்கவும்.",
    will_eleminate_all_selected:
      "தேர்ந்தெடுக்கப்பட்ட அனைத்து நாட்களையும் அட்டவணையில் இருந்து நீக்கும்",
    remove_only_selected_days: "தேர்ந்தெடுக்கப்பட்ட நாட்களை மட்டும் அகற்றவும்",
    delete_selected_days_schedule:
      "இது அட்டவணையில் இருந்து தேர்ந்தெடுக்கப்பட்ட நாட்களை மட்டும் நீக்கும்",
    recurring_dates: "தொடர் தேதிகள்",
    enter_the_coupon_code: "கூப்பன் குறியீட்டை உள்ளிடவும்",
    coupon_applied: "கூப்பன் பயன்படுத்தப்பட்டது",
    coupon_id: "கூப்பன் ஐடி",
    del_recurring_by_dates:
      "அமர்வின் எந்த நாளை நீக்க விரும்புகிறீர்கள் என்பதைத் தேர்ந்தெடுக்கவும்",
    more_details: "கூடுதல் தகவல்கள்",
    removeStudentUser: "இந்த மாணவனை நிச்சயமாக அகற்ற விரும்புகிறீர்களா?",
    removeTeacherUser: "இந்த ஆசிரியரை நிச்சயமாக அகற்ற விரும்புகிறீர்களா?",
    sure_you_want_to_delete: "நிச்சயமாக, இதை நீக்க விரும்புகிறீர்களா",
    deleting_information_database: "இதை நீக்கினால் தரவுத்தளத்தில் உள்ள அனைத்து தகவல்களும் அழிக்கப்படும்.",
    to_confirm_type: "வகையை உறுதிப்படுத்த",
    name_not_matched: "பெயர் பொருந்தவில்லை.",
    confirm_this_type: "இதை உறுதிப்படுத்த, தட்டச்சு செய்யவும்",
    topic_title: "தலைப்பு தலைப்பு",
    select: "தேர்ந்தெடு",
    plz_enter_integers: "தயவுசெய்து முழு எண் மதிப்புகளை மட்டும் உள்ளிடவும்",
    help_Center:"உதவி மையம்",

  },
};
